const en = {
    common: {
      language: 'Language',
      save: 'Save Settings',
      saving: 'Saving...',
      continue: 'Continue',
      search: 'Search',
      cancel: 'Cancel',
      previous: 'Previous',
      next: 'Next',
      pageOf: 'Page {page} of {total}',
      loading: 'Loading...',
      notAvailable: 'N/A',
      unknown: 'Unknown',
      processing: 'Processing...'
    },
    onboarding: {
      chooseLanguageTitle: 'Choose Your Language',
      chooseLanguageSubtitle: 'Select your preferred language for the game',
      savingLanguage: 'Saving...'
    },
    navbar: {
      searchPlaceholder: 'Search player by name...',
      searchAriaLabel: 'Search',
      searching: 'Searching...',
      noResults: 'No results',
      totalCards: 'Total cards',
      company: 'Company',
      errorSearch: 'Search error',
      signIn: 'Sign In',
      register: 'Register',
      adminPanel: 'Admin Panel',
      rules: 'Rules',
      musicMute: 'Turn off background music',
      musicUnmute: 'Turn on background music'
    },
    rules: {
      mobileTitle: 'DIOS10 Rules',
      mobileDesc: 'On mobile, open the PDF in your browser for the best reading experience.',
      openPdf: 'Open PDF in browser'
    },
    auth: {
      signIn: 'Sign In',
      signingIn: 'Signing In...',
      email: 'Email',
      password: 'Password',
      forgotPassword: 'Forgot Password?',
      noAccount: "Don't have an account?",
      registerNow: 'Register Now',
      fillAllFields: 'Please fill in all fields',
      loginFailed: 'Login failed. Please check your credentials.',
      emailVerified: 'E-mail verified. You can now log in.',
      emailVerifiedInvalid: 'Invalid or expired verification link.',
      createAccount: 'Create Your Account',
      chooseUsername: 'Choose your username',
      username: 'Username',
      confirmPassword: 'Confirm Password',
      referralCode: 'Referral Code (Optional)',
      referralPlaceholder: 'Enter referral code if you have one',
      confirmPasswordPlaceholder: 'Confirm your password',
      minimumCharacters: 'Minimum 6 characters',
      creatingAccount: 'Creating Account...',
      startJourney: 'Start Your Journey',
      alreadyAccount: 'Already have an account?',
      terms: 'By registering, you agree to our Terms of Service',
      passwordMismatch: 'Passwords do not match',
      passwordShort: 'Password must be at least 6 characters',
      registrationPending: 'Registration is pending. Please verify your email using the link we sent you. You cannot log in until your email is verified.',
      registrationSuccess: 'Registration complete. You can now log in.',
      registrationFailed: 'Registration failed. Please try again.',
      forgotTitle: 'Forgot Password?',
      forgotSubtitle: "Enter your email address and we'll send you a link to reset your password.",
      sendResetLink: 'Send Reset Link',
      sending: 'Sending...',
      resetToken: 'Reset Token',
      setNewPassword: 'Set New Password',
      newPassword: 'New Password',
      confirmNewPassword: 'Confirm New Password',
      resetPassword: 'Reset Password',
      resetting: 'Resetting...',
      resetTokenRequired: 'Reset token is required',
      resetPasswordShort: 'Password must be at least 8 characters long',
      resetSuccess: 'Password reset successfully! Redirecting to login...',
      resetFailed: 'Failed to reset password. Token may be invalid or expired.',
      requestResetSuccess: 'If this email exists, a password reset link has been sent.',
      requestResetToken: 'Password reset link sent! Token: {token} (Copy this token for testing)',
      addToHomeTitle: 'Add to Home Screen',
      addToHomeMessage: 'This app works best as an app. Save the app to your phone\'s home screen for the best experience.',
      addToHomeButton: 'Save to Home Screen',
      addToHomeDontShowAgain: 'Don\'t show this message again',
      addToHomeGotIt: 'Got it',
      addToHomeStepsSafari: 'In Safari: 1) Tap the Share button (square with arrow) at the bottom. 2) Scroll down and tap "Add to Home Screen". 3) Tap "Add".',
      addToHomeStepsChrome: 'In Chrome: 1) Tap the Share icon (or 3 dots menu) in the address bar. 2) Tap "Add to Home Screen". 3) Tap "Add".',
      addToHomeStepsFirefox: 'In Firefox: 1) Tap the Share icon in the address bar. 2) Select "Add to Home Screen". 3) Tap "Add".',
      addToHomeStepsEdge: 'In Edge: 1) Tap the Share icon (or 3 dots menu) in the address bar. 2) Tap "Add to Home Screen". 3) Tap "Add".',
      addToHomeStepsSamsung: 'In Samsung Internet: 1) Tap the menu (3 lines). 2) Tap "Add page to" > "Home screen". 3) Tap "Add".',
      addToHomeStepsOpera: 'In Opera: 1) Tap the menu icon. 2) Tap "Add to Home screen". 3) Tap "Add".',
      addToHomeStepsDefault: '1) Tap the Share or menu icon in your browser. 2) Look for "Add to Home Screen" or similar. 3) Tap "Add".'
    },
    home: {
      marketplace: 'MARKETPLACE',
      tournaments: 'TOURNAMENTS',
      rankings: 'RANKINGS',
      marketplaceDesc: 'Buy and sell cards',
      tournamentsDesc: 'Compete in GameWeeks',
      rankingsDesc: 'Leaderboards',
      activeGameweeks: 'ACTIVE GAMEWEEKS',
      tournamentsCount: '{count} Tournaments'
    },
    settings: {
      title: 'Settings',
      walletConnection: 'Wallet Connection',
      walletConnected: 'Connected',
      connectWallet: 'Connect Wallet',
      disconnectWallet: 'Disconnect',
      connecting: 'Connecting...',
      languageLabel: 'Language',
      tutorialCompleted: 'Tutorial Completed',
      soundsEnabled: 'Sound effects',
      soundsEnabledDesc: 'Play sounds when clicking buttons and during game actions',
      musicEnabled: 'Background music',
      musicEnabledDesc: 'Play background music after login',
      musicVolume: 'Music volume',
      musicVolumeMobile: 'On mobile, volume is controlled by your device.',
      accountTitle: 'Account',
      logout: 'Logout',
      saveSuccess: 'Settings saved successfully.',
      saveFailed: 'Failed to save settings.',
      passwordSectionTitle: 'Reset password',
      currentPassword: 'Current password',
      currentPasswordPlaceholder: 'Enter your current password',
      newPassword: 'New password',
      newPasswordPlaceholder: 'Enter your new password',
      confirmNewPassword: 'Confirm new password',
      confirmNewPasswordPlaceholder: 'Repeat your new password',
      changePassword: 'Confirm password change',
      changingPassword: 'Updating password...',
      passwordFillAllFields: 'Please fill in all password fields.',
      passwordMinLength: 'The new password must be at least 8 characters long.',
      passwordMismatch: 'The new passwords do not match.',
      passwordMustDiffer: 'The new password must be different from the current one.',
      passwordChangeSuccess: 'Password updated successfully.',
      passwordChangeFailed: 'Failed to update password.'
    },
    rankings: {
      title: 'Rankings',
      gameweekSectionTitle: 'GameWeek Rankings',
      gameweekSectionDesc: 'Official standings for each GameWeek tournament: rank, final score, and prize. Choose the tournament and category (Basic, Plus, Rare, Epic, Unique) below.',
      monthlySectionTitle: 'Monthly Rankings',
      monthlySectionDesc: 'Official monthly leaderboards published by the platform. The score is the sum of your GameWeek results in that period (same category).',
      monthlySelectTitle: 'Choose monthly ranking',
      monthlySelectPlaceholder: 'Select a monthly ranking...',
      monthlyEmptyHint: 'No monthly ranking has been published yet. They are released by the platform at the end of each period.',
      monthlyEmptyTable: 'No data for this monthly ranking',
      monthlyCategoryLabel: 'Category',
      monthlyCategoryGlobal: 'Global',
      monthlyPrizePoolLabel: 'Prize pool',
      selectTitle: 'Choose GameWeek tournament',
      selectPlaceholder: 'Select a GameWeek tournament...',
      emptyHint: 'No GameWeek rankings available. Standings appear once a tournament has calculated scores.',
      loading: 'Loading rankings...',
      typeLabel: 'Type',
      tableRank: 'Rank',
      tablePlayer: 'Player',
      tableScore: 'Score',
      tablePrize: 'Prize',
      emptyTable: 'No rankings available yet',
      provisionalLabel: 'Provisional ranking (not final)',
      previewFormationLabel: 'Formation',
      previewReserves: 'Reserves',
      previewLegend: 'Legend',
      previewEmpty: 'No lineup available for this player',
      previewError: 'Unable to load the lineup preview',
      topRefTitle: 'Referral Leaderboard',
      topRefDesc: 'Top referrers by earnings from invited users. Choose a time period to filter.',
      topRefPeriodLabel: 'Time period',
      topRefColReferrals: 'Users invited',
      topRefColEarnings: 'Earnings (DIOS)',
      topRefEmpty: 'No referrers in this period yet',
      topRefPeriodAll: 'All time',
      topRefPeriodMonthly: 'Monthly',
      topRefPeriodSemestral: 'This semester',
      topRefPeriodAnnual: 'Annual',
      topRefSelectMonth: 'Select month',
      topRefSelectYear: 'Select year'
    },
    marketplace: {
      title: 'Marketplace',
      balanceLabel: 'Your Balance',
      tabsAuctions: 'Auctions',
      tabsPacks: 'Packs',
      tabsSales: 'Buy Now',
      tabsLoans: 'Loans',
      tabsTrades: 'Card to Card',
      filtersTitle: 'Search & Filters',
      resetFilters: 'Reset filters',
      auctionStatusOpen: 'Open',
      auctionStatusClosed: 'Closed',
      auctionStatusClosedHint: 'Here you see expired auctions being processed: time is over but the auction is not closed yet and the card has not been assigned.',
      searchPlayerLabel: 'Search Player',
      searchPlayerPlaceholder: 'Enter player name...',
      rarityLabel: 'Rarity',
      allRarities: 'All Rarities',
      rarityBasic: 'Basic',
      rarityPlus: 'Plus',
      rarityRare: 'Rare',
      rarityEpic: 'Epic',
      rarityUnique: 'Unique',
      positionLabel: 'Position',
      allPositions: 'All Positions',
      positionGK: 'Goalkeeper',
      positionDEF: 'Defender',
      positionMID: 'Midfielder',
      positionATT: 'Attacker',
      nationalityLabel: 'Nationality',
      nationalityPlaceholder: 'e.g. Italy',
      teamLabel: 'Team',
      teamPlaceholder: 'e.g. Real Madrid',
      leagueLabel: 'League',
      leaguePlaceholder: 'e.g. Serie A',
      ageMinLabel: 'Age Min',
      ageMinPlaceholder: 'e.g. 18',
      ageMaxLabel: 'Age Max',
      ageMaxPlaceholder: 'e.g. 35',
      xpMinLabel: 'XP Min',
      xpMinPlaceholder: 'e.g. 5',
      xpMaxLabel: 'XP Max',
      xpMaxPlaceholder: 'e.g. 20',
      auctionsInfoTitle: 'Auctions Info',
      auctionsInfoBody: 'Auctions are finalized every 10 minutes. If you win, card assignment can take up to 10 minutes.',
      secondaryMarketFilterNotice: 'Currently only Divinity and Legend (Coach) cards are shown in the secondary market.',
      bidSuccess: '✅ Bid placed successfully! Your bid is now active.',
      purchaseSuccess: '✅ Card purchased successfully! Check your collection.',
      packSuccess: '✅ Pack opened successfully! New cards added to your collection.',
      loanSuccess: '✅ Loan accepted successfully! Card is now in your collection.',
      tradeAcceptSuccess: '✅ Trade accepted successfully! Cards swapped.',
      tradeRejectSuccess: '✅ Trade rejected',
      counterOfferSuccess: '✅ Counter offer sent successfully! The trade owner will see it in their offers.',
      emptyAuctionsTitle: 'No Active Auctions',
      emptyAuctionsBody: 'Check back later for new auction opportunities',
      emptySalesTitle: 'No Cards Available',
      emptySalesBody: 'No cards are currently listed for sale',
      emptyPacksTitle: 'No Packs Available',
      emptyPacksBody: 'Packs will be available soon',
      emptyLoansTitle: 'No Loans Available',
      emptyLoansBody: 'No cards are currently available for loan',
      emptyTradesTitle: 'No Open Trades',
      emptyTradesBody: 'No open trades available at the moment. Create one from your cards!'
    },
    marketplaceCards: {
      ended: 'Ended',
      auctionBadge: 'Auction',
      viewCopiesAria: 'View {count} copies',
      playerAlt: 'Player',
      positionLabel: 'Position',
      teamLabel: 'Team',
      rarityLabel: 'Rarity',
      xpLevelLabel: 'XP Level',
      currentBidLabel: 'Current Bid',
      currentWinnerLabel: 'Current Winner',
      minBidLabel: 'Minimum Bid',
      bidAmountLabel: 'Your Bid Amount',
      bidPlaceholder: 'Enter bid (min: {amount} DIOS)',
      placingBid: 'Placing...',
      auctionExtending: 'Updating timer...',
      placeBid: 'Place Bid',
      quickBid: 'Quick Bid',
      multipleCopiesHint: 'Multiple copies available. Select a copy to place your bid.',
      viewCopiesBid: 'View Copies & Bid',
      loginToBid: 'Please log in to place a bid',
      bidMinError: 'Bid must be at least {amount} DIOS',
      bidFailed: 'Failed to place bid',
      bidAuctionUpdated: 'The auction has been updated: new high bidder and new value. Minimum bid is now {amount} DIOS. Please refresh and try again.',
      bidOfferMinButton: 'Bid {amount} D10S',
      copiesLoadFailed: 'Failed to load copies',
      availableCopies: 'Available Copies ({count})',
      loadingCopies: 'Loading copies...',
      noCopies: 'No copies available.',
      auctionNumber: 'Auction #{id}',
      saleNumber: 'Sale #{id}',
      loanNumber: 'Loan #{id}',
      ownerLabel: 'Owner',
      loanFromLabel: 'Loan from',
      multipleLenders: 'Multiple users (see copies)',
      none: '—',
      bidMin: 'Bid Min',
      customBidPlaceholder: 'Custom (min {amount})',
      loginToPurchase: 'Please log in to purchase',
      purchaseOwnCard: 'You cannot purchase your own card',
      purchaseFailed: 'Failed to purchase card',
      buyNowBadge: 'Buy Now',
      bonusLabel: 'Bonus',
      bonusPosition: 'Boosts role',
      bonusLeague: 'Boosts league',
      bonusScore: 'Score bonus',
      priceLabel: 'Price',
      processing: 'Processing...',
      buyNowAction: 'Buy Now',
      viewCopiesPurchase: 'View Copies & Buy',
      loginToOpenPack: 'Please log in to open packs',
      openPackFailed: 'Failed to open pack',
      packDescriptionFallback: 'Discover amazing cards inside this pack!',
      openingPack: 'Opening Pack...',
      openPack: 'Open Pack',
      packQuantity: 'Quantity',
      packQuantityLabel: 'Packs to buy',
      openingOnePack: 'opening 1 pack',
      openingPacksCount: 'opening {count} packs',
      nextPack: 'Next pack',
      skipOpening: 'Skip',
      cardsAssignedSummary: '{count} cards have been added to your collection.',
      viewInProfile: 'View in Profile',
      loginToAcceptLoan: 'Please log in to accept loans',
      acceptOwnLoan: 'You cannot accept your own loan',
      coachLenderRotationBlocked:
        'You must borrow this coach rarity from every other user who has it listed before you can borrow from this user again.',
      coachPurchaseSameSellerBlocked:
        'You can buy multiple coach cards, but only one per seller.',
      coachLoanSameLenderActive:
        'You already have an active coach loan of this rarity from this user. Choose another user or a different rarity (e.g. Epic and Plus in parallel).',
      acceptLoanFailed: 'Failed to accept loan',
      loanBadge: 'Loan',
      periodLoanBadge: 'Loan (6h periods)',
      pricePerGameweek: 'Price per Gameweek',
      pricePerPeriod: 'Price per period (6h)',
      periodDurationLabel: 'Period length',
      periodHours: '{hours} hours',
      periodsOffered: 'Periods offered',
      periodsRemaining: 'Periods remaining',
      listingSlotsRemaining: 'Listing slots left',
      periodsInUseCount: '{count} in use',
      periodsUsedCount: '{count} used',
      periodInUseNow: 'Period in use',
      periodBorrowOneAtATime: 'Each user rents one 6h period at a time (you cannot select multiple periods).',
      youRentOnePeriod: 'You rent',
      acceptOnePeriod: 'Accept 1 period',
      acceptOnePeriodHint: 'You will rent this card for {hours} hours (one period only) for {amount} DIOS.',
      costPerPeriod: 'Cost per period',
      durationLabel: 'Duration',
      gameweeks: '{count} Gameweeks',
      totalCost: 'Total Cost',
      acceptLoan: 'Accept Loan',
      viewCopiesLoan: 'View Copies & Accept'
    },
    coachTraining: {
      use: 'Use',
      useTitle: 'Start coach training',
      title: 'Coach training',
      hint: 'Select up to {max} player cards of rarity {rarity} to put in training.',
      xpHint: 'While in training, XP accrues proportionally (+{xpPerHour}% per hour, up to +{xp}% over {intervalHours}h).',
      periodStartsOnStart:
        'The {hours}h loan period starts only when you click Start training (not when you accept the loan).',
      loading: 'Loading…',
      noEligible: 'No eligible cards of this rarity.',
      selectAtLeastOne: 'Select at least one card.',
      cardInUseBlocked: 'A card in use in an active tournament cannot be put in training.',
      borrowedCardBlocked: 'Borrowed cards cannot be put in training.',
      selected: '{count} / {max} selected',
      start: 'Start training',
      starting: 'Starting…',
      started: 'Training started. The 6h period has begun.',
      startError: 'Could not start training.',
      loadError: 'Could not load training session.',
      active: 'Training in progress ({hours}h period). +{xpPerHour}% XP per hour on each card (max +{xp}% over {intervalHours}h).',
      periodEndsAt: 'Loan period ends: {date}',
      slotsRemaining: '{count} / {max} training slots · {remaining} available',
      inTrainingSection: 'In training',
      addSection: 'Add cards',
      addCards: 'Add to training',
      added: 'Cards added to training.',
      badge: 'Training',
      cancel: 'Cancel',
      close: 'Close'
    },
    trade: {
      loginToAccept: 'Please log in to accept trades',
      noRequestedCardAvailable: 'You do not have the requested card available for trade',
      noRequestedCard: 'You do not have the requested card',
      loadCardsFailed: 'Failed to load your cards',
      acceptFailed: 'Failed to accept trade',
      loginToReject: 'Please log in to reject trades',
      rejectFailed: 'Failed to reject trade',
      loginToCounter: 'Please log in to make counter offers',
      noCardsForCounter: 'No available cards for counter offer',
      selectCardForCounter: 'Please select a card for counter offer',
      createCounterFailed: 'Failed to create counter offer',
      openTrade: 'Open Trade',
      offerFrom: 'Trade Offer from {username}',
      byUser: 'By: {username}',
      expires: 'Expires: {date}',
      theyOffer: 'They offer',
      theyWant: 'They want',
      youGive: 'You give',
      unknownPlayer: 'Unknown Player',
      unknownRarity: 'Unknown Rarity',
      accept: 'Accept Trade',
      makeCounter: 'Make Counter Offer',
      counterOffer: 'Counter Offer',
      reject: 'Reject',
      ownerHint: 'This is your trade offer. Wait for others to accept or make counter offers.',
      selectCardTitle: 'Select Card to Trade',
      youWillReceive: 'You will receive',
      youWillGive: 'You will give',
      selectWhichCard: 'Select which card to trade:',
      makeCounterTitle: 'Make Counter Offer',
      counterHint: "You don't have the requested card, but you can offer one of your cards instead.",
      selectCardToOffer: 'Select a card to offer:',
      selectCardPlaceholder: '-- Select a card --',
      sendCounter: 'Send Counter Offer',
      sending: 'Sending...',
      counterOfferTitle: 'Counter Offer',
      youWant: 'You want',
      yourCard: 'Your card',
      theirCard: 'Their card',
      selectCardInstead: 'Select a card to offer instead:',
      creating: 'Creating...'
    },
    tournaments: {
      title: 'GameWeeks & Tournaments',
      create: 'Create Tournament',
      filterTitle: 'Filter by Type',
      filterAll: 'All',
      filterGameweek: 'GameWeeks',
      filterPrivate: 'Private',
      filterThematic: 'Thematic',
      loading: 'Loading tournaments...',
      emptyGameweeks: 'No active GameWeeks available at the moment',
      emptyTournaments: 'No tournaments available',
      statusInProgress: 'IN PROGRESS',
      statusPendingPayment: 'PENDING PAYMENT',
      statusClosed: 'CLOSED',
      statusUpcoming: 'UPCOMING',
      statusOpen: 'OPEN',
      checkScores: 'Check Scores',
      viewGameweekScores: 'View gameweek scores',
      viewTournamentScores: 'View tournament scores',
      availableTournaments: '{count} Tournaments Available',
      participants: '{count} participants',
      free: 'Free',
      registered: 'Registered',
      editFormation: 'Edit Formation',
      enter: 'Enter',
      entriesClosed: 'GameWeek is in progress - entries are closed',
      starts: 'Starts',
      ends: 'End',
      countdownFormationLocksIn: 'Formation locks in',
      countdownFormationLocked: 'Formation locked',
      countdownStartsIn: 'Starts in',
      countdownEndsIn: 'Ends in',
      countdownEnded: 'Ended',
      buyIn: 'Buy-in',
      buyInAmount: '{amount} DIOS',
      gameweekPricing: 'Basic: Free | Plus: 5 | Rare: 10 | Epic: 25 | Unique: 50 DIOS',
      rarityLabel: 'Rarity',
      rarityBasic: 'Basic',
      inProgressClosed: 'In Progress - Entries Closed',
      joinGameweek: 'Join GameWeek',
      joinFreeGameweek: 'Join Free GameWeek',
      enterTournament: 'Enter Tournament',
      joinFree: 'Join Free',
      prizePool: 'Prize Pool',
      prize: 'Prize'
    },
    notifications: {
      title: 'Notifications',
      markAllRead: 'Mark all read',
      noNotifications: 'No notifications',
      ariaLabel: 'Notifications',
      justNow: 'Just now',
      minutesAgo: '{count}m ago',
      hoursAgo: '{count}h ago',
      daysAgo: '{count}d ago'
    },
    profile: {
      tabs: {
        myCards: 'My Cards',
        soldLoans: 'Sold & Loans',
        activityReport: 'Activity Report',
        offers: 'Offers',
        referrals: 'Referrals',
        loginHistory: 'Login History',
        security: 'Security',
        notifications: 'Notifications',
        settings: 'Settings'
      }
    },
    activityReport: {
      title: 'Activity Report',
      last7Days: 'Last 7 days',
      downloadCsv: 'Download CSV',
      loading: 'Loading activity...',
      empty: 'No activity in the last 7 days.',
      category: {
        deposit: 'Deposit',
        withdrawal: 'Withdrawal',
        prize: 'Prize',
        marketplace: 'Marketplace'
      },
      action: {
        deposit: 'Deposit',
        withdrawal: 'Withdrawal',
        purchase: 'Purchase',
        sale: 'Sale',
        loanBorrow: 'Loan (Borrow)',
        loanLend: 'Loan (Lend)',
        gameweekPrize: 'Gameweek Prize'
      }
    },
    cardsStatus: {
      cardsForSale: 'Cards for Sale',
      soldCards: 'Sold Cards',
      loanedCards: 'Loaned Cards',
      borrowedCards: 'Borrowed Cards',
      forSaleLabel: 'For sale',
      soldLabel: 'Sold',
      loanedLabel: 'On loan',
      borrowedLabel: 'Borrowed',
      listedDate: 'Listed',
      saleDate: 'Sale date',
      startDate: 'Start date',
      duration: 'Duration: {count} GW',
      emptyCardsForSale: 'No cards for sale.',
      emptySold: 'No sold cards.',
      emptyLoaned: 'No loaned cards.',
      emptyBorrowed: 'No active borrowed cards.',
      removeFromSale: 'Remove from sale',
      confirmRemoveFromSale: 'Remove this card from sale?',
      removeFromSaleFailed: 'Failed to remove from sale',
      listedLoans: 'Loans listed (waiting)',
      listedLoanLabel: 'On loan',
      emptyListedLoans: 'No loans waiting for a borrower.',
      removeFromLoan: 'Remove',
      confirmRemoveFromLoan: 'Remove this card from the loan listing?',
      removeFromLoanFailed: 'Failed to remove from loan',
      cannotRemovePeriodLoan: 'Cannot remove: at least one period has already been taken.',
      periodListingDetail: '{price} D10S/period · {remaining} of {total} left ({used} used)',
      periodActiveDetail: '{price} D10S/period · period {current}/{total} in use ({borrower})',
      periodInUse: 'Period {current} of {total} in use',
      pricePerPeriodLabel: 'Price per period',
      savePeriodPrice: 'Save price',
      invalidPeriodPrice: 'Enter a valid price',
      updatePeriodPriceFailed: 'Failed to update period price'
    },
    loginHistory: {
      title: 'Login History',
      total: 'Total: {count}',
      loading: 'Loading login history...',
      empty: 'No login history found',
      success: 'Success',
      failed: 'Failed',
      reason: 'Reason',
      ip: 'IP',
      location: 'Location'
    },
    security: {
      titleSecurity: 'Security Reports',
      titleSupport: 'Support Tickets',
      total: 'Total: {count}',
      reportIssue: 'Report Issue',
      createFirst: 'Create First Report',
      loadingSecurity: 'Loading security reports...',
      loadingSupport: 'Loading support tickets...',
      emptySecurity: 'No security reports found',
      emptySupport: 'No support tickets found',
      sectionSecurity: 'Security Reports',
      sectionSupport: 'Support Tickets',
      created: 'Created',
      resolved: 'Resolved',
      adminNotes: 'Admin Notes',
      botReply: 'Bot Reply',
      reportModalTitle: 'Report Security Issue',
      reportType: 'Report Type',
      priority: 'Priority',
      title: 'Title',
      description: 'Description',
      titlePlaceholder: 'Brief description',
      descriptionPlaceholder: 'Detailed description of the security issue',
      reportTypeOptions: {
        accountCompromise: 'Account Compromise',
        suspiciousActivity: 'Suspicious Activity',
        phishing: 'Phishing',
        unauthorizedAccess: 'Unauthorized Access',
        other: 'Other'
      },
      priorityOptions: {
        low: 'Low',
        medium: 'Medium',
        high: 'High',
        critical: 'Critical'
      },
      openSupportTicket: 'Open support ticket',
      supportTicketModalTitle: 'New support ticket',
      supportSubject: 'Subject (optional)',
      supportSubjectPlaceholder: 'Short summary (optional)',
      supportMessage: 'Message',
      supportMessagePlaceholder: 'Describe your request in detail.',
      submitSupportTicket: 'Send ticket',
      supportTicketError: 'Could not open the ticket. Please try again.',
      submit: 'Submit Report',
      cancel: 'Cancel'
    },
    notificationsTab: {
      maintenanceTitle: 'Maintenance Alerts',
      announcementsTitle: 'System Announcements',
      personalTitle: 'Personal Notifications',
      unread: '{count} unread',
      markAllRead: 'Mark all as read',
      noMaintenance: 'No maintenance alerts',
      noAnnouncements: 'No announcements',
      noPersonal: 'No notifications found',
      clickToView: 'Click to view →',
      scheduled: 'Scheduled',
      affects: 'Affects'
    },
    gdpr: {
      bannerTitle: 'Privacy & Cookies',
      bannerDescription: 'We use cookies and similar technologies to run the site, to improve your experience and to personalize content. You can accept all, reject optional cookies, or customize your choices.',
      acceptAll: 'Accept all',
      rejectOptional: 'Reject optional',
      customize: 'Customize',
      preferencesTitle: 'Cookie preferences',
      preferencesIntro: 'Choose which categories of cookies you allow. Necessary cookies are required for the site to work and cannot be disabled.',
      necessary: 'Necessary',
      necessaryDesc: 'Essential for the site to work (e.g. session, security).',
      analytics: 'Analytics',
      analyticsDesc: 'Help us understand how you use the site to improve it.',
      preferencesCat: 'Preferences',
      preferencesDesc: 'Remember your settings and preferences.',
      marketing: 'Marketing',
      marketingDesc: 'Used for relevant ads and marketing (if we use them).',
      alwaysOn: 'Always on',
      savePreferences: 'Save preferences',
      cookiePreferencesLink: 'Cookie preferences'
    },
    legal: {
      platformOwner: 'The platform owner is Uilliam Dettori.'
    },
    settingsExtra: {
      walletAssociatedLabel: 'Wallet linked to your account:',
      walletConnectedLabel: 'Currently connected wallet:',
      walletMismatchTitle: 'Wallet mismatch',
      walletMismatchBody: 'The connected wallet does not match the one linked to your account. Connect the correct wallet to use all features.',
      walletConnected: 'Connected wallet',
      walletSaveSuccess: 'Wallet linked successfully!',
      walletSaveError: 'Failed to save wallet: {message}',
      walletConnectError: 'Failed to connect wallet: {message}',
      saveWallet: 'Link this wallet to your account',
      saveWalletConfirm: 'Yes, link wallet',
      savingWallet: 'Saving...',
      walletMobileHint: 'On mobile: when the connection screen opens, choose your wallet app or scan the QR code.',
      walletConnectedReadyInfo: 'You can use this wallet for deposits and withdrawals. No need to connect again.',
      walletModalTitle: 'Wallet connected',
      walletModalConnectedSuccess: 'Wallet connected successfully:',
      walletModalQuestion: 'Do you want to link this wallet to your account? This lets you use it for future transactions.',
      walletModalSkip: 'No, skip'
    },
    supportWidget: {
      buttonOpen: 'Help',
      title: 'Support',
      closeAria: 'Close',
      sendAria: 'Send',
      openTelegram: 'Open Telegram',
      loadingReply: 'Looking for an answer...',
      escalateAction: 'Open support ticket',
      inputPlaceholder: 'Write here...',
      welcomeMessage: 'I can help with deposits, withdrawals, marketplace, auctions, packs, tournaments, referrals, or account issues. If needed, I can escalate to a human operator, or you can contact support directly on Telegram.',
      fallbackNotUnderstood: 'I did not understand. Do you want to talk to an operator?',
      temporaryError: 'Temporary error. Try again or contact an operator.',
      loginRequired: 'To open a support ticket you need to log in first.',
      writeRequestHint: 'Write your request below and tap "Open support ticket" again, or send a message to the bot first.',
      escalatedTicket: 'Your request has been sent to an operator. Ticket #{ticketId}',
      escalateFailed: 'I cannot contact an operator right now. Please try again shortly.',
      quickHome: 'Home',
      quickMarketplace: 'Marketplace',
      quickTournaments: 'Tournaments',
      quickRankings: 'Rankings',
      quickDeposit: 'Deposit',
      quickProfile: 'Profile'
    },
    depositPage: {
      title: 'Deposit Funds',
      chooseMethod: 'Choose how to deposit',
      methodBonifico: 'SEPA bank transfer',
      methodPostepay: 'Postepay top-up',
      bonificoTitle: 'SEPA bank transfer',
      bonificoLead: 'Send a SEPA transfer to the IBAN below. In the payment reference, enter your ',
      usernameEmphasis: 'DIOS username',
      bonificoTail: ' so we can match the payment. 1 EUR = 1 DIOS. Crediting is not automatic: it will be verified manually.',
      postepayTitle: 'Postepay top-up',
      postepayLead: 'Use the details below for the top-up. ',
      postepayCausaleLabel: 'Reference:',
      postepayMid: ' enter your ',
      postepayTail: ' (same as you use to log in). Crediting is not automatic: it will be verified manually.',
      labelIban: 'IBAN',
      labelAccountHolder: 'Account holder',
      labelCardNumber: 'Card number',
      labelExpiry: 'Expiry',
      labelFiscalCode: 'Fiscal code (holder)',
      copyIban: 'Copy IBAN',
      copy: 'Copy',
      copyNumber: 'Copy number',
      copyFiscalCode: 'Copy fiscal code',
      copied: 'Copied ✓',
      stripeUnavailableTitle: 'Not available at the moment'
    },
    confirmD10S: {
      first: 'You are about to spend {amount} DIOS for: {action}. Do you want to continue?',
      second: 'Confirm again to proceed.',
      actionDeposit: 'Deposit',
      actionWithdraw: 'Withdraw',
      actionListSale: 'List for sale',
      actionListLoan: 'List for loan',
      firstListSale: 'You are about to list this card for sale at {amount} DIOS. Do you want to continue?',
      firstListLoan: 'You are about to list this card for loan (total {amount} DIOS). Do you want to continue?',
      titleFirst: 'Confirm operation',
      titleSecond: 'Final confirmation',
      confirmContinue: 'Continue',
      confirmFinal: 'Yes, proceed'
    }
};

const it = {
    common: {
      language: 'Lingua',
      save: 'Salva impostazioni',
      saving: 'Salvataggio...',
      continue: 'Continua',
      search: 'Cerca',
      cancel: 'Annulla',
      previous: 'Precedente',
      next: 'Successivo',
      pageOf: 'Pagina {page} di {total}',
      loading: 'Caricamento...',
      notAvailable: 'N/D',
      unknown: 'Sconosciuto',
      processing: 'Elaborazione...'
    },
    onboarding: {
      chooseLanguageTitle: 'Scegli la tua lingua',
      chooseLanguageSubtitle: 'Seleziona la lingua preferita per il gioco',
      savingLanguage: 'Salvataggio...'
    },
    navbar: {
      searchPlaceholder: 'Cerca player per nome...',
      searchAriaLabel: 'Cerca',
      searching: 'Ricerca in corso...',
      noResults: 'Nessun risultato',
      totalCards: 'Totale cards',
      company: 'Company',
      errorSearch: 'Errore nella ricerca',
      signIn: 'Accedi',
      register: 'Registrati',
      adminPanel: 'Pannello admin',
      rules: 'Regolamento',
      musicMute: 'Disattiva musica di sottofondo',
      musicUnmute: 'Attiva musica di sottofondo'
    },
    rules: {
      mobileTitle: 'Regolamento DIOS10',
      mobileDesc: 'Su mobile apri il PDF nel browser per una lettura ottimale.',
      openPdf: 'Apri PDF nel browser'
    },
    auth: {
      signIn: 'Accedi',
      signingIn: 'Accesso...',
      email: 'Email',
      password: 'Password',
      forgotPassword: 'Password dimenticata?',
      noAccount: 'Non hai un account?',
      registerNow: 'Registrati ora',
      fillAllFields: 'Compila tutti i campi',
      loginFailed: 'Login fallito. Controlla le credenziali.',
      emailVerified: 'E-mail verificata. Ora puoi accedere.',
      emailVerifiedInvalid: 'Link di verifica non valido o scaduto.',
      createAccount: 'Crea il tuo account',
      chooseUsername: 'Scegli il tuo username',
      username: 'Username',
      confirmPassword: 'Conferma password',
      referralCode: 'Codice referral (opzionale)',
      referralPlaceholder: 'Inserisci il codice referral se ne hai uno',
      confirmPasswordPlaceholder: 'Conferma la tua password',
      minimumCharacters: 'Minimo 6 caratteri',
      creatingAccount: 'Creazione account...',
      startJourney: 'Inizia il viaggio',
      alreadyAccount: 'Hai già un account?',
      terms: 'Registrandoti accetti i Termini di servizio',
      passwordMismatch: 'Le password non coincidono',
      passwordShort: 'La password deve avere almeno 6 caratteri',
      registrationPending: 'Registrazione in attesa. Verifica la tua email tramite il link che ti abbiamo inviato. Non puoi accedere finché l\'email non è verificata.',
      registrationSuccess: 'Registrazione completata. Ora puoi accedere.',
      registrationFailed: 'Registrazione fallita. Riprova.',
      forgotTitle: 'Password dimenticata?',
      forgotSubtitle: 'Inserisci la tua email e ti invieremo un link per reimpostare la password.',
      sendResetLink: 'Invia link di reset',
      sending: 'Invio...',
      resetToken: 'Token di reset',
      setNewPassword: 'Imposta nuova password',
      newPassword: 'Nuova password',
      confirmNewPassword: 'Conferma nuova password',
      resetPassword: 'Reimposta password',
      resetting: 'Reimpostazione...',
      resetTokenRequired: 'Il token di reset è obbligatorio',
      resetPasswordShort: 'La password deve avere almeno 8 caratteri',
      resetSuccess: 'Password reimpostata! Reindirizzamento al login...',
      resetFailed: 'Impossibile reimpostare la password. Token non valido o scaduto.',
      requestResetSuccess: 'Se questa email esiste, è stato inviato un link di reset.',
      requestResetToken: 'Link di reset inviato! Token: {token} (Copia questo token per i test)',
      addToHomeTitle: 'Aggiungi alla Home',
      addToHomeMessage: 'Questa app è compatibile con uso App. Salva la schermata dell\'app nella home del tuo telefono per un\'esperienza migliore.',
      addToHomeButton: 'Salva nella home',
      addToHomeDontShowAgain: 'Non mostrare più il messaggio',
      addToHomeGotIt: 'Ho capito',
      addToHomeStepsSafari: 'In Safari: 1) Tocca il pulsante Condividi (quadrato con freccia) in basso. 2) Scorri e seleziona "Aggiungi a Home". 3) Tocca "Aggiungi".',
      addToHomeStepsChrome: 'In Chrome: 1) Tocca l\'icona Condividi (o menu tre puntini) nella barra degli indirizzi. 2) Seleziona "Aggiungi a Home". 3) Tocca "Aggiungi".',
      addToHomeStepsFirefox: 'In Firefox: 1) Tocca l\'icona Condividi nella barra degli indirizzi. 2) Seleziona "Aggiungi a Home". 3) Tocca "Aggiungi".',
      addToHomeStepsEdge: 'In Edge: 1) Tocca l\'icona Condividi (o menu tre puntini) nella barra degli indirizzi. 2) Seleziona "Aggiungi a Home". 3) Tocca "Aggiungi".',
      addToHomeStepsSamsung: 'In Samsung Internet: 1) Tocca il menu (tre linee). 2) Seleziona "Aggiungi pagina a" > "Schermata Home". 3) Tocca "Aggiungi".',
      addToHomeStepsOpera: 'In Opera: 1) Tocca l\'icona menu. 2) Seleziona "Aggiungi a Home". 3) Tocca "Aggiungi".',
      addToHomeStepsDefault: '1) Tocca l\'icona Condividi o menu del browser. 2) Cerca "Aggiungi a Home" o simile. 3) Tocca "Aggiungi".'
    },
    home: {
      marketplace: 'MERCATO',
      tournaments: 'TORNEI',
      rankings: 'CLASSIFICHE',
      marketplaceDesc: 'Compra e vendi carte',
      tournamentsDesc: 'Partecipa alle GameWeek',
      rankingsDesc: 'Classifiche',
      activeGameweeks: 'GAMEWEEKS ATTIVE',
      tournamentsCount: '{count} Tornei'
    },
    settings: {
      title: 'Impostazioni',
      walletConnection: 'Connessione wallet',
      walletConnected: 'Connesso',
      connectWallet: 'Connetti wallet',
      disconnectWallet: 'Disconnetti',
      connecting: 'Connessione...',
      languageLabel: 'Lingua',
      tutorialCompleted: 'Tutorial completato',
      soundsEnabled: 'Effetti sonori',
      soundsEnabledDesc: 'Riproduci suoni al clic sui pulsanti e durante le azioni di gioco',
      musicEnabled: 'Musica di sottofondo',
      musicEnabledDesc: 'Riproduci musica di sottofondo dopo il login',
      musicVolume: 'Volume musica',
      musicVolumeMobile: 'Su mobile il volume è controllato dal dispositivo.',
      accountTitle: 'Account',
      logout: 'Logout',
      saveSuccess: 'Impostazioni salvate con successo.',
      saveFailed: 'Impossibile salvare le impostazioni.',
      passwordSectionTitle: 'Reset password',
      currentPassword: 'Password attuale',
      currentPasswordPlaceholder: 'Inserisci la password attuale',
      newPassword: 'Nuova password',
      newPasswordPlaceholder: 'Inserisci la nuova password',
      confirmNewPassword: 'Conferma nuova password',
      confirmNewPasswordPlaceholder: 'Ripeti la nuova password',
      changePassword: 'Conferma cambio password',
      changingPassword: 'Aggiornamento password...',
      passwordFillAllFields: 'Compila tutti i campi della password.',
      passwordMinLength: 'La nuova password deve avere almeno 8 caratteri.',
      passwordMismatch: 'Le nuove password non coincidono.',
      passwordMustDiffer: 'La nuova password deve essere diversa da quella attuale.',
      passwordChangeSuccess: 'Password aggiornata con successo.',
      passwordChangeFailed: 'Impossibile aggiornare la password.'
    },
    rankings: {
      title: 'Classifiche',
      gameweekSectionTitle: 'Classifiche GameWeek',
      gameweekSectionDesc: 'Classifica ufficiale di ogni torneo GameWeek: posizione, punteggio finale e premio. Scegli torneo e categoria (Basic, Plus, Rare, Epic, Unique) dal menu.',
      monthlySectionTitle: 'Classifiche Mensili',
      monthlySectionDesc: 'Classifiche ufficiali pubblicate dalla piattaforma: il punteggio è la somma dei risultati delle GameWeek comprese nel periodo (stessa categoria).',
      monthlySelectTitle: 'Scegli classifica mensile',
      monthlySelectPlaceholder: 'Seleziona una classifica mensile...',
      monthlyEmptyHint: 'Nessuna classifica mensile pubblicata al momento. Vengono pubblicate dalla piattaforma al termine del periodo.',
      monthlyEmptyTable: 'Nessun dato per questa classifica mensile',
      monthlyCategoryLabel: 'Categoria',
      monthlyCategoryGlobal: 'Globale',
      monthlyPrizePoolLabel: 'Montepremi',
      selectTitle: 'Scegli torneo GameWeek',
      selectPlaceholder: 'Seleziona un torneo GameWeek...',
      emptyHint: 'Nessuna classifica GameWeek disponibile. Le posizioni compaiono quando un torneo ha punteggi calcolati.',
      loading: 'Caricamento classifiche...',
      typeLabel: 'Tipo',
      tableRank: 'Posizione',
      tablePlayer: 'Giocatore',
      tableScore: 'Punteggio',
      tablePrize: 'Premio',
      emptyTable: 'Nessuna classifica disponibile',
      provisionalLabel: 'Classifica non definitiva',
      previewFormationLabel: 'Formazione',
      previewReserves: 'Riserve',
      previewLegend: 'Legend',
      previewEmpty: 'Nessuna formazione disponibile per questo player',
      previewError: 'Impossibile caricare l\'anteprima della formazione',
      topRefTitle: 'Classifica Referral',
      topRefDesc: 'I migliori referrer per guadagni da utenti invitati. Scegli il periodo da visualizzare.',
      topRefPeriodLabel: 'Periodo di riferimento',
      topRefColReferrals: 'Utenti invitati',
      topRefColEarnings: 'Guadagni (DIOS)',
      topRefEmpty: 'Nessun referrer in questo periodo',
      topRefPeriodAll: 'Sempre',
      topRefPeriodMonthly: 'Mensile',
      topRefPeriodSemestral: 'Questo semestre',
      topRefPeriodAnnual: 'Annuale',
      topRefSelectMonth: 'Seleziona mese',
      topRefSelectYear: 'Seleziona anno'
    },
    marketplace: {
      title: 'Marketplace',
      balanceLabel: 'Saldo',
      tabsAuctions: 'Aste',
      tabsPacks: 'Packs',
      tabsSales: 'Compra subito',
      tabsLoans: 'Prestiti',
      tabsTrades: 'Carta per carta',
      filtersTitle: 'Ricerca e filtri',
      resetFilters: 'Reset filtri',
      auctionStatusOpen: 'Aperte',
      auctionStatusClosed: 'Chiuse',
      auctionStatusClosedHint: 'Qui vedi le aste scadute in elaborazione: il tempo è finito ma l\'asta non è ancora chiusa e la card non è stata associata.',
      searchPlayerLabel: 'Cerca giocatore',
      searchPlayerPlaceholder: 'Inserisci il nome del giocatore...',
      rarityLabel: 'Rarità',
      allRarities: 'Tutte le rarità',
      rarityBasic: 'Basic',
      rarityPlus: 'Plus',
      rarityRare: 'Rare',
      rarityEpic: 'Epic',
      rarityUnique: 'Unique',
      positionLabel: 'Ruolo',
      allPositions: 'Tutti i ruoli',
      positionGK: 'Portiere',
      positionDEF: 'Difensore',
      positionMID: 'Centrocampista',
      positionATT: 'Attaccante',
      nationalityLabel: 'Nazionalità',
      nationalityPlaceholder: 'es. Italia',
      teamLabel: 'Squadra',
      teamPlaceholder: 'es. Real Madrid',
      leagueLabel: 'Campionato',
      leaguePlaceholder: 'es. Serie A',
      ageMinLabel: 'Età min',
      ageMinPlaceholder: 'es. 18',
      ageMaxLabel: 'Età max',
      ageMaxPlaceholder: 'es. 35',
      xpMinLabel: 'XP min',
      xpMinPlaceholder: 'es. 5',
      xpMaxLabel: 'XP max',
      xpMaxPlaceholder: 'es. 20',
      auctionsInfoTitle: 'Info aste',
      auctionsInfoBody: 'Le aste vengono finalizzate ogni 10 minuti. Se vinci, l\'assegnazione della card può richiedere fino a 10 minuti.',
      secondaryMarketFilterNotice: 'Attualmente verranno visualizzate solo card Divinity e Legend (Allenatore).',
      bidSuccess: '✅ Offerta piazzata! La tua offerta è attiva.',
      purchaseSuccess: '✅ Carta acquistata! Controlla la tua collezione.',
      packSuccess: '✅ Pack aperto! Nuove carte aggiunte alla collezione.',
      loanSuccess: '✅ Prestito accettato! La carta è ora nella tua collezione.',
      tradeAcceptSuccess: '✅ Scambio accettato! Carte scambiate.',
      tradeRejectSuccess: '✅ Scambio rifiutato',
      counterOfferSuccess: '✅ Controproposta inviata! Il proprietario la vedrà nelle offerte.',
      emptyAuctionsTitle: 'Nessuna asta attiva',
      emptyAuctionsBody: 'Torna più tardi per nuove aste',
      emptySalesTitle: 'Nessuna carta disponibile',
      emptySalesBody: 'Nessuna carta è attualmente in vendita',
      emptyPacksTitle: 'Nessun pack disponibile',
      emptyPacksBody: 'I pack saranno disponibili a breve',
      emptyLoansTitle: 'Nessun prestito disponibile',
      emptyLoansBody: 'Nessuna carta disponibile per il prestito',
      emptyTradesTitle: 'Nessuno scambio aperto',
      emptyTradesBody: 'Nessuno scambio disponibile al momento. Creane uno dalle tue carte!'
    },
    marketplaceCards: {
      ended: 'Terminata',
      auctionBadge: 'Asta',
      viewCopiesAria: 'Vedi {count} copie',
      playerAlt: 'Giocatore',
      positionLabel: 'Ruolo',
      teamLabel: 'Squadra',
      rarityLabel: 'Rarità',
      xpLevelLabel: 'Livello XP',
      currentBidLabel: 'Offerta attuale',
      currentWinnerLabel: 'Vincitore attuale',
      minBidLabel: 'Offerta minima',
      bidAmountLabel: 'Importo offerta',
      bidPlaceholder: 'Inserisci offerta (min: {amount} DIOS)',
      placingBid: 'Invio...',
      auctionExtending: 'Aggiornamento timer...',
      placeBid: 'Fai offerta',
      quickBid: 'Offerta rapida',
      multipleCopiesHint: 'Più copie disponibili. Seleziona una copia per fare l\'offerta.',
      viewCopiesBid: 'Vedi copie e fai offerta',
      loginToBid: 'Accedi per fare un\'offerta',
      bidMinError: 'L\'offerta deve essere almeno {amount} DIOS',
      bidFailed: 'Impossibile fare l\'offerta',
      bidAuctionUpdated: 'L\'asta si è aggiornata: nuovo offerente e nuovo valore. Offerta minima ora {amount} DIOS. Aggiorna e riprova.',
      bidOfferMinButton: 'Offri {amount} D10S',
      copiesLoadFailed: 'Impossibile caricare le copie',
      availableCopies: 'Copie disponibili ({count})',
      loadingCopies: 'Caricamento copie...',
      noCopies: 'Nessuna copia disponibile.',
      auctionNumber: 'Asta #{id}',
      saleNumber: 'Vendita #{id}',
      loanNumber: 'Prestito #{id}',
      ownerLabel: 'Proprietario',
      loanFromLabel: 'In prestito da',
      multipleLenders: 'Più utenti (vedi copie)',
      none: '—',
      bidMin: 'Offerta min',
      customBidPlaceholder: 'Personalizzata (min {amount})',
      loginToPurchase: 'Accedi per acquistare',
      purchaseOwnCard: 'Non puoi acquistare la tua stessa carta',
      purchaseFailed: 'Impossibile acquistare la carta',
      buyNowBadge: 'Compra subito',
      bonusLabel: 'Bonus',
      bonusPosition: 'Potenzia ruolo',
      bonusLeague: 'Potenzia lega',
      bonusScore: 'Bonus score',
      priceLabel: 'Prezzo',
      processing: 'Elaborazione...',
      buyNowAction: 'Compra subito',
      viewCopiesPurchase: 'Vedi copie e compra',
      loginToOpenPack: 'Accedi per aprire i pack',
      openPackFailed: 'Impossibile aprire il pack',
      packDescriptionFallback: 'Scopri carte incredibili in questo pack!',
      openingPack: 'Apertura pack...',
      openPack: 'Apri pack',
      packQuantity: 'Quantità',
      packQuantityLabel: 'Pack da acquistare',
      openingOnePack: 'apertura 1 pack',
      openingPacksCount: 'apertura {count} packs',
      nextPack: 'Prossimo pack',
      skipOpening: 'Salta',
      cardsAssignedSummary: '{count} carte sono state aggiunte alla tua collezione.',
      viewInProfile: 'Vedi nel Profilo',
      loginToAcceptLoan: 'Accedi per accettare i prestiti',
      acceptOwnLoan: 'Non puoi accettare il tuo stesso prestito',
      coachLenderRotationBlocked:
        'Devi prendere in prestito la card coach da tutti gli altri utenti che la offrono (stessa rarità) prima di poterla richiedere di nuovo a questo utente.',
      coachPurchaseSameSellerBlocked:
        'Puoi acquistare più card allenatore, ma non più di una dallo stesso utente.',
      coachLoanSameLenderActive:
        'Hai già un prestito coach di questa rarità attivo con questo utente. Scegli un altro utente o un\'altra rarità (es. Epic e Plus in parallelo).',
      acceptLoanFailed: 'Impossibile accettare il prestito',
      loanBadge: 'Prestito',
      periodLoanBadge: 'Prestito (periodi 6h)',
      pricePerGameweek: 'Prezzo per GameWeek',
      pricePerPeriod: 'Prezzo per periodo (6h)',
      periodDurationLabel: 'Durata periodo',
      periodHours: '{hours} ore',
      periodsOffered: 'Periodi offerti',
      periodsRemaining: 'Periodi rimanenti',
      listingSlotsRemaining: 'Slot rimanenti sul listing',
      periodsInUseCount: '{count} in uso',
      periodsUsedCount: '{count} usati',
      periodInUseNow: 'Periodo in uso',
      periodBorrowOneAtATime: 'Ogni utente prende un solo periodo da 6h alla volta (non puoi scegliere più periodi).',
      youRentOnePeriod: 'Prendi',
      acceptOnePeriod: 'Accetta 1 periodo',
      acceptOnePeriodHint: 'Noleggi questa card per {hours} ore (un solo periodo) per {amount} DIOS.',
      costPerPeriod: 'Costo per un periodo',
      durationLabel: 'Durata',
      gameweeks: '{count} GameWeeks',
      totalCost: 'Costo totale',
      acceptLoan: 'Accetta prestito',
      viewCopiesLoan: 'Vedi copie e accetta'
    },
    coachTraining: {
      use: 'Usa',
      useTitle: 'Avvia allenamento coach',
      title: 'Allenamento',
      hint: 'Seleziona fino a {max} carte giocatore di rarità {rarity} da mettere in allenamento.',
      xpHint: 'In allenamento l\'XP matura in proporzione (+{xpPerHour}% all\'ora, fino a +{xp}% in {intervalHours}h).',
      periodStartsOnStart:
        'Le {hours}h del prestito partono solo al clic su Avvia allenamento (non quando accetti il prestito).',
      loading: 'Caricamento…',
      noEligible: 'Nessuna carta eleggibile di questa rarità.',
      selectAtLeastOne: 'Seleziona almeno una carta.',
      cardInUseBlocked: 'Una carta in uso in un torneo attivo non può essere messa in allenamento.',
      borrowedCardBlocked: 'Le carte prese in prestito non possono essere messe in allenamento.',
      selected: '{count} / {max} selezionate',
      start: 'Avvia allenamento',
      starting: 'Avvio…',
      started: 'Allenamento avviato. Il periodo da 6h è iniziato.',
      startError: 'Impossibile avviare l\'allenamento.',
      loadError: 'Impossibile caricare la sessione.',
      active: 'Allenamento in corso (periodo {hours}h). +{xpPerHour}% XP all\'ora su ogni carta (max +{xp}% in {intervalHours}h).',
      periodEndsAt: 'Fine periodo prestito: {date}',
      slotsRemaining: '{count} / {max} slot allenamento · {remaining} disponibili',
      inTrainingSection: 'In allenamento',
      addSection: 'Aggiungi carte',
      addCards: 'Aggiungi all\'allenamento',
      added: 'Carte aggiunte all\'allenamento.',
      badge: 'Allenamento',
      cancel: 'Annulla',
      close: 'Chiudi'
    },
    trade: {
      loginToAccept: 'Accedi per accettare gli scambi',
      noRequestedCardAvailable: 'Non hai la carta richiesta disponibile per lo scambio',
      noRequestedCard: 'Non hai la carta richiesta',
      loadCardsFailed: 'Impossibile caricare le tue carte',
      acceptFailed: 'Impossibile accettare lo scambio',
      loginToReject: 'Accedi per rifiutare gli scambi',
      rejectFailed: 'Impossibile rifiutare lo scambio',
      loginToCounter: 'Accedi per fare controproposte',
      noCardsForCounter: 'Nessuna carta disponibile per la controproposta',
      selectCardForCounter: 'Seleziona una carta per la controproposta',
      createCounterFailed: 'Impossibile creare la controproposta',
      openTrade: 'Scambio aperto',
      offerFrom: 'Offerta di scambio da {username}',
      byUser: 'Da: {username}',
      expires: 'Scade: {date}',
      theyOffer: 'Offrono',
      theyWant: 'Vogliono',
      youGive: 'Tu dai',
      unknownPlayer: 'Giocatore sconosciuto',
      unknownRarity: 'Rarità sconosciuta',
      accept: 'Accetta scambio',
      makeCounter: 'Fai controproposta',
      counterOffer: 'Controproposta',
      reject: 'Rifiuta',
      ownerHint: 'Questo è il tuo scambio. Attendi che altri accettino o facciano controproposte.',
      selectCardTitle: 'Seleziona carta da scambiare',
      youWillReceive: 'Riceverai',
      youWillGive: 'Darai',
      selectWhichCard: 'Seleziona quale carta scambiare:',
      makeCounterTitle: 'Fai controproposta',
      counterHint: 'Non hai la carta richiesta, ma puoi offrire una delle tue.',
      selectCardToOffer: 'Seleziona una carta da offrire:',
      selectCardPlaceholder: '-- Seleziona una carta --',
      sendCounter: 'Invia controproposta',
      sending: 'Invio...',
      counterOfferTitle: 'Controproposta',
      youWant: 'Vuoi',
      yourCard: 'La tua carta',
      theirCard: 'La loro carta',
      selectCardInstead: 'Seleziona una carta da offrire al posto:',
      creating: 'Creazione...'
    },
    tournaments: {
      title: 'GameWeeks e Tornei',
      create: 'Crea torneo',
      filterTitle: 'Filtra per tipo',
      filterAll: 'Tutti',
      filterGameweek: 'GameWeeks',
      filterPrivate: 'Privati',
      filterThematic: 'Tematici',
      loading: 'Caricamento tornei...',
      emptyGameweeks: 'Nessuna GameWeek attiva al momento',
      emptyTournaments: 'Nessun torneo disponibile',
      statusInProgress: 'IN CORSO',
      statusPendingPayment: 'PAGAMENTO IN SOSPESO',
      statusClosed: 'CHIUSO',
      statusUpcoming: 'IN ARRIVO',
      statusOpen: 'APERTO',
      checkScores: 'Vedi punteggi',
      viewGameweekScores: 'Vedi punteggi gameweek',
      viewTournamentScores: 'Vedi punteggi torneo',
      availableTournaments: '{count} tornei disponibili',
      participants: '{count} partecipanti',
      free: 'Gratis',
      registered: 'Registrato',
      editFormation: 'Modifica formazione',
      enter: 'Entra',
      entriesClosed: 'GameWeek in corso - iscrizioni chiuse',
      starts: 'Inizio',
      ends: 'Fine',
      countdownFormationLocksIn: 'Formazione bloccata tra',
      countdownFormationLocked: 'Formazione bloccata',
      countdownStartsIn: 'Inizia tra',
      countdownEndsIn: 'Finisce tra',
      countdownEnded: 'Terminato',
      buyIn: 'Quota',
      buyInAmount: '{amount} DIOS',
      gameweekPricing: 'Basic: Gratis | Plus: 5 | Rare: 10 | Epic: 25 | Unique: 50 DIOS',
      rarityLabel: 'Rarità',
      rarityBasic: 'Basic',
      inProgressClosed: 'In corso - iscrizioni chiuse',
      joinGameweek: 'Partecipa alla GameWeek',
      joinFreeGameweek: 'Partecipa alla GameWeek gratuita',
      enterTournament: 'Entra nel torneo',
      joinFree: 'Partecipa gratis',
      prizePool: 'Montepremi',
      prize: 'Premio'
    },
    notifications: {
      title: 'Notifiche',
      markAllRead: 'Segna tutte come lette',
      noNotifications: 'Nessuna notifica',
      ariaLabel: 'Notifiche',
      justNow: 'Adesso',
      minutesAgo: '{count}m fa',
      hoursAgo: '{count}h fa',
      daysAgo: '{count}g fa'
    },
    profile: {
      tabs: {
        myCards: 'My Cards',
        soldLoans: 'Vendute & Prestiti',
        activityReport: 'Report attività',
        offers: 'Offerte',
        referrals: 'Referral',
        loginHistory: 'Login History',
        security: 'Security',
        notifications: 'Notifiche',
        settings: 'Impostazioni'
      }
    },
    activityReport: {
      title: 'Report attività',
      last7Days: 'Ultimi 7 giorni',
      downloadCsv: 'Scarica CSV',
      loading: 'Caricamento attività...',
      empty: 'Nessuna attività negli ultimi 7 giorni.',
      category: {
        deposit: 'Deposito',
        withdrawal: 'Prelievo',
        prize: 'Premio',
        marketplace: 'Marketplace'
      },
      action: {
        deposit: 'Deposito',
        withdrawal: 'Prelievo',
        purchase: 'Acquisto',
        sale: 'Vendita',
        loanBorrow: 'Prestito (in)',
        loanLend: 'Prestito (out)',
        gameweekPrize: 'Premio Gameweek'
      }
    },
    cardsStatus: {
      cardsForSale: 'Carte in vendita',
      soldCards: 'Carte vendute',
      loanedCards: 'Prestiti concessi',
      borrowedCards: 'Carte prese in prestito',
      forSaleLabel: 'In vendita',
      soldLabel: 'Venduta',
      loanedLabel: 'In prestito',
      borrowedLabel: 'Presa in prestito',
      listedDate: 'Inserita',
      saleDate: 'Data vendita',
      startDate: 'Data inizio',
      duration: 'Durata: {count} GW',
      emptyCardsForSale: 'Nessuna carta in vendita.',
      emptySold: 'Nessuna carta venduta.',
      emptyLoaned: 'Nessun prestito concesso.',
      emptyBorrowed: 'Nessuna carta in prestito attivo.',
      removeFromSale: 'Rimuovi da vendita',
      confirmRemoveFromSale: 'Rimuovere questa carta dalla vendita?',
      removeFromSaleFailed: 'Impossibile rimuovere dalla vendita',
      listedLoans: 'Prestiti in attesa',
      listedLoanLabel: 'In prestito',
      emptyListedLoans: 'Nessun prestito in attesa di borrower.',
      removeFromLoan: 'Rimuovi',
      confirmRemoveFromLoan: 'Rimuovere questa carta dal prestito?',
      removeFromLoanFailed: 'Impossibile rimuovere dal prestito',
      cannotRemovePeriodLoan: 'Non puoi rimuovere: almeno un periodo è già stato preso.',
      periodListingDetail: '{price} D10S/periodo · restano {remaining}/{total} ({used} usati)',
      periodActiveDetail: '{price} D10S/periodo · periodo {current}/{total} in uso ({borrower})',
      periodInUse: 'Periodo {current}/{total} in uso',
      pricePerPeriodLabel: 'Prezzo per periodo',
      savePeriodPrice: 'Salva prezzo',
      invalidPeriodPrice: 'Inserisci un prezzo valido',
      updatePeriodPriceFailed: 'Impossibile aggiornare il prezzo'
    },
    loginHistory: {
      title: 'Cronologia login',
      total: 'Totale: {count}',
      loading: 'Caricamento login...',
      empty: 'Nessun login trovato',
      success: 'Successo',
      failed: 'Fallito',
      reason: 'Motivo',
      ip: 'IP',
      location: 'Luogo'
    },
    security: {
      titleSecurity: 'Report sicurezza',
      titleSupport: 'Ticket supporto',
      total: 'Totale: {count}',
      reportIssue: 'Segnala problema',
      createFirst: 'Crea il primo report',
      loadingSecurity: 'Caricamento report sicurezza...',
      loadingSupport: 'Caricamento ticket supporto...',
      emptySecurity: 'Nessun report sicurezza trovato',
      emptySupport: 'Nessun ticket supporto trovato',
      sectionSecurity: 'Report sicurezza',
      sectionSupport: 'Ticket supporto',
      created: 'Creato',
      resolved: 'Risolto',
      adminNotes: 'Note admin',
      botReply: 'Risposta bot',
      reportModalTitle: 'Segnala problema di sicurezza',
      reportType: 'Tipo segnalazione',
      priority: 'Priorità',
      title: 'Titolo',
      description: 'Descrizione',
      titlePlaceholder: 'Breve descrizione',
      descriptionPlaceholder: 'Descrizione dettagliata del problema di sicurezza',
      reportTypeOptions: {
        accountCompromise: 'Account compromesso',
        suspiciousActivity: 'Attività sospetta',
        phishing: 'Phishing',
        unauthorizedAccess: 'Accesso non autorizzato',
        other: 'Altro'
      },
      priorityOptions: {
        low: 'Bassa',
        medium: 'Media',
        high: 'Alta',
        critical: 'Critica'
      },
      openSupportTicket: 'Apri ticket supporto',
      supportTicketModalTitle: 'Nuovo ticket supporto',
      supportSubject: 'Oggetto (facoltativo)',
      supportSubjectPlaceholder: 'Breve titolo (facoltativo)',
      supportMessage: 'Messaggio',
      supportMessagePlaceholder: 'Descrivi la tua richiesta in dettaglio.',
      submitSupportTicket: 'Invia ticket',
      supportTicketError: 'Impossibile aprire il ticket. Riprova.',
      submit: 'Invia segnalazione',
      cancel: 'Annulla'
    },
    notificationsTab: {
      maintenanceTitle: 'Avvisi manutenzione',
      announcementsTitle: 'Annunci di sistema',
      personalTitle: 'Notifiche personali',
      unread: '{count} non lette',
      markAllRead: 'Segna tutte come lette',
      noMaintenance: 'Nessun avviso manutenzione',
      noAnnouncements: 'Nessun annuncio',
      noPersonal: 'Nessuna notifica',
      clickToView: 'Clicca per vedere →',
      scheduled: 'Programmato',
      affects: 'Riguarda'
    },
    gdpr: {
      bannerTitle: 'Privacy e Cookie',
      bannerDescription: 'Utilizziamo cookie e tecnologie simili per far funzionare il sito, migliorare la tua esperienza e personalizzare i contenuti. Puoi accettare tutto, rifiutare i cookie opzionali o personalizzare le tue scelte.',
      acceptAll: 'Accetta tutto',
      rejectOptional: 'Rifiuta opzionali',
      customize: 'Personalizza',
      preferencesTitle: 'Preferenze cookie',
      preferencesIntro: 'Scegli quali categorie di cookie consentire. I cookie necessari sono obbligatori per il funzionamento del sito e non possono essere disattivati.',
      necessary: 'Necessari',
      necessaryDesc: 'Indispensabili per il funzionamento del sito (es. sessione, sicurezza).',
      analytics: 'Analitici',
      analyticsDesc: 'Ci aiutano a capire come usi il sito per migliorarlo.',
      preferencesCat: 'Preferenze',
      preferencesDesc: 'Memorizzano le tue impostazioni e preferenze.',
      marketing: 'Marketing',
      marketingDesc: 'Utilizzati per pubblicità e marketing pertinenti (se ne facciamo uso).',
      alwaysOn: 'Sempre attivi',
      savePreferences: 'Salva preferenze',
      cookiePreferencesLink: 'Preferenze cookie'
    },
    legal: {
      platformOwner: 'The platform owner is Uilliam Dettori.'
    },
    settingsExtra: {
      walletAssociatedLabel: 'Wallet associato al tuo account:',
      walletConnectedLabel: 'Wallet attualmente connesso:',
      walletMismatchTitle: 'Wallet non corrispondente',
      walletMismatchBody: 'Il wallet connesso non corrisponde a quello associato al tuo account. Connetti il wallet corretto per utilizzare tutte le funzionalità.',
      walletConnected: 'Wallet connesso',
      walletSaveSuccess: 'Wallet associato con successo al tuo account!',
      walletSaveError: 'Errore nel salvare il wallet: {message}',
      walletConnectError: 'Errore nel collegare il wallet: {message}',
      saveWallet: 'Associa questo wallet al tuo account',
      saveWalletConfirm: 'Sì, associa wallet',
      savingWallet: 'Salvataggio...',
      walletMobileHint: 'Su mobile: quando si apre la schermata, scegli l\'app del wallet o scansiona il codice QR.',
      walletConnectedReadyInfo: 'Puoi usare questo wallet per depositi e prelievi. Non serve connetterlo di nuovo.',
      walletModalTitle: 'Wallet connesso',
      walletModalConnectedSuccess: 'Wallet connesso con successo:',
      walletModalQuestion: 'Vuoi associare questo wallet al tuo account? In questo modo potrai usarlo per le transazioni future.',
      walletModalSkip: 'No, salta'
    },
    supportWidget: {
      buttonOpen: 'Aiuto',
      title: 'Supporto',
      closeAria: 'Chiudi',
      sendAria: 'Invia',
      openTelegram: 'Apri Telegram',
      loadingReply: 'Sto cercando una risposta...',
      escalateAction: 'Apri ticket supporto',
      inputPlaceholder: 'Scrivi qui...',
      welcomeMessage: 'Posso aiutarti con depositi, prelievi, marketplace, aste, pack, tornei, referral o account. Se non risolvo, posso passarti a un operatore oppure puoi contattarlo direttamente su Telegram.',
      fallbackNotUnderstood: 'Non ho capito. Vuoi parlare con un operatore?',
      temporaryError: 'Errore temporaneo. Riprova o parla con un operatore.',
      loginRequired: 'Per aprire un ticket supporto devi effettuare il login.',
      writeRequestHint: 'Scrivi la tua richiesta nel campo qui sotto e tocca di nuovo "Apri ticket supporto", oppure invia prima un messaggio al bot.',
      escalatedTicket: 'Ho inoltrato la richiesta a un operatore. Ticket #{ticketId}',
      escalateFailed: 'Non riesco a contattare un operatore. Riprova tra poco.',
      quickHome: 'Home',
      quickMarketplace: 'Mercato',
      quickTournaments: 'Tornei',
      quickRankings: 'Classifiche',
      quickDeposit: 'Deposito',
      quickProfile: 'Profilo'
    },
    depositPage: {
      title: 'Deposito',
      chooseMethod: 'Scegli come depositare',
      methodBonifico: 'Bonifico ordinario',
      methodPostepay: 'Ricarica Postepay',
      bonificoTitle: 'Bonifico ordinario',
      bonificoLead: 'Effettua un bonifico SEPA sull\'IBAN indicato. Nella causale inserisci il tuo ',
      usernameEmphasis: 'username DIOS',
      bonificoTail: ' così possiamo abbinare il pagamento. 1 EUR = 1 DIOS. L\'accredito non è automatico: verrà verificato manualmente.',
      postepayTitle: 'Ricarica Postepay',
      postepayLead: 'Usa i dati qui sotto per la ricarica. ',
      postepayCausaleLabel: 'Causale:',
      postepayMid: ' indica il tuo ',
      postepayTail: ' (stesso con cui accedi). L\'accredito non è automatico: verrà verificato manualmente.',
      labelIban: 'IBAN',
      labelAccountHolder: 'Intestatario',
      labelCardNumber: 'Numero carta',
      labelExpiry: 'Scadenza',
      labelFiscalCode: 'Codice fiscale (intestatario)',
      copyIban: 'Copia IBAN',
      copy: 'Copia',
      copyNumber: 'Copia numero',
      copyFiscalCode: 'Copia CF',
      copied: 'Copiato ✓',
      stripeUnavailableTitle: 'Non disponibile al momento'
    },
    confirmD10S: {
      first: 'Stai per spendere {amount} DIOS per: {action}. Vuoi continuare?',
      second: 'Conferma di nuovo per procedere.',
      actionDeposit: 'Deposito',
      actionWithdraw: 'Prelievo',
      actionListSale: 'Metti in vendita',
      actionListLoan: 'Metti in prestito',
      firstListSale: 'Stai per mettere in vendita questa carta al prezzo di {amount} DIOS. Vuoi continuare?',
      firstListLoan: 'Stai per mettere in prestito questa carta (totale {amount} DIOS). Vuoi continuare?',
      titleFirst: 'Conferma operazione',
      titleSecond: 'Conferma definitiva',
      confirmContinue: 'Continua',
      confirmFinal: 'Sì, procedi'
    }
  };

const es = {
  common: {
    language: 'Idioma',
    save: 'Guardar ajustes',
    saving: 'Guardando...',
    continue: 'Continuar',
    search: 'Buscar',
    cancel: 'Cancelar',
    previous: 'Anterior',
    next: 'Siguiente',
    pageOf: 'Página {page} de {total}',
    loading: 'Cargando...',
    notAvailable: 'N/D',
    unknown: 'Desconocido',
    processing: 'Procesando...'
  },
  onboarding: {
    chooseLanguageTitle: 'Elige tu idioma',
    chooseLanguageSubtitle: 'Selecciona tu idioma preferido para el juego',
    savingLanguage: 'Guardando...'
  },
  navbar: {
    searchPlaceholder: 'Buscar jugador por nombre...',
    searchAriaLabel: 'Buscar',
    searching: 'Buscando...',
    noResults: 'Sin resultados',
    totalCards: 'Total de cartas',
    company: 'Empresa',
    errorSearch: 'Error de búsqueda',
    signIn: 'Iniciar sesión',
    register: 'Registrarse',
    adminPanel: 'Panel de administración',
    rules: 'Reglamento',
    musicMute: 'Desactivar música de fondo',
    musicUnmute: 'Activar música de fondo'
  },
  rules: {
    mobileTitle: 'Reglamento DIOS10',
    mobileDesc: 'En móvil abre el PDF en el navegador para una lectura óptima.',
    openPdf: 'Abrir PDF en navegador'
  },
  auth: {
    signIn: 'Iniciar sesión',
    signingIn: 'Iniciando sesión...',
    email: 'Correo electrónico',
    password: 'Contraseña',
    forgotPassword: '¿Olvidaste tu contraseña?',
    noAccount: '¿No tienes una cuenta?',
    registerNow: 'Regístrate ahora',
    fillAllFields: 'Completa todos los campos',
    loginFailed: 'Inicio de sesión fallido. Revisa tus credenciales.',
    emailVerified: 'E-mail verificada. Ya puedes iniciar sesión.',
    emailVerifiedInvalid: 'Enlace de verificación no válido o caducado.',
    createAccount: 'Crea tu cuenta',
    chooseUsername: 'Elige tu nombre de usuario',
    username: 'Nombre de usuario',
    confirmPassword: 'Confirmar contraseña',
    referralCode: 'Código de referido (opcional)',
    referralPlaceholder: 'Introduce el código de referido si tienes uno',
    confirmPasswordPlaceholder: 'Confirma tu contraseña',
    minimumCharacters: 'Mínimo 6 caracteres',
    creatingAccount: 'Creando cuenta...',
    startJourney: 'Comienza tu aventura',
    alreadyAccount: '¿Ya tienes una cuenta?',
    terms: 'Al registrarte, aceptas nuestros Términos de servicio',
    passwordMismatch: 'Las contraseñas no coinciden',
    passwordShort: 'La contraseña debe tener al menos 6 caracteres',
    registrationPending: 'Registro pendiente. Verifica tu email con el enlace que te hemos enviado. No puedes iniciar sesión hasta verificar tu email.',
    registrationSuccess: 'Registro completado. Ya puedes iniciar sesión.',
    registrationFailed: 'Registro fallido. Inténtalo de nuevo.',
    forgotTitle: '¿Olvidaste tu contraseña?',
    forgotSubtitle: 'Introduce tu correo electrónico y te enviaremos un enlace para restablecer tu contraseña.',
    sendResetLink: 'Enviar enlace de restablecimiento',
    sending: 'Enviando...',
    resetToken: 'Token de restablecimiento',
    setNewPassword: 'Establecer nueva contraseña',
    newPassword: 'Nueva contraseña',
    confirmNewPassword: 'Confirmar nueva contraseña',
    resetPassword: 'Restablecer contraseña',
    resetting: 'Restableciendo...',
    resetTokenRequired: 'Se requiere el token de restablecimiento',
    resetPasswordShort: 'La contraseña debe tener al menos 8 caracteres',
    resetSuccess: '¡Contraseña restablecida! Redirigiendo al login...',
    resetFailed: 'No se pudo restablecer la contraseña. El token puede ser inválido o estar caducado.',
    requestResetSuccess: 'Si este correo existe, se ha enviado un enlace de restablecimiento.',
    requestResetToken: '¡Enlace enviado! Token: {token} (Copia este token para pruebas)',
    addToHomeTitle: 'Añadir a pantalla de inicio',
    addToHomeMessage: 'Esta app funciona mejor como aplicación. Guarda la app en la pantalla de inicio de tu teléfono para la mejor experiencia.',
    addToHomeButton: 'Guardar en pantalla de inicio',
    addToHomeDontShowAgain: 'No mostrar más este mensaje',
    addToHomeGotIt: 'Entendido',
    addToHomeStepsSafari: 'En Safari: 1) Toca el botón Compartir (cuadrado con flecha) abajo. 2) Desliza y selecciona "Añadir a la pantalla de inicio". 3) Toca "Añadir".',
    addToHomeStepsChrome: 'En Chrome: 1) Toca el icono Compartir (o menú de 3 puntos) en la barra de direcciones. 2) Selecciona "Añadir a la pantalla de inicio". 3) Toca "Añadir".',
    addToHomeStepsFirefox: 'En Firefox: 1) Toca el icono Compartir en la barra de direcciones. 2) Selecciona "Añadir a la pantalla de inicio". 3) Toca "Añadir".',
    addToHomeStepsEdge: 'En Edge: 1) Toca el icono Compartir (o menú de 3 puntos) en la barra de direcciones. 2) Selecciona "Añadir a la pantalla de inicio". 3) Toca "Añadir".',
    addToHomeStepsSamsung: 'En Samsung Internet: 1) Toca el menú (3 líneas). 2) Selecciona "Añadir página a" > "Pantalla de inicio". 3) Toca "Añadir".',
    addToHomeStepsOpera: 'En Opera: 1) Toca el icono de menú. 2) Selecciona "Añadir a la pantalla de inicio". 3) Toca "Añadir".',
    addToHomeStepsDefault: '1) Toca el icono Compartir o menú del navegador. 2) Busca "Añadir a la pantalla de inicio" o similar. 3) Toca "Añadir".'
  },
  home: {
    marketplace: 'MERCADO',
    tournaments: 'TORNEOS',
    rankings: 'CLASIFICACIONES',
    marketplaceDesc: 'Compra y vende cartas',
    tournamentsDesc: 'Compite en GameWeeks',
    rankingsDesc: 'Clasificaciones',
    activeGameweeks: 'GAMEWEEKS ACTIVAS',
    tournamentsCount: '{count} Torneos'
  },
  settings: {
    title: 'Ajustes',
    walletConnection: 'Conexión de wallet',
    walletConnected: 'Conectado',
    connectWallet: 'Conectar wallet',
    disconnectWallet: 'Desconectar',
    connecting: 'Conectando...',
    languageLabel: 'Idioma',
    tutorialCompleted: 'Tutorial completado',
    soundsEnabled: 'Efectos de sonido',
    soundsEnabledDesc: 'Reproducir sonidos al hacer clic y durante las acciones del juego',
    musicEnabled: 'Música de fondo',
    musicEnabledDesc: 'Reproducir música de fondo después del inicio de sesión',
    musicVolume: 'Volumen de música',
    musicVolumeMobile: 'En móvil, el volumen se controla desde el dispositivo.',
    accountTitle: 'Cuenta',
    logout: 'Cerrar sesión',
    saveSuccess: 'Ajustes guardados correctamente.',
    saveFailed: 'No se pudieron guardar los ajustes.',
    passwordSectionTitle: 'Restablecer contraseña',
    currentPassword: 'Contraseña actual',
    currentPasswordPlaceholder: 'Introduce tu contraseña actual',
    newPassword: 'Nueva contraseña',
    newPasswordPlaceholder: 'Introduce tu nueva contraseña',
    confirmNewPassword: 'Confirmar nueva contraseña',
    confirmNewPasswordPlaceholder: 'Repite tu nueva contraseña',
    changePassword: 'Confirmar cambio de contraseña',
    changingPassword: 'Actualizando contraseña...',
    passwordFillAllFields: 'Completa todos los campos de la contraseña.',
    passwordMinLength: 'La nueva contraseña debe tener al menos 8 caracteres.',
    passwordMismatch: 'Las nuevas contraseñas no coinciden.',
    passwordMustDiffer: 'La nueva contraseña debe ser diferente de la actual.',
    passwordChangeSuccess: 'Contraseña actualizada correctamente.',
    passwordChangeFailed: 'No se pudo actualizar la contraseña.'
  },
  rankings: {
    title: 'Clasificaciones',
    gameweekSectionTitle: 'Clasificaciones GameWeek',
    gameweekSectionDesc: 'Clasificación oficial de cada torneo GameWeek: posición, puntuación final y premio. Elige torneo y categoría (Basic, Plus, Rare, Epic, Unique) en el menú.',
    monthlySectionTitle: 'Clasificaciones mensuales',
    monthlySectionDesc: 'Clasificaciones oficiales publicadas por la plataforma: la puntuación es la suma de los resultados de las GameWeek del periodo (misma categoría).',
    monthlySelectTitle: 'Elegir clasificación mensual',
    monthlySelectPlaceholder: 'Selecciona una clasificación mensual...',
    monthlyEmptyHint: 'Aún no hay clasificación mensual publicada. Se publican al final de cada periodo.',
    monthlyEmptyTable: 'No hay datos para esta clasificación mensual',
    monthlyCategoryLabel: 'Categoría',
    monthlyCategoryGlobal: 'Global',
    monthlyPrizePoolLabel: 'Bote de premios',
    selectTitle: 'Elegir torneo GameWeek',
    selectPlaceholder: 'Selecciona un torneo GameWeek...',
    emptyHint: 'No hay clasificaciones GameWeek disponibles. Aparecen cuando un torneo tiene puntuaciones calculadas.',
    loading: 'Cargando clasificaciones...',
    typeLabel: 'Tipo',
    tableRank: 'Posición',
    tablePlayer: 'Jugador',
    tableScore: 'Puntuación',
    tablePrize: 'Premio',
    emptyTable: 'No hay clasificaciones disponibles',
    provisionalLabel: 'Clasificación no definitiva',
    topRefTitle: 'Clasificación de Referrals',
    topRefDesc: 'Mejores referrers por ganancias de usuarios invitados. Elige el período a mostrar.',
    topRefPeriodLabel: 'Período de referencia',
    topRefColReferrals: 'Usuarios invitados',
    topRefColEarnings: 'Ganancias (DIOS)',
    topRefEmpty: 'Aún no hay referrers en este período',
    topRefPeriodAll: 'Todo el tiempo',
    topRefPeriodMonthly: 'Mensual',
    topRefPeriodSemestral: 'Este semestre',
    topRefPeriodAnnual: 'Anual',
    topRefSelectMonth: 'Seleccionar mes',
    topRefSelectYear: 'Seleccionar año'
  },
  marketplace: {
    title: 'Mercado',
    balanceLabel: 'Tu saldo',
    tabsAuctions: 'Subastas',
    tabsPacks: 'Packs',
    tabsSales: 'Compra ya',
    tabsLoans: 'Préstamos',
    tabsTrades: 'Carta por carta',
    filtersTitle: 'Buscar y filtros',
    resetFilters: 'Restablecer filtros',
    auctionStatusOpen: 'Abiertas',
    auctionStatusClosed: 'Cerradas',
    auctionStatusClosedHint: 'Aquí ves subastas expiradas en proceso: el tiempo terminó pero la subasta aún no se ha cerrado y la carta no ha sido asignada.',
    searchPlayerLabel: 'Buscar jugador',
    searchPlayerPlaceholder: 'Introduce el nombre del jugador...',
    rarityLabel: 'Rareza',
    allRarities: 'Todas las rarezas',
    rarityBasic: 'Basic',
    rarityPlus: 'Plus',
    rarityRare: 'Rare',
    rarityEpic: 'Epic',
    rarityUnique: 'Unique',
    positionLabel: 'Posición',
    allPositions: 'Todas las posiciones',
    positionGK: 'Portero',
    positionDEF: 'Defensor',
    positionMID: 'Centrocampista',
    positionATT: 'Delantero',
    nationalityLabel: 'Nacionalidad',
    nationalityPlaceholder: 'p. ej. Italia',
    teamLabel: 'Equipo',
    teamPlaceholder: 'p. ej. Real Madrid',
    leagueLabel: 'Liga',
    leaguePlaceholder: 'p. ej. Serie A',
    ageMinLabel: 'Edad mín',
    ageMinPlaceholder: 'p. ej. 18',
    ageMaxLabel: 'Edad máx',
    ageMaxPlaceholder: 'p. ej. 35',
    xpMinLabel: 'XP mín',
    xpMinPlaceholder: 'p. ej. 5',
    xpMaxLabel: 'XP máx',
    xpMaxPlaceholder: 'p. ej. 20',
    auctionsInfoTitle: 'Info subastas',
    auctionsInfoBody: 'Las subastas se finalizan cada 10 minutos. Si ganas, la asignación de la carta puede tardar hasta 10 minutos.',
    secondaryMarketFilterNotice: 'Actualmente solo se muestran cartas Divinity y Legend (Entrenador) en el mercado secundario.',
    bidSuccess: '✅ ¡Oferta realizada! Tu oferta está activa.',
    purchaseSuccess: '✅ ¡Carta comprada! Revisa tu colección.',
    packSuccess: '✅ ¡Pack abierto! Nuevas cartas añadidas a tu colección.',
    loanSuccess: '✅ ¡Préstamo aceptado! La carta ya está en tu colección.',
    tradeAcceptSuccess: '✅ ¡Intercambio aceptado! Cartas intercambiadas.',
    tradeRejectSuccess: '✅ Intercambio rechazado',
    counterOfferSuccess: '✅ ¡Contraoferta enviada! El propietario la verá en sus ofertas.',
    emptyAuctionsTitle: 'No hay subastas activas',
    emptyAuctionsBody: 'Vuelve más tarde para nuevas subastas',
    emptySalesTitle: 'No hay cartas disponibles',
    emptySalesBody: 'No hay cartas actualmente en venta',
    emptyPacksTitle: 'No hay packs disponibles',
    emptyPacksBody: 'Los packs estarán disponibles pronto',
    emptyLoansTitle: 'No hay préstamos disponibles',
    emptyLoansBody: 'No hay cartas disponibles para préstamo',
    emptyTradesTitle: 'No hay intercambios abiertos',
    emptyTradesBody: 'No hay intercambios disponibles en este momento. ¡Crea uno desde tus cartas!'
  },
  marketplaceCards: {
    ended: 'Finalizada',
    auctionBadge: 'Subasta',
    viewCopiesAria: 'Ver {count} copias',
    playerAlt: 'Jugador',
    positionLabel: 'Posición',
    teamLabel: 'Equipo',
    rarityLabel: 'Rareza',
    xpLevelLabel: 'Nivel de XP',
    currentBidLabel: 'Oferta actual',
    currentWinnerLabel: 'Ganador actual',
    minBidLabel: 'Oferta mínima',
    bidAmountLabel: 'Tu oferta',
    bidPlaceholder: 'Introduce oferta (mín: {amount} DIOS)',
    placingBid: 'Enviando...',
    auctionExtending: 'Actualizando temporizador...',
    placeBid: 'Hacer oferta',
    quickBid: 'Oferta rápida',
    multipleCopiesHint: 'Hay varias copias disponibles. Selecciona una copia para ofertar.',
    viewCopiesBid: 'Ver copias y ofertar',
    loginToBid: 'Inicia sesión para ofertar',
    bidMinError: 'La oferta debe ser al menos {amount} DIOS',
    bidFailed: 'No se pudo hacer la oferta',
    bidAuctionUpdated: 'La subasta se ha actualizado: nuevo mejor postor y nuevo valor. Oferta mínima ahora {amount} DIOS. Actualiza e inténtalo de nuevo.',
    bidOfferMinButton: 'Oferta {amount} D10S',
    copiesLoadFailed: 'No se pudieron cargar las copias',
    availableCopies: 'Copias disponibles ({count})',
    loadingCopies: 'Cargando copias...',
    noCopies: 'No hay copias disponibles.',
    auctionNumber: 'Subasta #{id}',
    none: '—',
    bidMin: 'Oferta mín',
    customBidPlaceholder: 'Personalizada (mín {amount})',
    loginToPurchase: 'Inicia sesión para comprar',
    purchaseOwnCard: 'No puedes comprar tu propia carta',
    purchaseFailed: 'No se pudo comprar la carta',
    buyNowBadge: 'Compra ya',
    priceLabel: 'Precio',
    processing: 'Procesando...',
    buyNowAction: 'Comprar ahora',
    loginToOpenPack: 'Inicia sesión para abrir packs',
    openPackFailed: 'No se pudo abrir el pack',
    packDescriptionFallback: '¡Descubre cartas increíbles dentro de este pack!',
    openingPack: 'Abriendo pack...',
    openPack: 'Abrir pack',
    packQuantity: 'Cantidad',
    packQuantityLabel: 'Packs a comprar',
    openingOnePack: 'apertura de 1 pack',
    openingPacksCount: 'apertura de {count} packs',
    nextPack: 'Siguiente pack',
    skipOpening: 'Omitir',
    cardsAssignedSummary: '{count} cartas añadidas a tu colección.',
    viewInProfile: 'Ver en Perfil',
    loginToAcceptLoan: 'Inicia sesión para aceptar préstamos',
    acceptOwnLoan: 'No puedes aceptar tu propio préstamo',
    acceptLoanFailed: 'No se pudo aceptar el préstamo',
    loanBadge: 'Préstamo',
    pricePerGameweek: 'Precio por Gameweek',
    durationLabel: 'Duración',
    gameweeks: '{count} Gameweeks',
    totalCost: 'Costo total',
    acceptLoan: 'Aceptar préstamo'
  },
  trade: {
    loginToAccept: 'Inicia sesión para aceptar intercambios',
    noRequestedCardAvailable: 'No tienes la carta solicitada disponible para el intercambio',
    noRequestedCard: 'No tienes la carta solicitada',
    loadCardsFailed: 'No se pudieron cargar tus cartas',
    acceptFailed: 'No se pudo aceptar el intercambio',
    loginToReject: 'Inicia sesión para rechazar intercambios',
    rejectFailed: 'No se pudo rechazar el intercambio',
    loginToCounter: 'Inicia sesión para hacer contraofertas',
    noCardsForCounter: 'No hay cartas disponibles para contraoferta',
    selectCardForCounter: 'Selecciona una carta para la contraoferta',
    createCounterFailed: 'No se pudo crear la contraoferta',
    openTrade: 'Intercambio abierto',
    offerFrom: 'Oferta de intercambio de {username}',
    byUser: 'Por: {username}',
    expires: 'Caduca: {date}',
    theyOffer: 'Ellos ofrecen',
    theyWant: 'Ellos quieren',
    youGive: 'Tú das',
    unknownPlayer: 'Jugador desconocido',
    unknownRarity: 'Rareza desconocida',
    accept: 'Aceptar intercambio',
    makeCounter: 'Hacer contraoferta',
    counterOffer: 'Contraoferta',
    reject: 'Rechazar',
    ownerHint: 'Esta es tu oferta de intercambio. Espera a que otros acepten o hagan contraofertas.',
    selectCardTitle: 'Selecciona carta para intercambiar',
    youWillReceive: 'Recibirás',
    youWillGive: 'Darás',
    selectWhichCard: 'Selecciona qué carta intercambiar:',
    makeCounterTitle: 'Hacer contraoferta',
    counterHint: 'No tienes la carta solicitada, pero puedes ofrecer una de tus cartas.',
    selectCardToOffer: 'Selecciona una carta para ofrecer:',
    selectCardPlaceholder: '-- Selecciona una carta --',
    sendCounter: 'Enviar contraoferta',
    sending: 'Enviando...',
    counterOfferTitle: 'Contraoferta',
    youWant: 'Tú quieres',
    yourCard: 'Tu carta',
    theirCard: 'Su carta',
    selectCardInstead: 'Selecciona una carta para ofrecer en su lugar:',
    creating: 'Creando...'
  },
  tournaments: {
    title: 'GameWeeks y Torneos',
    create: 'Crear torneo',
    filterTitle: 'Filtrar por tipo',
    filterAll: 'Todos',
    filterGameweek: 'GameWeeks',
    filterPrivate: 'Privados',
    filterThematic: 'Temáticos',
    loading: 'Cargando torneos...',
    emptyGameweeks: 'No hay GameWeeks activas en este momento',
    emptyTournaments: 'No hay torneos disponibles',
    statusInProgress: 'EN CURSO',
    statusPendingPayment: 'PAGO PENDIENTE',
    statusClosed: 'CERRADO',
    statusUpcoming: 'PRÓXIMO',
    statusOpen: 'ABIERTO',
    checkScores: 'Ver puntuaciones',
    viewGameweekScores: 'Ver puntuaciones de gameweek',
    viewTournamentScores: 'Ver puntuaciones del torneo',
    availableTournaments: '{count} Torneos disponibles',
    participants: '{count} participantes',
    free: 'Gratis',
    registered: 'Registrado',
    editFormation: 'Editar formación',
    enter: 'Entrar',
    entriesClosed: 'GameWeek en curso - inscripciones cerradas',
    starts: 'Empieza',
    ends: 'Fin',
    countdownFormationLocksIn: 'Formación bloqueada en',
    countdownFormationLocked: 'Formación bloqueada',
    countdownStartsIn: 'Empieza en',
    countdownEndsIn: 'Termina en',
    countdownEnded: 'Terminado',
    buyIn: 'Cuota',
    buyInAmount: '{amount} DIOS',
    gameweekPricing: 'Basic: Gratis | Plus: 5 | Rare: 10 | Epic: 25 | Unique: 50 DIOS',
    rarityLabel: 'Rareza',
    rarityBasic: 'Basic',
    inProgressClosed: 'En curso - inscripciones cerradas',
    joinGameweek: 'Unirse a GameWeek',
    joinFreeGameweek: 'Unirse a GameWeek gratuita',
    enterTournament: 'Entrar al torneo',
    joinFree: 'Entrar gratis',
    prizePool: 'Premio total',
    prize: 'Premio'
  },
  notifications: {
    title: 'Notificaciones',
    markAllRead: 'Marcar todas como leídas',
    noNotifications: 'Sin notificaciones',
    ariaLabel: 'Notificaciones',
    justNow: 'Ahora mismo',
    minutesAgo: 'hace {count}m',
    hoursAgo: 'hace {count}h',
    daysAgo: 'hace {count}d'
  },
  profile: {
    tabs: {
      myCards: 'Mis cartas',
      soldLoans: 'Vendidas y préstamos',
      activityReport: 'Reporte de actividad',
      offers: 'Ofertas',
      referrals: 'Referidos',
      loginHistory: 'Historial de login',
      security: 'Seguridad',
      notifications: 'Notificaciones',
      settings: 'Ajustes'
    }
  },
  activityReport: {
    title: 'Reporte de actividad',
    last7Days: 'Últimos 7 días',
    downloadCsv: 'Descargar CSV',
    loading: 'Cargando actividad...',
    empty: 'No hay actividad en los últimos 7 días.',
    category: {
      deposit: 'Depósito',
      withdrawal: 'Retiro',
      prize: 'Premio',
      marketplace: 'Marketplace'
    },
    action: {
      deposit: 'Depósito',
      withdrawal: 'Retiro',
      purchase: 'Compra',
      sale: 'Venta',
      loanBorrow: 'Préstamo (recibir)',
      loanLend: 'Préstamo (prestar)',
      gameweekPrize: 'Premio Gameweek'
    }
  },
  cardsStatus: {
    cardsForSale: 'Cartas en venta',
    soldCards: 'Cartas vendidas',
    loanedCards: 'Préstamos concedidos',
    borrowedCards: 'Cartas prestadas',
    forSaleLabel: 'En venta',
    soldLabel: 'Vendida',
    loanedLabel: 'En préstamo',
    borrowedLabel: 'Prestada',
    listedDate: 'Publicada',
    saleDate: 'Fecha de venta',
    startDate: 'Fecha de inicio',
    duration: 'Duración: {count} GW',
    emptyCardsForSale: 'No hay cartas en venta.',
    emptySold: 'No hay cartas vendidas.',
    emptyLoaned: 'No hay préstamos concedidos.',
    emptyBorrowed: 'No hay cartas prestadas activas.',
    removeFromSale: 'Quitar de venta',
    confirmRemoveFromSale: '¿Quitar esta carta de la venta?',
    removeFromSaleFailed: 'No se pudo quitar de la venta'
  },
  loginHistory: {
    title: 'Historial de inicio de sesión',
    total: 'Total: {count}',
    loading: 'Cargando historial de login...',
    empty: 'No se encontró historial de login',
    success: 'Éxito',
    failed: 'Fallido',
    reason: 'Motivo',
    ip: 'IP',
    location: 'Lugar'
  },
  security: {
    titleSecurity: 'Reportes de seguridad',
    titleSupport: 'Tickets de soporte',
    total: 'Total: {count}',
    reportIssue: 'Reportar problema',
    createFirst: 'Crear primer reporte',
    loadingSecurity: 'Cargando reportes de seguridad...',
    loadingSupport: 'Cargando tickets de soporte...',
    emptySecurity: 'No se encontraron reportes de seguridad',
    emptySupport: 'No se encontraron tickets de soporte',
    sectionSecurity: 'Reportes de seguridad',
    sectionSupport: 'Tickets de soporte',
    created: 'Creado',
    resolved: 'Resuelto',
    adminNotes: 'Notas del admin',
    botReply: 'Respuesta del bot',
    reportModalTitle: 'Reportar problema de seguridad',
    reportType: 'Tipo de reporte',
    priority: 'Prioridad',
    title: 'Título',
    description: 'Descripción',
    titlePlaceholder: 'Descripción breve',
    descriptionPlaceholder: 'Descripción detallada del problema de seguridad',
    reportTypeOptions: {
      accountCompromise: 'Cuenta comprometida',
      suspiciousActivity: 'Actividad sospechosa',
      phishing: 'Phishing',
      unauthorizedAccess: 'Acceso no autorizado',
      other: 'Otro'
    },
    priorityOptions: {
      low: 'Baja',
      medium: 'Media',
      high: 'Alta',
      critical: 'Crítica'
    },
    openSupportTicket: 'Abrir ticket de soporte',
    supportTicketModalTitle: 'Nuevo ticket de soporte',
    supportSubject: 'Asunto (opcional)',
    supportSubjectPlaceholder: 'Resumen breve (opcional)',
    supportMessage: 'Mensaje',
    supportMessagePlaceholder: 'Describe tu solicitud con detalle.',
    submitSupportTicket: 'Enviar ticket',
    supportTicketError: 'No se pudo abrir el ticket. Inténtalo de nuevo.',
    submit: 'Enviar reporte',
    cancel: 'Cancelar'
  },
  notificationsTab: {
    maintenanceTitle: 'Avisos de mantenimiento',
    announcementsTitle: 'Anuncios del sistema',
    personalTitle: 'Notificaciones personales',
    unread: '{count} sin leer',
    markAllRead: 'Marcar todas como leídas',
    noMaintenance: 'No hay avisos de mantenimiento',
    noAnnouncements: 'No hay anuncios',
    noPersonal: 'No se encontraron notificaciones',
    clickToView: 'Haz clic para ver →',
    scheduled: 'Programado',
    affects: 'Afecta'
  },
  gdpr: {
    bannerTitle: 'Privacidad y cookies',
    bannerDescription: 'Usamos cookies y tecnologías similares para el funcionamiento del sitio, mejorar tu experiencia y personalizar el contenido. Puedes aceptar todo, rechazar cookies opcionales o personalizar tus opciones.',
    acceptAll: 'Aceptar todo',
    rejectOptional: 'Rechazar opcionales',
    customize: 'Personalizar',
    preferencesTitle: 'Preferencias de cookies',
    preferencesIntro: 'Elige qué categorías de cookies permitir. Las cookies necesarias son obligatorias para el sitio y no se pueden desactivar.',
    necessary: 'Necesarias',
    necessaryDesc: 'Esenciales para el funcionamiento del sitio (ej. sesión, seguridad).',
    analytics: 'Analíticas',
    analyticsDesc: 'Nos ayudan a entender cómo usas el sitio para mejorarlo.',
    preferencesCat: 'Preferencias',
    preferencesDesc: 'Recuerdan tu configuración y preferencias.',
    marketing: 'Marketing',
    marketingDesc: 'Usadas para publicidad y marketing relevante (si las usamos).',
    alwaysOn: 'Siempre activas',
    savePreferences: 'Guardar preferencias',
    cookiePreferencesLink: 'Preferencias de cookies'
  },
  legal: {
    platformOwner: 'The platform owner is Uilliam Dettori.'
  },
  settingsExtra: {
    walletAssociatedLabel: 'Wallet vinculada a tu cuenta:',
    walletConnectedLabel: 'Wallet conectada actualmente:',
    walletMismatchTitle: 'La wallet no coincide',
    walletMismatchBody: 'La wallet conectada no coincide con la vinculada a tu cuenta. Conecta la wallet correcta para usar todas las funciones.',
    walletConnected: 'Wallet conectada',
    walletSaveSuccess: '¡Wallet vinculada con éxito!',
    walletSaveError: 'Error al guardar la wallet: {message}',
    walletConnectError: 'Error al conectar la wallet: {message}',
    saveWallet: 'Vincula esta wallet a tu cuenta',
    saveWalletConfirm: 'Sí, vincular wallet',
    savingWallet: 'Guardando...',
    walletMobileHint: 'En móvil: cuando se abra la pantalla, elige tu app de wallet o escanea el código QR.',
    walletConnectedReadyInfo: 'Puedes usar esta wallet para depósitos y retiros. No hace falta volver a conectarla.',
    walletModalTitle: 'Wallet conectada',
    walletModalConnectedSuccess: 'Wallet conectada con éxito:',
    walletModalQuestion: '¿Quieres vincular esta wallet a tu cuenta? Así podrás usarla para futuras transacciones.',
    walletModalSkip: 'No, omitir'
  },
  supportWidget: {
    buttonOpen: 'Ayuda',
    title: 'Soporte',
    closeAria: 'Cerrar',
    sendAria: 'Enviar',
    openTelegram: 'Abrir Telegram',
    loadingReply: 'Buscando una respuesta...',
    escalateAction: 'Abrir ticket de soporte',
    inputPlaceholder: 'Escribe aquí...',
    welcomeMessage: 'Puedo ayudarte con depósitos, retiros, marketplace, subastas, packs, torneos, referidos o cuenta. Si no lo resuelvo, puedo escalarlo a un operador o puedes contactar directamente por Telegram.',
    fallbackNotUnderstood: 'No entendí. ¿Quieres hablar con un operador?',
    temporaryError: 'Error temporal. Inténtalo de nuevo o habla con un operador.',
    loginRequired: 'Para abrir un ticket de soporte debes iniciar sesión.',
    writeRequestHint: 'Escribe tu solicitud abajo y pulsa de nuevo "Abrir ticket de soporte", o envía primero un mensaje al bot.',
    escalatedTicket: 'He enviado la solicitud a un operador. Ticket #{ticketId}',
    escalateFailed: 'No puedo contactar a un operador ahora mismo. Inténtalo de nuevo en breve.',
    quickHome: 'Inicio',
    quickMarketplace: 'Marketplace',
    quickTournaments: 'Torneos',
    quickRankings: 'Rankings',
    quickDeposit: 'Depósito',
    quickProfile: 'Perfil'
  },
  depositPage: {
    title: 'Depositar fondos',
    chooseMethod: 'Elige cómo depositar',
    methodBonifico: 'Transferencia bancaria (SEPA)',
    methodPostepay: 'Recarga Postepay',
    bonificoTitle: 'Transferencia bancaria (SEPA)',
    bonificoLead: 'Realiza una transferencia SEPA al IBAN indicado. En el concepto, indica tu ',
    usernameEmphasis: 'usuario DIOS',
    bonificoTail: ' para vincular el pago. 1 EUR = 1 DIOS. El abono no es automático: se verificará manualmente.',
    postepayTitle: 'Recarga Postepay',
    postepayLead: 'Usa los datos siguientes para la recarga. ',
    postepayCausaleLabel: 'Concepto:',
    postepayMid: ' indica tu ',
    postepayTail: ' (el mismo con el que inicias sesión). El abono no es automático: se verificará manualmente.',
    labelIban: 'IBAN',
    labelAccountHolder: 'Titular',
    labelCardNumber: 'Número de tarjeta',
    labelExpiry: 'Caducidad',
    labelFiscalCode: 'Código fiscal (titular)',
    copyIban: 'Copiar IBAN',
    copy: 'Copiar',
    copyNumber: 'Copiar número',
    copyFiscalCode: 'Copiar código fiscal',
    copied: 'Copiado ✓',
    stripeUnavailableTitle: 'No disponible por el momento'
  },
  confirmD10S: {
    first: 'Vas a gastar {amount} DIOS en: {action}. ¿Continuar?',
    second: 'Confirma de nuevo para continuar.',
    actionDeposit: 'Depósito',
    actionWithdraw: 'Retirada',
    actionListSale: 'Poner a la venta',
    actionListLoan: 'Poner en préstamo',
    firstListSale: 'Vas a poner esta carta a la venta por {amount} DIOS. ¿Continuar?',
    firstListLoan: 'Vas a poner esta carta en préstamo (total {amount} DIOS). ¿Continuar?',
    titleFirst: 'Confirmar operación',
    titleSecond: 'Confirmación final',
    confirmContinue: 'Continuar',
    confirmFinal: 'Sí, continuar'
  }
};

const fr = {
  common: {
    language: 'Langue',
    save: 'Enregistrer les paramètres',
    saving: 'Enregistrement...',
    continue: 'Continuer',
    search: 'Rechercher',
    cancel: 'Annuler',
    previous: 'Précédent',
    next: 'Suivant',
    pageOf: 'Page {page} sur {total}',
    loading: 'Chargement...',
    notAvailable: 'N/D',
    unknown: 'Inconnu',
    processing: 'Traitement...'
  },
  onboarding: {
    chooseLanguageTitle: 'Choisissez votre langue',
    chooseLanguageSubtitle: 'Sélectionnez votre langue préférée pour le jeu',
    savingLanguage: 'Enregistrement...'
  },
  navbar: {
    searchPlaceholder: 'Rechercher un joueur par nom...',
    searchAriaLabel: 'Rechercher',
    searching: 'Recherche...',
    noResults: 'Aucun résultat',
    totalCards: 'Total des cartes',
    company: 'Entreprise',
    errorSearch: 'Erreur de recherche',
    signIn: 'Se connecter',
    register: 'S’inscrire',
    adminPanel: 'Panneau admin',
    rules: 'Règlement',
    musicMute: 'Couper la musique de fond',
    musicUnmute: 'Activer la musique de fond'
  },
  rules: {
    mobileTitle: 'Règlement DIOS10',
    mobileDesc: 'Sur mobile, ouvrez le PDF dans le navigateur pour une lecture optimale.',
    openPdf: 'Ouvrir le PDF dans le navigateur'
  },
  auth: {
    signIn: 'Se connecter',
    signingIn: 'Connexion...',
    email: 'Email',
    password: 'Mot de passe',
    forgotPassword: 'Mot de passe oublié ?',
    noAccount: 'Vous n’avez pas de compte ?',
    registerNow: 'Inscrivez-vous maintenant',
    fillAllFields: 'Veuillez remplir tous les champs',
    loginFailed: 'Échec de la connexion. Vérifiez vos identifiants.',
    emailVerified: 'E-mail vérifiée. Vous pouvez maintenant vous connecter.',
    emailVerifiedInvalid: 'Lien de vérification invalide ou expiré.',
    createAccount: 'Créez votre compte',
    chooseUsername: 'Choisissez votre nom d’utilisateur',
    username: 'Nom d’utilisateur',
    confirmPassword: 'Confirmer le mot de passe',
    referralCode: 'Code de parrainage (optionnel)',
    referralPlaceholder: 'Entrez le code de parrainage si vous en avez un',
    confirmPasswordPlaceholder: 'Confirmez votre mot de passe',
    minimumCharacters: 'Minimum 6 caractères',
    creatingAccount: 'Création du compte...',
    startJourney: 'Commencez votre aventure',
    alreadyAccount: 'Vous avez déjà un compte ?',
    terms: 'En vous inscrivant, vous acceptez nos Conditions d’utilisation',
    passwordMismatch: 'Les mots de passe ne correspondent pas',
    passwordShort: 'Le mot de passe doit contenir au moins 6 caractères',
    registrationPending: 'Inscription en attente. Vérifiez votre email via le lien envoyé. Vous ne pouvez pas vous connecter tant que l\'email n\'est pas vérifié.',
    registrationSuccess: 'Inscription terminée. Vous pouvez maintenant vous connecter.',
    registrationFailed: 'Échec de l’inscription. Veuillez réessayer.',
    forgotTitle: 'Mot de passe oublié ?',
    forgotSubtitle: 'Entrez votre email et nous vous enverrons un lien pour réinitialiser votre mot de passe.',
    sendResetLink: 'Envoyer le lien de réinitialisation',
    sending: 'Envoi...',
    resetToken: 'Jeton de réinitialisation',
    setNewPassword: 'Définir un nouveau mot de passe',
    newPassword: 'Nouveau mot de passe',
    confirmNewPassword: 'Confirmer le nouveau mot de passe',
    resetPassword: 'Réinitialiser le mot de passe',
    resetting: 'Réinitialisation...',
    resetTokenRequired: 'Le jeton de réinitialisation est requis',
    resetPasswordShort: 'Le mot de passe doit contenir au moins 8 caractères',
    resetSuccess: 'Mot de passe réinitialisé ! Redirection vers la connexion...',
    resetFailed: 'Échec de la réinitialisation. Le jeton peut être invalide ou expiré.',
    requestResetSuccess: 'Si cet email existe, un lien de réinitialisation a été envoyé.',
    requestResetToken: 'Lien envoyé ! Jeton : {token} (Copiez ce jeton pour les tests)',
    addToHomeTitle: 'Ajouter à l\'écran d\'accueil',
    addToHomeMessage: 'Cette app fonctionne mieux en tant qu\'application. Enregistrez l\'app sur l\'écran d\'accueil de votre téléphone pour une meilleure expérience.',
    addToHomeButton: 'Enregistrer sur l\'écran d\'accueil',
    addToHomeDontShowAgain: 'Ne plus afficher ce message',
    addToHomeGotIt: 'Compris',
    addToHomeStepsSafari: 'Dans Safari : 1) Appuyez sur le bouton Partager (carré avec flèche) en bas. 2) Faites défiler et sélectionnez "Sur l\'écran d\'accueil". 3) Appuyez sur "Ajouter".',
    addToHomeStepsChrome: 'Dans Chrome : 1) Appuyez sur l\'icône Partager (ou menu 3 points) dans la barre d\'adresse. 2) Sélectionnez "Sur l\'écran d\'accueil". 3) Appuyez sur "Ajouter".',
    addToHomeStepsFirefox: 'Dans Firefox : 1) Appuyez sur l\'icône Partager dans la barre d\'adresse. 2) Sélectionnez "Sur l\'écran d\'accueil". 3) Appuyez sur "Ajouter".',
    addToHomeStepsEdge: 'Dans Edge : 1) Appuyez sur l\'icône Partager (ou menu 3 points) dans la barre d\'adresse. 2) Sélectionnez "Sur l\'écran d\'accueil". 3) Appuyez sur "Ajouter".',
    addToHomeStepsSamsung: 'Dans Samsung Internet : 1) Appuyez sur le menu (3 lignes). 2) Sélectionnez "Ajouter la page à" > "Écran d\'accueil". 3) Appuyez sur "Ajouter".',
    addToHomeStepsOpera: 'Dans Opera : 1) Appuyez sur l\'icône menu. 2) Sélectionnez "Sur l\'écran d\'accueil". 3) Appuyez sur "Ajouter".',
    addToHomeStepsDefault: '1) Appuyez sur l\'icône Partager ou menu du navigateur. 2) Cherchez "Sur l\'écran d\'accueil" ou similaire. 3) Appuyez sur "Ajouter".'
  },
  home: {
    marketplace: 'MARCHÉ',
    tournaments: 'TOURNOIS',
    rankings: 'CLASSEMENTS',
    marketplaceDesc: 'Acheter et vendre des cartes',
    tournamentsDesc: 'Compétir en GameWeeks',
    rankingsDesc: 'Classements',
    activeGameweeks: 'GAMEWEEKS ACTIVES',
    tournamentsCount: '{count} Tournois'
  },
  settings: {
    title: 'Paramètres',
    walletConnection: 'Connexion du wallet',
    walletConnected: 'Connecté',
    connectWallet: 'Connecter le wallet',
    disconnectWallet: 'Déconnecter',
    connecting: 'Connexion...',
    languageLabel: 'Langue',
    tutorialCompleted: 'Tutoriel terminé',
    soundsEnabled: 'Effets sonores',
    soundsEnabledDesc: 'Jouer des sons au clic et pendant les actions du jeu',
    musicEnabled: 'Musique de fond',
    musicEnabledDesc: 'Jouer la musique de fond après la connexion',
    musicVolume: 'Volume de la musique',
    musicVolumeMobile: 'Sur mobile, le volume est contrôlé par l\'appareil.',
    accountTitle: 'Compte',
    logout: 'Déconnexion',
    saveSuccess: 'Paramètres enregistrés avec succès.',
    saveFailed: 'Échec de l’enregistrement des paramètres.',
    passwordSectionTitle: 'Réinitialiser le mot de passe',
    currentPassword: 'Mot de passe actuel',
    currentPasswordPlaceholder: 'Saisissez votre mot de passe actuel',
    newPassword: 'Nouveau mot de passe',
    newPasswordPlaceholder: 'Saisissez votre nouveau mot de passe',
    confirmNewPassword: 'Confirmer le nouveau mot de passe',
    confirmNewPasswordPlaceholder: 'Répétez votre nouveau mot de passe',
    changePassword: 'Confirmer le changement de mot de passe',
    changingPassword: 'Mise à jour du mot de passe...',
    passwordFillAllFields: 'Veuillez remplir tous les champs du mot de passe.',
    passwordMinLength: 'Le nouveau mot de passe doit contenir au moins 8 caractères.',
    passwordMismatch: 'Les nouveaux mots de passe ne correspondent pas.',
    passwordMustDiffer: 'Le nouveau mot de passe doit être différent de l\'actuel.',
    passwordChangeSuccess: 'Mot de passe mis à jour avec succès.',
    passwordChangeFailed: 'Impossible de mettre à jour le mot de passe.'
  },
  rankings: {
    title: 'Classements',
    gameweekSectionTitle: 'Classements GameWeek',
    gameweekSectionDesc: 'Classement officiel de chaque tournoi GameWeek : position, score final et récompense. Choisissez le tournoi et la catégorie (Basic, Plus, Rare, Epic, Unique) ci-dessous.',
    monthlySectionTitle: 'Classements mensuels',
    monthlySectionDesc: 'Classements officiels publiés par la plateforme : le score est la somme des résultats GameWeek de la période (même catégorie).',
    monthlySelectTitle: 'Choisir un classement mensuel',
    monthlySelectPlaceholder: 'Sélectionnez un classement mensuel...',
    monthlyEmptyHint: 'Aucun classement mensuel publié pour le moment. Publiés par la plateforme en fin de période.',
    monthlyEmptyTable: 'Aucune donnée pour ce classement mensuel',
    monthlyCategoryLabel: 'Catégorie',
    monthlyCategoryGlobal: 'Global',
    monthlyPrizePoolLabel: 'Cagnotte',
    selectTitle: 'Choisir un tournoi GameWeek',
    selectPlaceholder: 'Sélectionnez un tournoi GameWeek...',
    emptyHint: 'Aucun classement GameWeek disponible. Les positions apparaissent lorsque les scores sont calculés.',
    loading: 'Chargement des classements...',
    typeLabel: 'Type',
    tableRank: 'Rang',
    tablePlayer: 'Joueur',
    tableScore: 'Score',
    tablePrize: 'Prix',
    emptyTable: 'Aucun classement disponible',
    topRefTitle: 'Classement des Parrains',
    topRefDesc: 'Meilleurs parrains par gains des utilisateurs invités. Choisissez la période à afficher.',
    topRefPeriodLabel: 'Période de référence',
    topRefColReferrals: 'Utilisateurs invités',
    topRefColEarnings: 'Gains (DIOS)',
    topRefEmpty: 'Aucun parrain sur cette période',
    topRefPeriodAll: 'Tout',
    topRefPeriodMonthly: 'Mensuel',
    topRefPeriodSemestral: 'Ce semestre',
    topRefPeriodAnnual: 'Annuel',
    topRefSelectMonth: 'Sélectionner le mois',
    topRefSelectYear: 'Sélectionner l\'année'
  },
  marketplace: {
    title: 'Marché',
    balanceLabel: 'Votre solde',
    tabsAuctions: 'Enchères',
    tabsPacks: 'Packs',
    tabsSales: 'Acheter maintenant',
    tabsLoans: 'Prêts',
    tabsTrades: 'Carte à carte',
    filtersTitle: 'Recherche et filtres',
    resetFilters: 'Réinitialiser les filtres',
    auctionStatusOpen: 'Ouvertes',
    auctionStatusClosed: 'Fermées',
    auctionStatusClosedHint: 'Ici, vous voyez les enchères expirées en cours de traitement : le temps est écoulé mais l’enchère n’est pas encore clôturée et la carte n’a pas été attribuée.',
    searchPlayerLabel: 'Rechercher un joueur',
    searchPlayerPlaceholder: 'Entrez le nom du joueur...',
    rarityLabel: 'Rareté',
    allRarities: 'Toutes les raretés',
    rarityBasic: 'Basic',
    rarityPlus: 'Plus',
    rarityRare: 'Rare',
    rarityEpic: 'Epic',
    rarityUnique: 'Unique',
    positionLabel: 'Poste',
    allPositions: 'Tous les postes',
    positionGK: 'Gardien',
    positionDEF: 'Défenseur',
    positionMID: 'Milieu',
    positionATT: 'Attaquant',
    nationalityLabel: 'Nationalité',
    nationalityPlaceholder: 'ex. Italie',
    teamLabel: 'Équipe',
    teamPlaceholder: 'ex. Real Madrid',
    leagueLabel: 'Ligue',
    leaguePlaceholder: 'ex. Serie A',
    ageMinLabel: 'Âge min',
    ageMinPlaceholder: 'ex. 18',
    ageMaxLabel: 'Âge max',
    ageMaxPlaceholder: 'ex. 35',
    xpMinLabel: 'XP min',
    xpMinPlaceholder: 'ex. 5',
    xpMaxLabel: 'XP max',
    xpMaxPlaceholder: 'ex. 20',
    auctionsInfoTitle: 'Infos enchères',
    auctionsInfoBody: 'Les enchères sont finalisées toutes les 10 minutes. Si vous gagnez, l’attribution de la carte peut prendre jusqu’à 10 minutes.',
    secondaryMarketFilterNotice: 'Actuellement, seules les cartes Divinity et Legend (Entraîneur) sont affichées sur le marché secondaire.',
    bidSuccess: '✅ Enchère placée ! Votre enchère est active.',
    purchaseSuccess: '✅ Carte achetée ! Vérifiez votre collection.',
    packSuccess: '✅ Pack ouvert ! Nouvelles cartes ajoutées à votre collection.',
    loanSuccess: '✅ Prêt accepté ! La carte est maintenant dans votre collection.',
    tradeAcceptSuccess: '✅ Échange accepté ! Cartes échangées.',
    tradeRejectSuccess: '✅ Échange rejeté',
    counterOfferSuccess: '✅ Contre-offre envoyée ! Le propriétaire la verra dans ses offres.',
    emptyAuctionsTitle: 'Aucune enchère active',
    emptyAuctionsBody: 'Revenez plus tard pour de nouvelles enchères',
    emptySalesTitle: 'Aucune carte disponible',
    emptySalesBody: 'Aucune carte n’est actuellement en vente',
    emptyPacksTitle: 'Aucun pack disponible',
    emptyPacksBody: 'Les packs seront bientôt disponibles',
    emptyLoansTitle: 'Aucun prêt disponible',
    emptyLoansBody: 'Aucune carte n’est actuellement disponible en prêt',
    emptyTradesTitle: 'Aucun échange ouvert',
    emptyTradesBody: 'Aucun échange disponible pour le moment. Créez-en un depuis vos cartes !'
  },
  marketplaceCards: {
    ended: 'Terminée',
    auctionBadge: 'Enchère',
    viewCopiesAria: 'Voir {count} copies',
    playerAlt: 'Joueur',
    positionLabel: 'Poste',
    teamLabel: 'Équipe',
    rarityLabel: 'Rareté',
    xpLevelLabel: 'Niveau XP',
    currentBidLabel: 'Enchère actuelle',
    currentWinnerLabel: 'Gagnant actuel',
    minBidLabel: 'Enchère minimale',
    bidAmountLabel: 'Votre enchère',
    bidPlaceholder: 'Entrez une enchère (min : {amount} DIOS)',
    placingBid: 'Envoi...',
    auctionExtending: 'Mise à jour du compte à rebours...',
    placeBid: 'Placer une enchère',
    quickBid: 'Enchère rapide',
    multipleCopiesHint: 'Plusieurs copies disponibles. Sélectionnez une copie pour enchérir.',
    viewCopiesBid: 'Voir copies et enchérir',
    loginToBid: 'Veuillez vous connecter pour enchérir',
    bidMinError: 'L’enchère doit être au moins {amount} DIOS',
    bidFailed: 'Échec de l’enchère',
    bidAuctionUpdated: "L'enchère a été mise à jour : nouvel enchérisseur et nouvelle valeur. Offre minimale {amount} DIOS. Actualisez et réessayez.",
    bidOfferMinButton: 'Enchérir {amount} D10S',
    copiesLoadFailed: 'Échec du chargement des copies',
    availableCopies: 'Copies disponibles ({count})',
    loadingCopies: 'Chargement des copies...',
    noCopies: 'Aucune copie disponible.',
    auctionNumber: 'Enchère #{id}',
    none: '—',
    bidMin: 'Enchère min',
    customBidPlaceholder: 'Personnalisée (min {amount})',
    loginToPurchase: 'Veuillez vous connecter pour acheter',
    purchaseOwnCard: 'Vous ne pouvez pas acheter votre propre carte',
    purchaseFailed: 'Échec de l’achat de la carte',
    buyNowBadge: 'Acheter maintenant',
    priceLabel: 'Prix',
    processing: 'Traitement...',
    buyNowAction: 'Acheter maintenant',
    loginToOpenPack: 'Veuillez vous connecter pour ouvrir des packs',
    openPackFailed: 'Échec de l’ouverture du pack',
    packDescriptionFallback: 'Découvrez des cartes incroyables dans ce pack !',
    openingPack: 'Ouverture du pack...',
    openPack: 'Ouvrir le pack',
    packQuantity: 'Quantité',
    packQuantityLabel: 'Packs à acheter',
    openingOnePack: 'ouverture de 1 pack',
    openingPacksCount: 'ouverture de {count} packs',
    nextPack: 'Pack suivant',
    skipOpening: 'Passer',
    cardsAssignedSummary: '{count} cartes ont été ajoutées à ta collection.',
    viewInProfile: 'Voir dans le Profil',
    loginToAcceptLoan: 'Veuillez vous connecter pour accepter les prêts',
    acceptOwnLoan: 'Vous ne pouvez pas accepter votre propre prêt',
    acceptLoanFailed: 'Échec de l’acceptation du prêt',
    loanBadge: 'Prêt',
    pricePerGameweek: 'Prix par Gameweek',
    durationLabel: 'Durée',
    gameweeks: '{count} Gameweeks',
    totalCost: 'Coût total',
    acceptLoan: 'Accepter le prêt'
  },
  trade: {
    loginToAccept: 'Veuillez vous connecter pour accepter les échanges',
    noRequestedCardAvailable: 'Vous n’avez pas la carte demandée disponible pour l’échange',
    noRequestedCard: 'Vous n’avez pas la carte demandée',
    loadCardsFailed: 'Échec du chargement de vos cartes',
    acceptFailed: 'Échec de l’acceptation de l’échange',
    loginToReject: 'Veuillez vous connecter pour rejeter les échanges',
    rejectFailed: 'Échec du rejet de l’échange',
    loginToCounter: 'Veuillez vous connecter pour faire des contre-offres',
    noCardsForCounter: 'Aucune carte disponible pour la contre-offre',
    selectCardForCounter: 'Veuillez sélectionner une carte pour la contre-offre',
    createCounterFailed: 'Échec de la création de la contre-offre',
    openTrade: 'Échange ouvert',
    offerFrom: 'Offre d’échange de {username}',
    byUser: 'Par : {username}',
    expires: 'Expire : {date}',
    theyOffer: 'Ils offrent',
    theyWant: 'Ils veulent',
    youGive: 'Vous donnez',
    unknownPlayer: 'Joueur inconnu',
    unknownRarity: 'Rareté inconnue',
    accept: 'Accepter l’échange',
    makeCounter: 'Faire une contre-offre',
    counterOffer: 'Contre-offre',
    reject: 'Rejeter',
    ownerHint: 'C’est votre offre d’échange. Attendez que d’autres acceptent ou fassent une contre-offre.',
    selectCardTitle: 'Sélectionner une carte à échanger',
    youWillReceive: 'Vous recevrez',
    youWillGive: 'Vous donnerez',
    selectWhichCard: 'Sélectionnez la carte à échanger :',
    makeCounterTitle: 'Faire une contre-offre',
    counterHint: 'Vous n’avez pas la carte demandée, mais vous pouvez offrir une de vos cartes.',
    selectCardToOffer: 'Sélectionnez une carte à offrir :',
    selectCardPlaceholder: '-- Sélectionner une carte --',
    sendCounter: 'Envoyer la contre-offre',
    sending: 'Envoi...',
    counterOfferTitle: 'Contre-offre',
    youWant: 'Vous voulez',
    yourCard: 'Votre carte',
    theirCard: 'Leur carte',
    selectCardInstead: 'Sélectionnez une carte à offrir à la place :',
    creating: 'Création...'
  },
  tournaments: {
    title: 'GameWeeks et Tournois',
    create: 'Créer un tournoi',
    filterTitle: 'Filtrer par type',
    filterAll: 'Tous',
    filterGameweek: 'GameWeeks',
    filterPrivate: 'Privés',
    filterThematic: 'Thématiques',
    loading: 'Chargement des tournois...',
    emptyGameweeks: 'Aucune GameWeek active pour le moment',
    emptyTournaments: 'Aucun tournoi disponible',
    statusInProgress: 'EN COURS',
    statusPendingPayment: 'PAIEMENT EN ATTENTE',
    statusClosed: 'FERMÉ',
    statusUpcoming: 'À VENIR',
    statusOpen: 'OUVERT',
    checkScores: 'Voir les scores',
    viewGameweekScores: 'Voir les scores de gameweek',
    viewTournamentScores: 'Voir les scores du tournoi',
    availableTournaments: '{count} Tournois disponibles',
    participants: '{count} participants',
    free: 'Gratuit',
    registered: 'Inscrit',
    editFormation: 'Modifier la formation',
    enter: 'Entrer',
    entriesClosed: 'GameWeek en cours - inscriptions fermées',
    starts: 'Débute',
    ends: 'Fin',
    countdownFormationLocksIn: 'Formation verrouillée dans',
    countdownFormationLocked: 'Formation verrouillée',
    countdownStartsIn: 'Débute dans',
    countdownEndsIn: 'Finit dans',
    countdownEnded: 'Terminé',
    buyIn: 'Mise',
    buyInAmount: '{amount} DIOS',
    gameweekPricing: 'Basic : Gratuit | Plus : 5 | Rare : 10 | Epic : 25 | Unique : 50 DIOS',
    rarityLabel: 'Rareté',
    rarityBasic: 'Basic',
    inProgressClosed: 'En cours - inscriptions fermées',
    joinGameweek: 'Rejoindre la GameWeek',
    joinFreeGameweek: 'Rejoindre la GameWeek gratuite',
    enterTournament: 'Entrer dans le tournoi',
    joinFree: 'Entrer gratuitement',
    prizePool: 'Prize Pool',
    prize: 'Récompense'
  },
  notifications: {
    title: 'Notifications',
    markAllRead: 'Tout marquer comme lu',
    noNotifications: 'Aucune notification',
    ariaLabel: 'Notifications',
    justNow: 'À l’instant',
    minutesAgo: 'il y a {count} min',
    hoursAgo: 'il y a {count} h',
    daysAgo: 'il y a {count} j'
  },
  profile: {
    tabs: {
      myCards: 'Mes cartes',
      soldLoans: 'Ventes et prêts',
      activityReport: 'Rapport d’activité',
      offers: 'Offres',
      referrals: 'Parrainages',
      loginHistory: 'Historique de connexion',
      security: 'Sécurité',
      notifications: 'Notifications',
      settings: 'Paramètres'
    }
  },
  activityReport: {
    title: 'Rapport d’activité',
    last7Days: '7 derniers jours',
    downloadCsv: 'Télécharger CSV',
    loading: 'Chargement de l’activité...',
    empty: 'Aucune activité ces 7 derniers jours.',
    category: {
      deposit: 'Dépôt',
      withdrawal: 'Retrait',
      prize: 'Récompense',
      marketplace: 'Marketplace'
    },
    action: {
      deposit: 'Dépôt',
      withdrawal: 'Retrait',
      purchase: 'Achat',
      sale: 'Vente',
      loanBorrow: 'Prêt (emprunt)',
      loanLend: 'Prêt (prêteur)',
      gameweekPrize: 'Récompense Gameweek'
    }
  },
  cardsStatus: {
    cardsForSale: 'Cartes en vente',
    soldCards: 'Cartes vendues',
    loanedCards: 'Prêts accordés',
    borrowedCards: 'Cartes empruntées',
    forSaleLabel: 'En vente',
    soldLabel: 'Vendue',
    loanedLabel: 'En prêt',
    borrowedLabel: 'Empruntée',
    listedDate: 'Publiée',
    saleDate: 'Date de vente',
    startDate: 'Date de début',
    duration: 'Durée : {count} GW',
    emptyCardsForSale: 'Aucune carte en vente.',
    emptySold: 'Aucune carte vendue.',
    emptyLoaned: 'Aucun prêt accordé.',
    emptyBorrowed: 'Aucune carte empruntée active.',
    removeFromSale: 'Retirer de la vente',
    confirmRemoveFromSale: 'Retirer cette carte de la vente ?',
    removeFromSaleFailed: 'Impossible de retirer de la vente'
  },
  loginHistory: {
    title: 'Historique de connexion',
    total: 'Total : {count}',
    loading: 'Chargement de l’historique...',
    empty: 'Aucun historique de connexion',
    success: 'Succès',
    failed: 'Échec',
    reason: 'Raison',
    ip: 'IP',
    location: 'Lieu'
  },
  security: {
    titleSecurity: 'Rapports de sécurité',
    titleSupport: 'Tickets de support',
    total: 'Total : {count}',
    reportIssue: 'Signaler un problème',
    createFirst: 'Créer le premier rapport',
    loadingSecurity: 'Chargement des rapports de sécurité...',
    loadingSupport: 'Chargement des tickets de support...',
    emptySecurity: 'Aucun rapport de sécurité',
    emptySupport: 'Aucun ticket de support',
    sectionSecurity: 'Rapports de sécurité',
    sectionSupport: 'Tickets de support',
    created: 'Créé',
    resolved: 'Résolu',
    adminNotes: 'Notes admin',
    botReply: 'Réponse du bot',
    reportModalTitle: 'Signaler un problème de sécurité',
    reportType: 'Type de rapport',
    priority: 'Priorité',
    title: 'Titre',
    description: 'Description',
    titlePlaceholder: 'Description brève',
    descriptionPlaceholder: 'Description détaillée du problème de sécurité',
    reportTypeOptions: {
      accountCompromise: 'Compte compromis',
      suspiciousActivity: 'Activité suspecte',
      phishing: 'Phishing',
      unauthorizedAccess: 'Accès non autorisé',
      other: 'Autre'
    },
    priorityOptions: {
      low: 'Faible',
      medium: 'Moyenne',
      high: 'Élevée',
      critical: 'Critique'
    },
    openSupportTicket: 'Ouvrir un ticket support',
    supportTicketModalTitle: 'Nouveau ticket support',
    supportSubject: 'Objet (facultatif)',
    supportSubjectPlaceholder: 'Court résumé (facultatif)',
    supportMessage: 'Message',
    supportMessagePlaceholder: 'Décrivez votre demande en détail.',
    submitSupportTicket: 'Envoyer le ticket',
    supportTicketError: 'Impossible d’ouvrir le ticket. Réessayez.',
    submit: 'Envoyer le rapport',
    cancel: 'Annuler'
  },
  notificationsTab: {
    maintenanceTitle: 'Alertes de maintenance',
    announcementsTitle: 'Annonces système',
    personalTitle: 'Notifications personnelles',
    unread: '{count} non lues',
    markAllRead: 'Tout marquer comme lu',
    noMaintenance: 'Aucune alerte de maintenance',
    noAnnouncements: 'Aucune annonce',
    noPersonal: 'Aucune notification',
    clickToView: 'Cliquer pour voir →',
    scheduled: 'Planifié',
    affects: 'Impacte'
  },
  gdpr: {
    bannerTitle: 'Confidentialité et cookies',
    bannerDescription: 'Nous utilisons des cookies et des technologies similaires pour faire fonctionner le site, améliorer votre expérience et personnaliser le contenu. Vous pouvez tout accepter, refuser les cookies optionnels ou personnaliser vos choix.',
    acceptAll: 'Tout accepter',
    rejectOptional: 'Refuser les optionnels',
    customize: 'Personnaliser',
    preferencesTitle: 'Préférences des cookies',
    preferencesIntro: 'Choisissez les catégories de cookies à autoriser. Les cookies nécessaires sont requis pour le site et ne peuvent pas être désactivés.',
    necessary: 'Nécessaires',
    necessaryDesc: 'Essentiels au fonctionnement du site (ex. session, sécurité).',
    analytics: 'Analytiques',
    analyticsDesc: 'Nous aident à comprendre comment vous utilisez le site pour l\'améliorer.',
    preferencesCat: 'Préférences',
    preferencesDesc: 'Mémorisent vos paramètres et préférences.',
    marketing: 'Marketing',
    marketingDesc: 'Utilisés pour la publicité et le marketing pertinents (si nous les utilisons).',
    alwaysOn: 'Toujours actifs',
    savePreferences: 'Enregistrer les préférences',
    cookiePreferencesLink: 'Préférences des cookies'
  },
  legal: {
    platformOwner: 'The platform owner is Uilliam Dettori.'
  },
  settingsExtra: {
    walletAssociatedLabel: 'Wallet lié à votre compte :',
    walletConnectedLabel: 'Wallet actuellement connecté :',
    walletMismatchTitle: 'Wallet non correspondant',
    walletMismatchBody: 'Le wallet connecté ne correspond pas à celui lié à votre compte. Connectez le bon wallet pour utiliser toutes les fonctionnalités.',
    walletConnected: 'Wallet connecté',
    walletSaveSuccess: 'Wallet lié avec succès !',
    walletSaveError: 'Erreur lors de l’enregistrement du wallet : {message}',
    walletConnectError: 'Erreur lors de la connexion du wallet : {message}',
    saveWallet: 'Lier ce wallet à votre compte',
    saveWalletConfirm: 'Oui, lier le wallet',
    savingWallet: 'Enregistrement...',
    walletMobileHint: 'Sur mobile : quand l\'écran s\'ouvre, choisissez l\'app wallet ou scannez le QR code.',
    walletConnectedReadyInfo: 'Vous pouvez utiliser ce wallet pour les dépôts et retraits. Pas besoin de le reconnecter.',
    walletModalTitle: 'Wallet connecté',
    walletModalConnectedSuccess: 'Wallet connecté avec succès :',
    walletModalQuestion: 'Voulez-vous lier ce wallet à votre compte ? Vous pourrez ainsi l\'utiliser pour les prochaines transactions.',
    walletModalSkip: 'Non, ignorer'
  },
  supportWidget: {
    buttonOpen: 'Aide',
    title: 'Support',
    closeAria: 'Fermer',
    sendAria: 'Envoyer',
    openTelegram: 'Ouvrir Telegram',
    loadingReply: 'Je cherche une réponse...',
    escalateAction: 'Ouvrir un ticket support',
    inputPlaceholder: 'Écris ici...',
    welcomeMessage: 'Je peux vous aider avec les dépôts, retraits, marketplace, enchères, packs, tournois, parrainage ou compte. Si besoin, je peux transférer à un opérateur, ou vous pouvez contacter le support directement sur Telegram.',
    fallbackNotUnderstood: 'Je n\'ai pas compris. Voulez-vous parler à un opérateur ?',
    temporaryError: 'Erreur temporaire. Réessayez ou contactez un opérateur.',
    loginRequired: 'Pour ouvrir un ticket support, vous devez vous connecter.',
    writeRequestHint: 'Écrivez votre demande ci-dessous et cliquez à nouveau sur "Ouvrir un ticket support", ou envoyez d\'abord un message au bot.',
    escalatedTicket: 'Votre demande a été transmise à un opérateur. Ticket #{ticketId}',
    escalateFailed: 'Je ne peux pas contacter un opérateur pour le moment. Réessayez bientôt.',
    quickHome: 'Accueil',
    quickMarketplace: 'Marketplace',
    quickTournaments: 'Tournois',
    quickRankings: 'Classements',
    quickDeposit: 'Dépôt',
    quickProfile: 'Profil'
  },
  depositPage: {
    title: 'Dépôt de fonds',
    chooseMethod: 'Choisissez comment déposer',
    methodBonifico: 'Virement bancaire (SEPA)',
    methodPostepay: 'Recharge Postepay',
    bonificoTitle: 'Virement bancaire (SEPA)',
    bonificoLead: 'Effectuez un virement SEPA vers l\'IBAN indiqué. Dans le libellé, indiquez votre ',
    usernameEmphasis: 'nom d\'utilisateur DIOS',
    bonificoTail: ' pour que nous puissions associer le paiement. 1 EUR = 1 DIOS. Le crédit n\'est pas automatique : il sera vérifié manuellement.',
    postepayTitle: 'Recharge Postepay',
    postepayLead: 'Utilisez les coordonnées ci-dessous pour la recharge. ',
    postepayCausaleLabel: 'Libellé :',
    postepayMid: ' indiquez votre ',
    postepayTail: ' (le même que pour la connexion). Le crédit n\'est pas automatique : il sera vérifié manuellement.',
    labelIban: 'IBAN',
    labelAccountHolder: 'Titulaire du compte',
    labelCardNumber: 'Numéro de carte',
    labelExpiry: 'Expiration',
    labelFiscalCode: 'Code fiscal (titulaire)',
    copyIban: 'Copier l\'IBAN',
    copy: 'Copier',
    copyNumber: 'Copier le numéro',
    copyFiscalCode: 'Copier le code fiscal',
    copied: 'Copié ✓',
    stripeUnavailableTitle: 'Indisponible pour le moment'
  },
  confirmD10S: {
    first: 'Vous êtes sur le point de dépenser {amount} DIOS pour : {action}. Continuer ?',
    second: 'Confirmez à nouveau pour continuer.',
    actionDeposit: 'Dépôt',
    actionWithdraw: 'Retrait',
    actionListSale: 'Mettre en vente',
    actionListLoan: 'Mettre en prêt',
    firstListSale: 'Vous êtes sur le point de mettre cette carte en vente pour {amount} DIOS. Continuer ?',
    firstListLoan: 'Vous êtes sur le point de mettre cette carte en prêt (total {amount} DIOS). Continuer ?',
    titleFirst: 'Confirmer l\'opération',
    titleSecond: 'Confirmation finale',
    confirmContinue: 'Continuer',
    confirmFinal: 'Oui, continuer'
  }
};

const de = {
  common: {
    language: 'Sprache',
    save: 'Einstellungen speichern',
    saving: 'Wird gespeichert...',
    continue: 'Weiter',
    search: 'Suchen',
    cancel: 'Abbrechen',
    previous: 'Zurück',
    next: 'Weiter',
    pageOf: 'Seite {page} von {total}',
    loading: 'Lädt...',
    notAvailable: 'k. A.',
    unknown: 'Unbekannt',
    processing: 'Wird verarbeitet...'
  },
  onboarding: {
    chooseLanguageTitle: 'Wähle deine Sprache',
    chooseLanguageSubtitle: 'Wähle deine bevorzugte Sprache für das Spiel',
    savingLanguage: 'Wird gespeichert...'
  },
  navbar: {
    searchPlaceholder: 'Spieler nach Name suchen...',
    searchAriaLabel: 'Suchen',
    searching: 'Suche läuft...',
    noResults: 'Keine Ergebnisse',
    totalCards: 'Gesamtanzahl Karten',
    company: 'Unternehmen',
    errorSearch: 'Suchfehler',
    signIn: 'Anmelden',
    register: 'Registrieren',
    adminPanel: 'Admin-Panel',
    rules: 'Regeln',
    musicMute: 'Hintergrundmusik ausschalten',
    musicUnmute: 'Hintergrundmusik einschalten'
  },
  rules: {
    mobileTitle: 'DIOS10 Regeln',
    mobileDesc: 'Auf dem Handy öffne die PDF im Browser für optimale Lesbarkeit.',
    openPdf: 'PDF im Browser öffnen'
  },
  auth: {
    signIn: 'Anmelden',
    signingIn: 'Anmeldung läuft...',
    email: 'E-Mail',
    password: 'Passwort',
    forgotPassword: 'Passwort vergessen?',
    noAccount: 'Noch kein Konto?',
    registerNow: 'Jetzt registrieren',
    fillAllFields: 'Bitte alle Felder ausfüllen',
    loginFailed: 'Anmeldung fehlgeschlagen. Bitte Zugangsdaten prüfen.',
    emailVerified: 'E-Mail bestätigt. Du kannst dich jetzt anmelden.',
    emailVerifiedInvalid: 'Bestätigungslink ungültig oder abgelaufen.',
    createAccount: 'Konto erstellen',
    chooseUsername: 'Wähle deinen Benutzernamen',
    username: 'Benutzername',
    confirmPassword: 'Passwort bestätigen',
    referralCode: 'Empfehlungscode (optional)',
    referralPlaceholder: 'Empfehlungscode eingeben, falls vorhanden',
    confirmPasswordPlaceholder: 'Passwort bestätigen',
    minimumCharacters: 'Mindestens 6 Zeichen',
    creatingAccount: 'Konto wird erstellt...',
    startJourney: 'Starte deine Reise',
    alreadyAccount: 'Bereits ein Konto?',
    terms: 'Mit der Registrierung stimmst du unseren Nutzungsbedingungen zu',
    passwordMismatch: 'Passwörter stimmen nicht überein',
    passwordShort: 'Passwort muss mindestens 6 Zeichen haben',
    registrationPending: 'Registrierung ausstehend. Bitte verifiziere deine E-Mail über den gesendeten Link. Anmeldung ist erst nach Verifizierung möglich.',
    registrationSuccess: 'Registrierung abgeschlossen. Du kannst dich jetzt anmelden.',
    registrationFailed: 'Registrierung fehlgeschlagen. Bitte erneut versuchen.',
    forgotTitle: 'Passwort vergessen?',
    forgotSubtitle: 'Gib deine E-Mail-Adresse ein und wir senden dir einen Link zum Zurücksetzen.',
    sendResetLink: 'Reset-Link senden',
    sending: 'Wird gesendet...',
    resetToken: 'Reset-Token',
    setNewPassword: 'Neues Passwort festlegen',
    newPassword: 'Neues Passwort',
    confirmNewPassword: 'Neues Passwort bestätigen',
    resetPassword: 'Passwort zurücksetzen',
    resetting: 'Wird zurückgesetzt...',
    resetTokenRequired: 'Reset-Token ist erforderlich',
    resetPasswordShort: 'Passwort muss mindestens 8 Zeichen lang sein',
    resetSuccess: 'Passwort erfolgreich zurückgesetzt! Weiterleitung zum Login...',
    resetFailed: 'Passwort konnte nicht zurückgesetzt werden. Token ungültig oder abgelaufen.',
    requestResetSuccess: 'Wenn diese E-Mail existiert, wurde ein Reset-Link gesendet.',
    requestResetToken: 'Reset-Link gesendet! Token: {token} (Für Tests kopieren)',
    addToHomeTitle: 'Zum Startbildschirm hinzufügen',
    addToHomeMessage: 'Diese App funktioniert am besten als App. Speichere die App auf dem Startbildschirm deines Handys für das beste Erlebnis.',
    addToHomeButton: 'Auf Startbildschirm speichern',
    addToHomeDontShowAgain: 'Diese Nachricht nicht mehr anzeigen',
    addToHomeGotIt: 'Verstanden',
    addToHomeStepsSafari: 'In Safari: 1) Tippe auf die Teilen-Schaltfläche (Quadrat mit Pfeil) unten. 2) Scrolle und wähle "Zum Home-Bildschirm". 3) Tippe auf "Hinzufügen".',
    addToHomeStepsChrome: 'In Chrome: 1) Tippe auf das Teilen-Symbol (oder 3-Punkte-Menü) in der Adressleiste. 2) Wähle "Zum Home-Bildschirm". 3) Tippe auf "Hinzufügen".',
    addToHomeStepsFirefox: 'In Firefox: 1) Tippe auf das Teilen-Symbol in der Adressleiste. 2) Wähle "Zum Home-Bildschirm". 3) Tippe auf "Hinzufügen".',
    addToHomeStepsEdge: 'In Edge: 1) Tippe auf das Teilen-Symbol (oder 3-Punkte-Menü) in der Adressleiste. 2) Wähle "Zum Home-Bildschirm". 3) Tippe auf "Hinzufügen".',
    addToHomeStepsSamsung: 'In Samsung Internet: 1) Tippe auf das Menü (3 Linien). 2) Wähle "Seite hinzufügen zu" > "Startbildschirm". 3) Tippe auf "Hinzufügen".',
    addToHomeStepsOpera: 'In Opera: 1) Tippe auf das Menü-Symbol. 2) Wähle "Zum Home-Bildschirm". 3) Tippe auf "Hinzufügen".',
    addToHomeStepsDefault: '1) Tippe auf das Teilen- oder Menü-Symbol im Browser. 2) Suche "Zum Home-Bildschirm" oder ähnlich. 3) Tippe auf "Hinzufügen".'
  },
  home: {
    marketplace: 'MARKTPLATZ',
    tournaments: 'TURNIERE',
    rankings: 'RANGLISTEN',
    marketplaceDesc: 'Karten kaufen und verkaufen',
    tournamentsDesc: 'In GameWeeks antreten',
    rankingsDesc: 'Bestenlisten',
    activeGameweeks: 'AKTIVE GAMEWEEKS',
    tournamentsCount: '{count} Turniere'
  },
  settings: {
    title: 'Einstellungen',
    walletConnection: 'Wallet-Verbindung',
    walletConnected: 'Verbunden',
    connectWallet: 'Wallet verbinden',
    disconnectWallet: 'Trennen',
    connecting: 'Verbinden...',
    languageLabel: 'Sprache',
    tutorialCompleted: 'Tutorial abgeschlossen',
    soundsEnabled: 'Soundeffekte',
    soundsEnabledDesc: 'Töne beim Klicken und während der Spielaktionen abspielen',
    musicEnabled: 'Hintergrundmusik',
    musicEnabledDesc: 'Hintergrundmusik nach der Anmeldung abspielen',
    musicVolume: 'Musiklautstärke',
    musicVolumeMobile: 'Auf dem Handy wird die Lautstärke vom Gerät gesteuert.',
    accountTitle: 'Konto',
    logout: 'Abmelden',
    saveSuccess: 'Einstellungen erfolgreich gespeichert.',
    saveFailed: 'Einstellungen konnten nicht gespeichert werden.',
    passwordSectionTitle: 'Passwort zurücksetzen',
    currentPassword: 'Aktuelles Passwort',
    currentPasswordPlaceholder: 'Gib dein aktuelles Passwort ein',
    newPassword: 'Neues Passwort',
    newPasswordPlaceholder: 'Gib dein neues Passwort ein',
    confirmNewPassword: 'Neues Passwort bestätigen',
    confirmNewPasswordPlaceholder: 'Wiederhole dein neues Passwort',
    changePassword: 'Passwortänderung bestätigen',
    changingPassword: 'Passwort wird aktualisiert...',
    passwordFillAllFields: 'Bitte fülle alle Passwortfelder aus.',
    passwordMinLength: 'Das neue Passwort muss mindestens 8 Zeichen lang sein.',
    passwordMismatch: 'Die neuen Passwörter stimmen nicht überein.',
    passwordMustDiffer: 'Das neue Passwort muss sich vom aktuellen unterscheiden.',
    passwordChangeSuccess: 'Passwort erfolgreich aktualisiert.',
    passwordChangeFailed: 'Passwort konnte nicht aktualisiert werden.'
  },
  rankings: {
    title: 'Ranglisten',
    gameweekSectionTitle: 'GameWeek-Ranglisten',
    gameweekSectionDesc: 'Offizielle Tabelle jedes GameWeek-Turniers: Platz, Endpunktzahl und Preis. Turnier und Kategorie (Basic, Plus, Rare, Epic, Unique) unten wählen.',
    monthlySectionTitle: 'Monatliche Ranglisten',
    monthlySectionDesc: 'Offizielle Monatsranglisten der Plattform: Die Punktzahl ist die Summe der GameWeek-Ergebnisse im Zeitraum (gleiche Kategorie).',
    monthlySelectTitle: 'Monatsrangliste wählen',
    monthlySelectPlaceholder: 'Monatliche Rangliste auswählen...',
    monthlyEmptyHint: 'Noch keine Monatsrangliste veröffentlicht. Wird von der Plattform am Periodenende freigegeben.',
    monthlyEmptyTable: 'Keine Daten für diese monatliche Rangliste',
    monthlyCategoryLabel: 'Kategorie',
    monthlyCategoryGlobal: 'Global',
    monthlyPrizePoolLabel: 'Preispool',
    selectTitle: 'GameWeek-Turnier wählen',
    selectPlaceholder: 'GameWeek-Turnier auswählen...',
    emptyHint: 'Keine GameWeek-Rangliste verfügbar. Erscheint, sobald ein Turnier berechnete Punktzahlen hat.',
    loading: 'Ranglisten werden geladen...',
    typeLabel: 'Typ',
    tableRank: 'Rang',
    tablePlayer: 'Spieler',
    tableScore: 'Punkte',
    tablePrize: 'Preis',
    emptyTable: 'Keine Ranglisten verfügbar',
    provisionalLabel: 'Vorläufige Rangliste',
    topRefTitle: 'Referrer-Rangliste',
    topRefDesc: 'Beste Referrer nach Einnahmen aus eingeladenen Nutzern. Zeitraum zum Filtern wählen.',
    topRefPeriodLabel: 'Zeitraum',
    topRefColReferrals: 'Eingeladene Nutzer',
    topRefColEarnings: 'Einnahmen (DIOS)',
    topRefEmpty: 'Noch keine Referrer in diesem Zeitraum',
    topRefPeriodAll: 'Gesamter Zeitraum',
    topRefPeriodMonthly: 'Monatlich',
    topRefPeriodSemestral: 'Dieses Halbjahr',
    topRefPeriodAnnual: 'Jährlich',
    topRefSelectMonth: 'Monat wählen',
    topRefSelectYear: 'Jahr wählen'
  },
  marketplace: {
    title: 'Marktplatz',
    balanceLabel: 'Dein Guthaben',
    tabsAuctions: 'Auktionen',
    tabsPacks: 'Packs',
    tabsSales: 'Sofortkauf',
    tabsLoans: 'Leihen',
    tabsTrades: 'Karte zu Karte',
    filtersTitle: 'Suche & Filter',
    resetFilters: 'Filter zurücksetzen',
    auctionStatusOpen: 'Offen',
    auctionStatusClosed: 'Geschlossen',
    auctionStatusClosedHint: 'Hier siehst du abgelaufene Auktionen in Bearbeitung: Zeit ist um, aber die Auktion ist noch nicht geschlossen und die Karte wurde noch nicht zugewiesen.',
    searchPlayerLabel: 'Spieler suchen',
    searchPlayerPlaceholder: 'Spielernamen eingeben...',
    rarityLabel: 'Seltenheit',
    allRarities: 'Alle Seltenheiten',
    rarityBasic: 'Basic',
    rarityPlus: 'Plus',
    rarityRare: 'Rare',
    rarityEpic: 'Epic',
    rarityUnique: 'Unique',
    positionLabel: 'Position',
    allPositions: 'Alle Positionen',
    positionGK: 'Torwart',
    positionDEF: 'Verteidiger',
    positionMID: 'Mittelfeld',
    positionATT: 'Stürmer',
    nationalityLabel: 'Nationalität',
    nationalityPlaceholder: 'z. B. Italien',
    teamLabel: 'Team',
    teamPlaceholder: 'z. B. Real Madrid',
    leagueLabel: 'Liga',
    leaguePlaceholder: 'z. B. Serie A',
    ageMinLabel: 'Alter min',
    ageMinPlaceholder: 'z. B. 18',
    ageMaxLabel: 'Alter max',
    ageMaxPlaceholder: 'z. B. 35',
    xpMinLabel: 'XP min',
    xpMinPlaceholder: 'z. B. 5',
    xpMaxLabel: 'XP max',
    xpMaxPlaceholder: 'z. B. 20',
    auctionsInfoTitle: 'Auktionen-Info',
    auctionsInfoBody: 'Auktionen werden alle 10 Minuten abgeschlossen. Wenn du gewinnst, kann die Kartenzuweisung bis zu 10 Minuten dauern.',
    secondaryMarketFilterNotice: 'Derzeit werden im Sekundärmarkt nur Divinity- und Legend-Karten (Trainer) angezeigt.',
    bidSuccess: '✅ Gebot erfolgreich! Dein Gebot ist aktiv.',
    purchaseSuccess: '✅ Karte gekauft! Prüfe deine Sammlung.',
    packSuccess: '✅ Pack geöffnet! Neue Karten zur Sammlung hinzugefügt.',
    loanSuccess: '✅ Leihe akzeptiert! Karte ist jetzt in deiner Sammlung.',
    tradeAcceptSuccess: '✅ Tausch akzeptiert! Karten getauscht.',
    tradeRejectSuccess: '✅ Tausch abgelehnt',
    counterOfferSuccess: '✅ Gegenvorschlag gesendet! Der Besitzer sieht ihn in seinen Angeboten.',
    emptyAuctionsTitle: 'Keine aktiven Auktionen',
    emptyAuctionsBody: 'Später wiederkommen für neue Auktionen',
    emptySalesTitle: 'Keine Karten verfügbar',
    emptySalesBody: 'Derzeit sind keine Karten zum Verkauf gelistet',
    emptyPacksTitle: 'Keine Packs verfügbar',
    emptyPacksBody: 'Packs werden bald verfügbar sein',
    emptyLoansTitle: 'Keine Leihen verfügbar',
    emptyLoansBody: 'Derzeit sind keine Karten zum Leihen verfügbar',
    emptyTradesTitle: 'Keine offenen Tausche',
    emptyTradesBody: 'Derzeit keine offenen Tausche. Erstelle einen aus deinen Karten!'
  },
  marketplaceCards: {
    ended: 'Beendet',
    auctionBadge: 'Auktion',
    viewCopiesAria: '{count} Kopien anzeigen',
    playerAlt: 'Spieler',
    positionLabel: 'Position',
    teamLabel: 'Team',
    rarityLabel: 'Seltenheit',
    xpLevelLabel: 'XP-Level',
    currentBidLabel: 'Aktuelles Gebot',
    currentWinnerLabel: 'Aktueller Gewinner',
    minBidLabel: 'Mindestgebot',
    bidAmountLabel: 'Dein Gebot',
    bidPlaceholder: 'Gebot eingeben (min: {amount} DIOS)',
    placingBid: 'Wird abgegeben...',
    auctionExtending: 'Timer wird aktualisiert...',
    placeBid: 'Gebot abgeben',
    quickBid: 'Schnellgebot',
    multipleCopiesHint: 'Mehrere Kopien verfügbar. Wähle eine Kopie zum Bieten.',
    viewCopiesBid: 'Kopien anzeigen & bieten',
    loginToBid: 'Bitte anmelden, um zu bieten',
    bidMinError: 'Gebot muss mindestens {amount} DIOS betragen',
    bidFailed: 'Gebot fehlgeschlagen',
    bidAuctionUpdated: 'Die Auktion wurde aktualisiert: neuer Höchstbietender und neuer Wert. Mindestgebot jetzt {amount} DIOS. Bitte aktualisieren und erneut versuchen.',
    bidOfferMinButton: 'Bieten {amount} D10S',
    copiesLoadFailed: 'Kopien konnten nicht geladen werden',
    availableCopies: 'Verfügbare Kopien ({count})',
    loadingCopies: 'Kopien werden geladen...',
    noCopies: 'Keine Kopien verfügbar.',
    auctionNumber: 'Auktion #{id}',
    none: '—',
    bidMin: 'Mindestgebot',
    customBidPlaceholder: 'Benutzerdefiniert (min {amount})',
    loginToPurchase: 'Bitte anmelden, um zu kaufen',
    purchaseOwnCard: 'Du kannst deine eigene Karte nicht kaufen',
    purchaseFailed: 'Kauf der Karte fehlgeschlagen',
    buyNowBadge: 'Sofortkauf',
    priceLabel: 'Preis',
    processing: 'Wird verarbeitet...',
    buyNowAction: 'Jetzt kaufen',
    loginToOpenPack: 'Bitte anmelden, um Packs zu öffnen',
    openPackFailed: 'Pack konnte nicht geöffnet werden',
    packDescriptionFallback: 'Entdecke tolle Karten in diesem Pack!',
    openingPack: 'Pack wird geöffnet...',
    openPack: 'Pack öffnen',
    packQuantity: 'Anzahl',
    packQuantityLabel: 'Packs kaufen',
    openingOnePack: 'Öffnung von 1 Pack',
    openingPacksCount: 'Öffnung von {count} Packs',
    nextPack: 'Nächster Pack',
    skipOpening: 'Überspringen',
    cardsAssignedSummary: '{count} Karten wurden deiner Sammlung hinzugefügt.',
    viewInProfile: 'Im Profil ansehen',
    loginToAcceptLoan: 'Bitte anmelden, um Leihen zu akzeptieren',
    acceptOwnLoan: 'Du kannst deine eigene Leihe nicht akzeptieren',
    acceptLoanFailed: 'Leihe konnte nicht akzeptiert werden',
    loanBadge: 'Leihe',
    pricePerGameweek: 'Preis pro Gameweek',
    durationLabel: 'Dauer',
    gameweeks: '{count} Gameweeks',
    totalCost: 'Gesamtkosten',
    acceptLoan: 'Leihe akzeptieren'
  },
  trade: {
    loginToAccept: 'Bitte anmelden, um Tausche zu akzeptieren',
    noRequestedCardAvailable: 'Du hast die angeforderte Karte nicht für den Tausch verfügbar',
    noRequestedCard: 'Du hast die angeforderte Karte nicht',
    loadCardsFailed: 'Deine Karten konnten nicht geladen werden',
    acceptFailed: 'Tausch konnte nicht akzeptiert werden',
    loginToReject: 'Bitte anmelden, um Tausche abzulehnen',
    rejectFailed: 'Tausch konnte nicht abgelehnt werden',
    loginToCounter: 'Bitte anmelden, um Gegenvorschläge zu machen',
    noCardsForCounter: 'Keine verfügbaren Karten für Gegenvorschlag',
    selectCardForCounter: 'Bitte wähle eine Karte für den Gegenvorschlag',
    createCounterFailed: 'Gegenvorschlag konnte nicht erstellt werden',
    openTrade: 'Offener Tausch',
    offerFrom: 'Tauschangebot von {username}',
    byUser: 'Von: {username}',
    expires: 'Läuft ab: {date}',
    theyOffer: 'Sie bieten',
    theyWant: 'Sie wollen',
    youGive: 'Du gibst',
    unknownPlayer: 'Unbekannter Spieler',
    unknownRarity: 'Unbekannte Seltenheit',
    accept: 'Tausch akzeptieren',
    makeCounter: 'Gegenvorschlag machen',
    counterOffer: 'Gegenvorschlag',
    reject: 'Ablehnen',
    ownerHint: 'Dies ist dein Tauschangebot. Warte, bis andere akzeptieren oder Gegenvorschläge machen.',
    selectCardTitle: 'Karte zum Tauschen auswählen',
    youWillReceive: 'Du erhältst',
    youWillGive: 'Du gibst',
    selectWhichCard: 'Wähle, welche Karte du tauschen möchtest:',
    makeCounterTitle: 'Gegenvorschlag machen',
    counterHint: 'Du hast die angeforderte Karte nicht, aber du kannst eine deiner Karten anbieten.',
    selectCardToOffer: 'Karte zum Anbieten auswählen:',
    selectCardPlaceholder: '-- Karte auswählen --',
    sendCounter: 'Gegenvorschlag senden',
    sending: 'Wird gesendet...',
    counterOfferTitle: 'Gegenvorschlag',
    youWant: 'Du willst',
    yourCard: 'Deine Karte',
    theirCard: 'Ihre Karte',
    selectCardInstead: 'Wähle stattdessen eine Karte zum Anbieten:',
    creating: 'Wird erstellt...'
  },
  tournaments: {
    title: 'GameWeeks & Turniere',
    create: 'Turnier erstellen',
    filterTitle: 'Nach Typ filtern',
    filterAll: 'Alle',
    filterGameweek: 'GameWeeks',
    filterPrivate: 'Privat',
    filterThematic: 'Thematisch',
    loading: 'Turniere werden geladen...',
    emptyGameweeks: 'Derzeit keine aktiven GameWeeks',
    emptyTournaments: 'Keine Turniere verfügbar',
    statusInProgress: 'IN PROGRESS',
    statusPendingPayment: 'ZAHLUNG AUSSTEHEND',
    statusClosed: 'GESCHLOSSEN',
    statusUpcoming: 'KOMMEND',
    statusOpen: 'OFFEN',
    checkScores: 'Scores ansehen',
    viewGameweekScores: 'Gameweek-Scores ansehen',
    viewTournamentScores: 'Turnier-Scores ansehen',
    availableTournaments: '{count} Turniere verfügbar',
    participants: '{count} Teilnehmer',
    free: 'Gratis',
    registered: 'Registriert',
    editFormation: 'Formation bearbeiten',
    enter: 'Teilnehmen',
    entriesClosed: 'GameWeek läuft - Anmeldungen geschlossen',
    starts: 'Startet',
    ends: 'Ende',
    countdownFormationLocksIn: 'Formation gesperrt in',
    countdownFormationLocked: 'Formation gesperrt',
    countdownStartsIn: 'Startet in',
    countdownEndsIn: 'Endet in',
    countdownEnded: 'Beendet',
    buyIn: 'Einsatz',
    buyInAmount: '{amount} DIOS',
    gameweekPricing: 'Basic: Gratis | Plus: 5 | Rare: 10 | Epic: 25 | Unique: 50 DIOS',
    rarityLabel: 'Seltenheit',
    rarityBasic: 'Basic',
    inProgressClosed: 'Läuft - Anmeldungen geschlossen',
    joinGameweek: 'GameWeek beitreten',
    joinFreeGameweek: 'Kostenloser GameWeek beitreten',
    enterTournament: 'Turnier beitreten',
    joinFree: 'Kostenlos beitreten',
    prizePool: 'Preisgeld',
    prize: 'Preis'
  },
  notifications: {
    title: 'Benachrichtigungen',
    markAllRead: 'Alle als gelesen markieren',
    noNotifications: 'Keine Benachrichtigungen',
    ariaLabel: 'Benachrichtigungen',
    justNow: 'Gerade eben',
    minutesAgo: 'vor {count} Min',
    hoursAgo: 'vor {count} Std',
    daysAgo: 'vor {count} Tg'
  },
  profile: {
    tabs: {
      myCards: 'Meine Karten',
      soldLoans: 'Verkauft & Leihen',
      activityReport: 'Aktivitätsbericht',
      offers: 'Angebote',
      referrals: 'Empfehlungen',
      loginHistory: 'Login-Verlauf',
      security: 'Sicherheit',
      notifications: 'Benachrichtigungen',
      settings: 'Einstellungen'
    }
  },
  activityReport: {
    title: 'Aktivitätsbericht',
    last7Days: 'Letzte 7 Tage',
    downloadCsv: 'CSV herunterladen',
    loading: 'Aktivitäten werden geladen...',
    empty: 'Keine Aktivitäten in den letzten 7 Tagen.',
    category: {
      deposit: 'Einzahlung',
      withdrawal: 'Auszahlung',
      prize: 'Preis',
      marketplace: 'Marketplace'
    },
    action: {
      deposit: 'Einzahlung',
      withdrawal: 'Auszahlung',
      purchase: 'Kauf',
      sale: 'Verkauf',
      loanBorrow: 'Leihe (nehmen)',
      loanLend: 'Leihe (geben)',
      gameweekPrize: 'Gameweek-Preis'
    }
  },
  cardsStatus: {
    cardsForSale: 'Karten zum Verkauf',
    soldCards: 'Verkaufte Karten',
    loanedCards: 'Gewährte Leihen',
    borrowedCards: 'Geliehene Karten',
    forSaleLabel: 'Zum Verkauf',
    soldLabel: 'Verkauft',
    loanedLabel: 'Verliehen',
    borrowedLabel: 'Geliehen',
    listedDate: 'Eingestellt',
    saleDate: 'Verkaufsdatum',
    startDate: 'Startdatum',
    duration: 'Dauer: {count} GW',
    emptyCardsForSale: 'Keine Karten zum Verkauf.',
    emptySold: 'Keine verkauften Karten.',
    emptyLoaned: 'Keine gewährten Leihen.',
    emptyBorrowed: 'Keine aktiven geliehenen Karten.',
    removeFromSale: 'Aus Verkauf entfernen',
    confirmRemoveFromSale: 'Diese Karte aus dem Verkauf entfernen?',
    removeFromSaleFailed: 'Entfernen aus dem Verkauf fehlgeschlagen'
  },
  loginHistory: {
    title: 'Login-Verlauf',
    total: 'Gesamt: {count}',
    loading: 'Login-Verlauf wird geladen...',
    empty: 'Kein Login-Verlauf gefunden',
    success: 'Erfolgreich',
    failed: 'Fehlgeschlagen',
    reason: 'Grund',
    ip: 'IP',
    location: 'Ort'
  },
  security: {
    titleSecurity: 'Sicherheitsberichte',
    titleSupport: 'Support-Tickets',
    total: 'Gesamt: {count}',
    reportIssue: 'Problem melden',
    createFirst: 'Ersten Bericht erstellen',
    loadingSecurity: 'Sicherheitsberichte werden geladen...',
    loadingSupport: 'Support-Tickets werden geladen...',
    emptySecurity: 'Keine Sicherheitsberichte gefunden',
    emptySupport: 'Keine Support-Tickets gefunden',
    sectionSecurity: 'Sicherheitsberichte',
    sectionSupport: 'Support-Tickets',
    created: 'Erstellt',
    resolved: 'Gelöst',
    adminNotes: 'Admin-Notizen',
    botReply: 'Bot-Antwort',
    reportModalTitle: 'Sicherheitsproblem melden',
    reportType: 'Berichtstyp',
    priority: 'Priorität',
    title: 'Titel',
    description: 'Beschreibung',
    titlePlaceholder: 'Kurze Beschreibung',
    descriptionPlaceholder: 'Detaillierte Beschreibung des Sicherheitsproblems',
    reportTypeOptions: {
      accountCompromise: 'Konto kompromittiert',
      suspiciousActivity: 'Verdächtige Aktivität',
      phishing: 'Phishing',
      unauthorizedAccess: 'Unbefugter Zugriff',
      other: 'Sonstiges'
    },
    priorityOptions: {
      low: 'Niedrig',
      medium: 'Mittel',
      high: 'Hoch',
      critical: 'Kritisch'
    },
    openSupportTicket: 'Support-Ticket öffnen',
    supportTicketModalTitle: 'Neues Support-Ticket',
    supportSubject: 'Betreff (optional)',
    supportSubjectPlaceholder: 'Kurze Zusammenfassung (optional)',
    supportMessage: 'Nachricht',
    supportMessagePlaceholder: 'Beschreiben Sie Ihr Anliegen ausführlich.',
    submitSupportTicket: 'Ticket senden',
    supportTicketError: 'Ticket konnte nicht erstellt werden. Bitte erneut versuchen.',
    submit: 'Bericht senden',
    cancel: 'Abbrechen'
  },
  notificationsTab: {
    maintenanceTitle: 'Wartungswarnungen',
    announcementsTitle: 'Systemankündigungen',
    personalTitle: 'Persönliche Benachrichtigungen',
    unread: '{count} ungelesen',
    markAllRead: 'Alle als gelesen markieren',
    noMaintenance: 'Keine Wartungswarnungen',
    noAnnouncements: 'Keine Ankündigungen',
    noPersonal: 'Keine Benachrichtigungen gefunden',
    clickToView: 'Klicken zum Ansehen →',
    scheduled: 'Geplant',
    affects: 'Betrifft'
  },
  gdpr: {
    bannerTitle: 'Datenschutz & Cookies',
    bannerDescription: 'Wir verwenden Cookies und ähnliche Technologien, um die Website zu betreiben, deine Erfahrung zu verbessern und Inhalte zu personalisieren. Du kannst alle akzeptieren, optionale ablehnen oder deine Auswahl anpassen.',
    acceptAll: 'Alle akzeptieren',
    rejectOptional: 'Optionale ablehnen',
    customize: 'Anpassen',
    preferencesTitle: 'Cookie-Einstellungen',
    preferencesIntro: 'Wähle, welche Cookie-Kategorien du erlaubst. Notwendige Cookies sind für die Website erforderlich und können nicht deaktiviert werden.',
    necessary: 'Notwendig',
    necessaryDesc: 'Essenziell für die Funktion der Website (z. B. Sitzung, Sicherheit).',
    analytics: 'Analytik',
    analyticsDesc: 'Helfen uns zu verstehen, wie du die Website nutzt, um sie zu verbessern.',
    preferencesCat: 'Einstellungen',
    preferencesDesc: 'Merken sich deine Einstellungen und Präferenzen.',
    marketing: 'Marketing',
    marketingDesc: 'Werden für relevante Werbung und Marketing verwendet (falls wir sie nutzen).',
    alwaysOn: 'Immer an',
    savePreferences: 'Einstellungen speichern',
    cookiePreferencesLink: 'Cookie-Einstellungen'
  },
  legal: {
    platformOwner: 'The platform owner is Uilliam Dettori.'
  },
  settingsExtra: {
    walletAssociatedLabel: 'Wallet mit deinem Konto verknüpft:',
    walletConnectedLabel: 'Aktuell verbundene Wallet:',
    walletMismatchTitle: 'Wallet stimmt nicht überein',
    walletMismatchBody: 'Die verbundene Wallet stimmt nicht mit der verknüpften Wallet überein. Verbinde die richtige Wallet, um alle Funktionen zu nutzen.',
    walletConnected: 'Verbundene Wallet',
    walletSaveSuccess: 'Wallet erfolgreich verknüpft!',
    walletSaveError: 'Fehler beim Speichern der Wallet: {message}',
    walletConnectError: 'Fehler beim Verbinden der Wallet: {message}',
    saveWallet: 'Diese Wallet mit deinem Konto verknüpfen',
    saveWalletConfirm: 'Ja, Wallet verknüpfen',
    savingWallet: 'Wird gespeichert...',
    walletMobileHint: 'Auf dem Handy: Wenn der Bildschirm aufgeht, wähle deine Wallet-App oder scanne den QR-Code.',
    walletConnectedReadyInfo: 'Du kannst diese Wallet für Ein- und Auszahlungen nutzen. Kein erneutes Verbinden nötig.',
    walletModalTitle: 'Wallet verbunden',
    walletModalConnectedSuccess: 'Wallet erfolgreich verbunden:',
    walletModalQuestion: 'Möchtest du diese Wallet mit deinem Konto verknüpfen? So kannst du sie für zukünftige Transaktionen nutzen.',
    walletModalSkip: 'Nein, überspringen'
  },
  supportWidget: {
    buttonOpen: 'Hilfe',
    title: 'Support',
    closeAria: 'Schließen',
    sendAria: 'Senden',
    openTelegram: 'Telegram öffnen',
    loadingReply: 'Ich suche nach einer Antwort...',
    escalateAction: 'Support-Ticket öffnen',
    inputPlaceholder: 'Hier schreiben...',
    welcomeMessage: 'Ich kann bei Einzahlungen, Auszahlungen, Marketplace, Auktionen, Packs, Turnieren, Referral oder Konto helfen. Wenn nötig, leite ich an einen Mitarbeiter weiter, oder du kontaktierst den Support direkt über Telegram.',
    fallbackNotUnderstood: 'Ich habe das nicht verstanden. Möchtest du mit einem Mitarbeiter sprechen?',
    temporaryError: 'Vorübergehender Fehler. Bitte versuche es erneut oder kontaktiere einen Mitarbeiter.',
    loginRequired: 'Um ein Support-Ticket zu öffnen, musst du dich zuerst anmelden.',
    writeRequestHint: 'Schreibe deine Anfrage unten und tippe erneut auf "Support-Ticket öffnen", oder sende zuerst eine Nachricht an den Bot.',
    escalatedTicket: 'Deine Anfrage wurde an einen Mitarbeiter weitergeleitet. Ticket #{ticketId}',
    escalateFailed: 'Ich kann gerade keinen Mitarbeiter erreichen. Bitte versuche es in Kürze erneut.',
    quickHome: 'Startseite',
    quickMarketplace: 'Marketplace',
    quickTournaments: 'Turniere',
    quickRankings: 'Rankings',
    quickDeposit: 'Einzahlung',
    quickProfile: 'Profil'
  },
  depositPage: {
    title: 'Guthaben einzahlen',
    chooseMethod: 'Wähle, wie du einzahlen möchtest',
    methodBonifico: 'Banküberweisung (SEPA)',
    methodPostepay: 'Postepay-Aufladung',
    bonificoTitle: 'Banküberweisung (SEPA)',
    bonificoLead: 'Überweise per SEPA auf die angegebene IBAN. Gib im Verwendungszweck deinen ',
    usernameEmphasis: 'DIOS-Benutzernamen',
    bonificoTail: ' an, damit wir die Zahlung zuordnen können. 1 EUR = 1 DIOS. Die Gutschrift erfolgt nicht automatisch und wird manuell geprüft.',
    postepayTitle: 'Postepay-Aufladung',
    postepayLead: 'Nutze die unten stehenden Daten für die Aufladung. ',
    postepayCausaleLabel: 'Verwendungszweck:',
    postepayMid: ' gib deinen ',
    postepayTail: ' ein (derselbe wie beim Login). Die Gutschrift erfolgt nicht automatisch und wird manuell geprüft.',
    labelIban: 'IBAN',
    labelAccountHolder: 'Kontoinhaber',
    labelCardNumber: 'Kartennummer',
    labelExpiry: 'Gültigkeit',
    labelFiscalCode: 'Steuer-ID (Inhaber)',
    copyIban: 'IBAN kopieren',
    copy: 'Kopieren',
    copyNumber: 'Nummer kopieren',
    copyFiscalCode: 'Steuer-ID kopieren',
    copied: 'Kopiert ✓',
    stripeUnavailableTitle: 'Derzeit nicht verfügbar'
  },
  confirmD10S: {
    first: 'Du bist dabei, {amount} DIOS auszugeben für: {action}. Fortfahren?',
    second: 'Bestätige erneut, um fortzufahren.',
    actionDeposit: 'Einzahlung',
    actionWithdraw: 'Auszahlung',
    actionListSale: 'Zum Verkauf anbieten',
    actionListLoan: 'Zum Verleih anbieten',
    firstListSale: 'Du bist dabei, diese Karte für {amount} DIOS zum Verkauf anzubieten. Fortfahren?',
    firstListLoan: 'Du bist dabei, diese Karte zu verleihen (Gesamt {amount} DIOS). Fortfahren?',
    titleFirst: 'Vorgang bestätigen',
    titleSecond: 'Abschließende Bestätigung',
    confirmContinue: 'Weiter',
    confirmFinal: 'Ja, fortfahren'
  }
};

const pt = {
  common: {
    language: 'Idioma',
    save: 'Guardar definições',
    saving: 'A guardar...',
    continue: 'Continuar',
    search: 'Pesquisar',
    cancel: 'Cancelar',
    previous: 'Anterior',
    next: 'Seguinte',
    pageOf: 'Página {page} de {total}',
    loading: 'A carregar...',
    notAvailable: 'N/D',
    unknown: 'Desconhecido',
    processing: 'A processar...'
  },
  onboarding: {
    chooseLanguageTitle: 'Escolhe o teu idioma',
    chooseLanguageSubtitle: 'Seleciona o teu idioma preferido para o jogo',
    savingLanguage: 'A guardar...'
  },
  navbar: {
    searchPlaceholder: 'Pesquisar jogador por nome...',
    searchAriaLabel: 'Pesquisar',
    searching: 'A pesquisar...',
    noResults: 'Sem resultados',
    totalCards: 'Total de cartas',
    company: 'Empresa',
    errorSearch: 'Erro de pesquisa',
    signIn: 'Iniciar sessão',
    register: 'Registar',
    adminPanel: 'Painel de admin',
    rules: 'Regras',
    musicMute: 'Desativar música de fundo',
    musicUnmute: 'Ativar música de fundo'
  },
  rules: {
    mobileTitle: 'Regras DIOS10',
    mobileDesc: 'No telemóvel abre o PDF no navegador para uma leitura óptima.',
    openPdf: 'Abrir PDF no navegador'
  },
  auth: {
    signIn: 'Iniciar sessão',
    signingIn: 'A iniciar sessão...',
    email: 'Email',
    password: 'Palavra-passe',
    forgotPassword: 'Esqueceste-te da palavra-passe?',
    noAccount: 'Não tens uma conta?',
    registerNow: 'Regista-te agora',
    fillAllFields: 'Preenche todos os campos',
    loginFailed: 'Falha no login. Verifica as credenciais.',
    emailVerified: 'E-mail verificado. Já podes iniciar sessão.',
    emailVerifiedInvalid: 'Ligação de verificação inválida ou expirada.',
    createAccount: 'Cria a tua conta',
    chooseUsername: 'Escolhe o teu nome de utilizador',
    username: 'Nome de utilizador',
    confirmPassword: 'Confirmar palavra-passe',
    referralCode: 'Código de referência (opcional)',
    referralPlaceholder: 'Introduz o código de referência se tiveres',
    confirmPasswordPlaceholder: 'Confirma a tua palavra-passe',
    minimumCharacters: 'Mínimo 6 caracteres',
    creatingAccount: 'A criar conta...',
    startJourney: 'Começa a tua jornada',
    alreadyAccount: 'Já tens uma conta?',
    terms: 'Ao registar-te, aceitas os nossos Termos de Serviço',
    passwordMismatch: 'As palavras-passe não coincidem',
    passwordShort: 'A palavra-passe deve ter pelo menos 6 caracteres',
    registrationPending: 'Registo pendente. Verifica o teu email através do link que te enviamos. Não podes iniciar sessão até verificar o email.',
    registrationSuccess: 'Registo concluído. Já podes iniciar sessão.',
    registrationFailed: 'Falha no registo. Tenta novamente.',
    forgotTitle: 'Esqueceste-te da palavra-passe?',
    forgotSubtitle: 'Introduz o teu email e enviaremos um link para redefinir a palavra-passe.',
    sendResetLink: 'Enviar link de reposição',
    sending: 'A enviar...',
    resetToken: 'Token de reposição',
    setNewPassword: 'Definir nova palavra-passe',
    newPassword: 'Nova palavra-passe',
    confirmNewPassword: 'Confirmar nova palavra-passe',
    resetPassword: 'Redefinir palavra-passe',
    resetting: 'A redefinir...',
    resetTokenRequired: 'O token de reposição é obrigatório',
    resetPasswordShort: 'A palavra-passe deve ter pelo menos 8 caracteres',
    resetSuccess: 'Palavra-passe redefinida com sucesso! A redirecionar para o login...',
    resetFailed: 'Falha ao redefinir a palavra-passe. O token pode ser inválido ou expirado.',
    requestResetSuccess: 'Se este email existir, foi enviado um link de reposição.',
    requestResetToken: 'Link enviado! Token: {token} (Copia este token para testes)',
    addToHomeTitle: 'Adicionar ao ecrã inicial',
    addToHomeMessage: 'Esta app funciona melhor como aplicação. Guarda a app no ecrã inicial do teu telemóvel para a melhor experiência.',
    addToHomeButton: 'Guardar no ecrã inicial',
    addToHomeDontShowAgain: 'Não mostrar mais esta mensagem',
    addToHomeGotIt: 'Entendido',
    addToHomeStepsSafari: 'No Safari: 1) Toca no botão Partilhar (quadrado com seta) em baixo. 2) Desliza e seleciona "Adicionar ao Ecrã Inicial". 3) Toca em "Adicionar".',
    addToHomeStepsChrome: 'No Chrome: 1) Toca no ícone Partilhar (ou menu 3 pontos) na barra de endereço. 2) Seleciona "Adicionar ao Ecrã Inicial". 3) Toca em "Adicionar".',
    addToHomeStepsFirefox: 'No Firefox: 1) Toca no ícone Partilhar na barra de endereço. 2) Seleciona "Adicionar ao Ecrã Inicial". 3) Toca em "Adicionar".',
    addToHomeStepsEdge: 'No Edge: 1) Toca no ícone Partilhar (ou menu 3 pontos) na barra de endereço. 2) Seleciona "Adicionar ao Ecrã Inicial". 3) Toca em "Adicionar".',
    addToHomeStepsSamsung: 'No Samsung Internet: 1) Toca no menu (3 linhas). 2) Seleciona "Adicionar página a" > "Ecrã inicial". 3) Toca em "Adicionar".',
    addToHomeStepsOpera: 'No Opera: 1) Toca no ícone do menu. 2) Seleciona "Adicionar ao Ecrã Inicial". 3) Toca em "Adicionar".',
    addToHomeStepsDefault: '1) Toca no ícone Partilhar ou menu do navegador. 2) Procura "Adicionar ao Ecrã Inicial" ou similar. 3) Toca em "Adicionar".'
  },
  home: {
    marketplace: 'MERCADO',
    tournaments: 'TORNEIOS',
    rankings: 'CLASSIFICAÇÕES',
    marketplaceDesc: 'Compra e vende cartas',
    tournamentsDesc: 'Compete em GameWeeks',
    rankingsDesc: 'Classificações',
    activeGameweeks: 'GAMEWEEKS ATIVAS',
    tournamentsCount: '{count} Torneios'
  },
  settings: {
    title: 'Definições',
    walletConnection: 'Ligação da wallet',
    walletConnected: 'Ligado',
    connectWallet: 'Ligar wallet',
    disconnectWallet: 'Desligar',
    connecting: 'A ligar...',
    languageLabel: 'Idioma',
    tutorialCompleted: 'Tutorial concluído',
    soundsEnabled: 'Efeitos sonoros',
    soundsEnabledDesc: 'Reproduzir sons ao clicar e durante as ações do jogo',
    musicEnabled: 'Música de fundo',
    musicEnabledDesc: 'Reproduzir música de fundo após o login',
    musicVolume: 'Volume da música',
    musicVolumeMobile: 'No telemóvel, o volume é controlado pelo dispositivo.',
    accountTitle: 'Conta',
    logout: 'Terminar sessão',
    saveSuccess: 'Definições guardadas com sucesso.',
    saveFailed: 'Falha ao guardar definições.',
    passwordSectionTitle: 'Redefinir palavra-passe',
    currentPassword: 'Palavra-passe atual',
    currentPasswordPlaceholder: 'Introduz a tua palavra-passe atual',
    newPassword: 'Nova palavra-passe',
    newPasswordPlaceholder: 'Introduz a tua nova palavra-passe',
    confirmNewPassword: 'Confirmar nova palavra-passe',
    confirmNewPasswordPlaceholder: 'Repete a tua nova palavra-passe',
    changePassword: 'Confirmar alteração da palavra-passe',
    changingPassword: 'A atualizar palavra-passe...',
    passwordFillAllFields: 'Preenche todos os campos da palavra-passe.',
    passwordMinLength: 'A nova palavra-passe deve ter pelo menos 8 caracteres.',
    passwordMismatch: 'As novas palavras-passe não coincidem.',
    passwordMustDiffer: 'A nova palavra-passe deve ser diferente da atual.',
    passwordChangeSuccess: 'Palavra-passe atualizada com sucesso.',
    passwordChangeFailed: 'Não foi possível atualizar a palavra-passe.'
  },
  rankings: {
    title: 'Classificações',
    gameweekSectionTitle: 'Classificações GameWeek',
    gameweekSectionDesc: 'Classificação oficial de cada torneio GameWeek: posição, pontuação final e prémio. Escolhe torneio e categoria (Basic, Plus, Rare, Epic, Unique) no menu.',
    monthlySectionTitle: 'Classificações mensais',
    monthlySectionDesc: 'Classificações oficiais publicadas pela plataforma: a pontuação é a soma dos resultados das GameWeek do período (mesma categoria).',
    monthlySelectTitle: 'Escolher classificação mensal',
    monthlySelectPlaceholder: 'Seleciona uma classificação mensal...',
    monthlyEmptyHint: 'Ainda não há classificação mensal publicada. São publicadas pela plataforma no fim do período.',
    monthlyEmptyTable: 'Sem dados para esta classificação mensal',
    monthlyCategoryLabel: 'Categoria',
    monthlyCategoryGlobal: 'Global',
    monthlyPrizePoolLabel: 'Prémios',
    selectTitle: 'Escolher torneio GameWeek',
    selectPlaceholder: 'Seleciona um torneio GameWeek...',
    emptyHint: 'Não há classificações GameWeek disponíveis. Aparecem quando um torneio tem pontuações calculadas.',
    loading: 'A carregar classificações...',
    typeLabel: 'Tipo',
    tableRank: 'Posição',
    tablePlayer: 'Jogador',
    tableScore: 'Pontuação',
    tablePrize: 'Prémio',
    emptyTable: 'Não há classificações disponíveis',
    topRefTitle: 'Classificação de Referrals',
    topRefDesc: 'Melhores referrers por ganhos de utilizadores convidados. Escolha o período a mostrar.',
    topRefPeriodLabel: 'Período de referência',
    topRefColReferrals: 'Utilizadores convidados',
    topRefColEarnings: 'Ganhos (DIOS)',
    topRefEmpty: 'Ainda não há referrers neste período',
    topRefPeriodAll: 'Sempre',
    topRefPeriodMonthly: 'Mensal',
    topRefPeriodSemestral: 'Este semestre',
    topRefPeriodAnnual: 'Anual',
    topRefSelectMonth: 'Selecionar mês',
    topRefSelectYear: 'Selecionar ano'
  },
  marketplace: {
    title: 'Mercado',
    balanceLabel: 'O teu saldo',
    tabsAuctions: 'Leilões',
    tabsPacks: 'Packs',
    tabsSales: 'Comprar já',
    tabsLoans: 'Empréstimos',
    tabsTrades: 'Carta por carta',
    filtersTitle: 'Pesquisa e filtros',
    resetFilters: 'Redefinir filtros',
    auctionStatusOpen: 'Abertos',
    auctionStatusClosed: 'Fechados',
    auctionStatusClosedHint: 'Aqui vês leilões expirados em processamento: o tempo acabou mas o leilão ainda não foi fechado e a carta não foi atribuída.',
    searchPlayerLabel: 'Pesquisar jogador',
    searchPlayerPlaceholder: 'Introduz o nome do jogador...',
    rarityLabel: 'Raridade',
    allRarities: 'Todas as raridades',
    rarityBasic: 'Basic',
    rarityPlus: 'Plus',
    rarityRare: 'Rare',
    rarityEpic: 'Epic',
    rarityUnique: 'Unique',
    positionLabel: 'Posição',
    allPositions: 'Todas as posições',
    positionGK: 'Guarda-redes',
    positionDEF: 'Defesa',
    positionMID: 'Médio',
    positionATT: 'Avançado',
    nationalityLabel: 'Nacionalidade',
    nationalityPlaceholder: 'ex. Itália',
    teamLabel: 'Equipa',
    teamPlaceholder: 'ex. Real Madrid',
    leagueLabel: 'Liga',
    leaguePlaceholder: 'ex. Serie A',
    ageMinLabel: 'Idade mín',
    ageMinPlaceholder: 'ex. 18',
    ageMaxLabel: 'Idade máx',
    ageMaxPlaceholder: 'ex. 35',
    xpMinLabel: 'XP mín',
    xpMinPlaceholder: 'ex. 5',
    xpMaxLabel: 'XP máx',
    xpMaxPlaceholder: 'ex. 20',
    auctionsInfoTitle: 'Info leilões',
    auctionsInfoBody: 'Os leilões são finalizados a cada 10 minutos. Se ganhares, a atribuição da carta pode demorar até 10 minutos.',
    secondaryMarketFilterNotice: 'Atualmente, apenas cartas Divinity e Legend (Treinador) são exibidas no mercado secundário.',
    bidSuccess: '✅ Licitação feita! A tua licitação está ativa.',
    purchaseSuccess: '✅ Carta comprada! Verifica a tua coleção.',
    packSuccess: '✅ Pack aberto! Novas cartas adicionadas à tua coleção.',
    loanSuccess: '✅ Empréstimo aceite! A carta está agora na tua coleção.',
    tradeAcceptSuccess: '✅ Troca aceite! Cartas trocadas.',
    tradeRejectSuccess: '✅ Troca rejeitada',
    counterOfferSuccess: '✅ Contraoferta enviada! O proprietário verá nas ofertas.',
    emptyAuctionsTitle: 'Nenhum leilão ativo',
    emptyAuctionsBody: 'Volta mais tarde para novas oportunidades',
    emptySalesTitle: 'Nenhuma carta disponível',
    emptySalesBody: 'Não há cartas à venda neste momento',
    emptyPacksTitle: 'Nenhum pack disponível',
    emptyPacksBody: 'Os packs estarão disponíveis em breve',
    emptyLoansTitle: 'Nenhum empréstimo disponível',
    emptyLoansBody: 'Não há cartas disponíveis para empréstimo',
    emptyTradesTitle: 'Nenhuma troca aberta',
    emptyTradesBody: 'Não há trocas abertas neste momento. Cria uma com as tuas cartas!'
  },
  marketplaceCards: {
    ended: 'Terminada',
    auctionBadge: 'Leilão',
    viewCopiesAria: 'Ver {count} cópias',
    playerAlt: 'Jogador',
    positionLabel: 'Posição',
    teamLabel: 'Equipa',
    rarityLabel: 'Raridade',
    xpLevelLabel: 'Nível de XP',
    currentBidLabel: 'Licitação atual',
    currentWinnerLabel: 'Vencedor atual',
    minBidLabel: 'Licitação mínima',
    bidAmountLabel: 'A tua licitação',
    bidPlaceholder: 'Introduz a licitação (mín: {amount} DIOS)',
    placingBid: 'A enviar...',
    auctionExtending: 'A atualizar temporizador...',
    placeBid: 'Fazer licitação',
    quickBid: 'Licitação rápida',
    multipleCopiesHint: 'Existem várias cópias. Seleciona uma cópia para licitar.',
    viewCopiesBid: 'Ver cópias e licitar',
    loginToBid: 'Inicia sessão para licitar',
    bidMinError: 'A licitação deve ser pelo menos {amount} DIOS',
    bidFailed: 'Falha ao licitar',
    bidAuctionUpdated: 'O leilão foi atualizado: novo licitante e novo valor. Licitação mínima agora {amount} DIOS. Atualize e tente novamente.',
    bidOfferMinButton: 'Licitar {amount} D10S',
    copiesLoadFailed: 'Falha ao carregar cópias',
    availableCopies: 'Cópias disponíveis ({count})',
    loadingCopies: 'A carregar cópias...',
    noCopies: 'Sem cópias disponíveis.',
    auctionNumber: 'Leilão #{id}',
    none: '—',
    bidMin: 'Licitação mín',
    customBidPlaceholder: 'Personalizada (mín {amount})',
    loginToPurchase: 'Inicia sessão para comprar',
    purchaseOwnCard: 'Não podes comprar a tua própria carta',
    purchaseFailed: 'Falha ao comprar a carta',
    buyNowBadge: 'Comprar já',
    priceLabel: 'Preço',
    processing: 'A processar...',
    buyNowAction: 'Comprar agora',
    loginToOpenPack: 'Inicia sessão para abrir packs',
    openPackFailed: 'Falha ao abrir o pack',
    packDescriptionFallback: 'Descobre cartas incríveis neste pack!',
    openingPack: 'A abrir pack...',
    openPack: 'Abrir pack',
    packQuantity: 'Quantidade',
    packQuantityLabel: 'Packs a comprar',
    openingOnePack: 'abertura de 1 pack',
    openingPacksCount: 'abertura de {count} packs',
    nextPack: 'Próximo pack',
    skipOpening: 'Saltar',
    cardsAssignedSummary: '{count} cartas adicionadas à tua coleção.',
    viewInProfile: 'Ver no Perfil',
    loginToAcceptLoan: 'Inicia sessão para aceitar empréstimos',
    acceptOwnLoan: 'Não podes aceitar o teu próprio empréstimo',
    acceptLoanFailed: 'Falha ao aceitar empréstimo',
    loanBadge: 'Empréstimo',
    pricePerGameweek: 'Preço por Gameweek',
    durationLabel: 'Duração',
    gameweeks: '{count} Gameweeks',
    totalCost: 'Custo total',
    acceptLoan: 'Aceitar empréstimo'
  },
  trade: {
    loginToAccept: 'Inicia sessão para aceitar trocas',
    noRequestedCardAvailable: 'Não tens a carta solicitada disponível para troca',
    noRequestedCard: 'Não tens a carta solicitada',
    loadCardsFailed: 'Falha ao carregar as tuas cartas',
    acceptFailed: 'Falha ao aceitar a troca',
    loginToReject: 'Inicia sessão para rejeitar trocas',
    rejectFailed: 'Falha ao rejeitar a troca',
    loginToCounter: 'Inicia sessão para fazer contraofertas',
    noCardsForCounter: 'Sem cartas disponíveis para contraoferta',
    selectCardForCounter: 'Seleciona uma carta para contraoferta',
    createCounterFailed: 'Falha ao criar contraoferta',
    openTrade: 'Troca aberta',
    offerFrom: 'Oferta de troca de {username}',
    byUser: 'Por: {username}',
    expires: 'Expira: {date}',
    theyOffer: 'Eles oferecem',
    theyWant: 'Eles querem',
    youGive: 'Tu dás',
    unknownPlayer: 'Jogador desconhecido',
    unknownRarity: 'Raridade desconhecida',
    accept: 'Aceitar troca',
    makeCounter: 'Fazer contraoferta',
    counterOffer: 'Contraoferta',
    reject: 'Rejeitar',
    ownerHint: 'Esta é a tua oferta de troca. Espera que outros aceitem ou façam contraofertas.',
    selectCardTitle: 'Selecionar carta para trocar',
    youWillReceive: 'Vais receber',
    youWillGive: 'Vais dar',
    selectWhichCard: 'Seleciona que carta trocar:',
    makeCounterTitle: 'Fazer contraoferta',
    counterHint: 'Não tens a carta solicitada, mas podes oferecer uma das tuas cartas.',
    selectCardToOffer: 'Seleciona uma carta para oferecer:',
    selectCardPlaceholder: '-- Seleciona uma carta --',
    sendCounter: 'Enviar contraoferta',
    sending: 'A enviar...',
    counterOfferTitle: 'Contraoferta',
    youWant: 'Tu queres',
    yourCard: 'A tua carta',
    theirCard: 'A carta deles',
    selectCardInstead: 'Seleciona uma carta para oferecer em alternativa:',
    creating: 'A criar...'
  },
  tournaments: {
    title: 'GameWeeks e Torneios',
    create: 'Criar torneio',
    filterTitle: 'Filtrar por tipo',
    filterAll: 'Todos',
    filterGameweek: 'GameWeeks',
    filterPrivate: 'Privados',
    filterThematic: 'Temáticos',
    loading: 'A carregar torneios...',
    emptyGameweeks: 'Nenhuma GameWeek ativa no momento',
    emptyTournaments: 'Nenhum torneio disponível',
    statusInProgress: 'EM CURSO',
    statusPendingPayment: 'PAGAMENTO PENDENTE',
    statusClosed: 'FECHADO',
    statusUpcoming: 'EM BREVE',
    statusOpen: 'ABERTO',
    checkScores: 'Ver pontuações',
    viewGameweekScores: 'Ver pontuações da gameweek',
    viewTournamentScores: 'Ver pontuações do torneio',
    availableTournaments: '{count} Torneios disponíveis',
    participants: '{count} participantes',
    free: 'Grátis',
    registered: 'Registado',
    editFormation: 'Editar formação',
    enter: 'Entrar',
    entriesClosed: 'GameWeek em curso - inscrições fechadas',
    starts: 'Começa',
    ends: 'Fim',
    countdownFormationLocksIn: 'Formação bloqueada em',
    countdownFormationLocked: 'Formação bloqueada',
    countdownStartsIn: 'Começa em',
    countdownEndsIn: 'Termina em',
    countdownEnded: 'Terminado',
    buyIn: 'Entrada',
    buyInAmount: '{amount} DIOS',
    gameweekPricing: 'Basic: Grátis | Plus: 5 | Rare: 10 | Epic: 25 | Unique: 50 DIOS',
    rarityLabel: 'Raridade',
    rarityBasic: 'Basic',
    inProgressClosed: 'Em curso - inscrições fechadas',
    joinGameweek: 'Juntar à GameWeek',
    joinFreeGameweek: 'Juntar à GameWeek gratuita',
    enterTournament: 'Entrar no torneio',
    joinFree: 'Entrar gratuitamente',
    prizePool: 'Prémio total',
    prize: 'Prémio'
  },
  notifications: {
    title: 'Notificações',
    markAllRead: 'Marcar tudo como lido',
    noNotifications: 'Sem notificações',
    ariaLabel: 'Notificações',
    justNow: 'Agora mesmo',
    minutesAgo: 'há {count}m',
    hoursAgo: 'há {count}h',
    daysAgo: 'há {count}d'
  },
  profile: {
    tabs: {
      myCards: 'As minhas cartas',
      soldLoans: 'Vendidas e empréstimos',
      activityReport: 'Relatório de atividade',
      offers: 'Ofertas',
      referrals: 'Referências',
      loginHistory: 'Histórico de login',
      security: 'Segurança',
      notifications: 'Notificações',
      settings: 'Definições'
    }
  },
  activityReport: {
    title: 'Relatório de atividade',
    last7Days: 'Últimos 7 dias',
    downloadCsv: 'Transferir CSV',
    loading: 'A carregar atividade...',
    empty: 'Sem atividade nos últimos 7 dias.',
    category: {
      deposit: 'Depósito',
      withdrawal: 'Levantamento',
      prize: 'Prémio',
      marketplace: 'Marketplace'
    },
    action: {
      deposit: 'Depósito',
      withdrawal: 'Levantamento',
      purchase: 'Compra',
      sale: 'Venda',
      loanBorrow: 'Empréstimo (receber)',
      loanLend: 'Empréstimo (emprestar)',
      gameweekPrize: 'Prémio Gameweek'
    }
  },
  cardsStatus: {
    cardsForSale: 'Cartas à venda',
    soldCards: 'Cartas vendidas',
    loanedCards: 'Empréstimos concedidos',
    borrowedCards: 'Cartas emprestadas',
    forSaleLabel: 'À venda',
    soldLabel: 'Vendida',
    loanedLabel: 'Emprestada',
    borrowedLabel: 'Emprestada',
    listedDate: 'Publicada',
    saleDate: 'Data de venda',
    startDate: 'Data de início',
    duration: 'Duração: {count} GW',
    emptyCardsForSale: 'Sem cartas à venda.',
    emptySold: 'Sem cartas vendidas.',
    emptyLoaned: 'Sem empréstimos concedidos.',
    emptyBorrowed: 'Sem cartas emprestadas ativas.',
    removeFromSale: 'Remover da venda',
    confirmRemoveFromSale: 'Remover esta carta da venda?',
    removeFromSaleFailed: 'Falha ao remover da venda'
  },
  loginHistory: {
    title: 'Histórico de login',
    total: 'Total: {count}',
    loading: 'A carregar histórico de login...',
    empty: 'Nenhum histórico de login encontrado',
    success: 'Sucesso',
    failed: 'Falhou',
    reason: 'Motivo',
    ip: 'IP',
    location: 'Local'
  },
  security: {
    titleSecurity: 'Relatórios de segurança',
    titleSupport: 'Tickets de suporte',
    total: 'Total: {count}',
    reportIssue: 'Reportar problema',
    createFirst: 'Criar o primeiro relatório',
    loadingSecurity: 'A carregar relatórios de segurança...',
    loadingSupport: 'A carregar tickets de suporte...',
    emptySecurity: 'Nenhum relatório de segurança encontrado',
    emptySupport: 'Nenhum ticket de suporte encontrado',
    sectionSecurity: 'Relatórios de segurança',
    sectionSupport: 'Tickets de suporte',
    created: 'Criado',
    resolved: 'Resolvido',
    adminNotes: 'Notas do admin',
    botReply: 'Resposta do bot',
    reportModalTitle: 'Reportar problema de segurança',
    reportType: 'Tipo de relatório',
    priority: 'Prioridade',
    title: 'Título',
    description: 'Descrição',
    titlePlaceholder: 'Descrição breve',
    descriptionPlaceholder: 'Descrição detalhada do problema de segurança',
    reportTypeOptions: {
      accountCompromise: 'Conta comprometida',
      suspiciousActivity: 'Atividade suspeita',
      phishing: 'Phishing',
      unauthorizedAccess: 'Acesso não autorizado',
      other: 'Outro'
    },
    priorityOptions: {
      low: 'Baixa',
      medium: 'Média',
      high: 'Alta',
      critical: 'Crítica'
    },
    openSupportTicket: 'Abrir ticket de suporte',
    supportTicketModalTitle: 'Novo ticket de suporte',
    supportSubject: 'Assunto (opcional)',
    supportSubjectPlaceholder: 'Resumo breve (opcional)',
    supportMessage: 'Mensagem',
    supportMessagePlaceholder: 'Descreva o seu pedido em detalhe.',
    submitSupportTicket: 'Enviar ticket',
    supportTicketError: 'Não foi possível abrir o ticket. Tente novamente.',
    submit: 'Enviar relatório',
    cancel: 'Cancelar'
  },
  notificationsTab: {
    maintenanceTitle: 'Alertas de manutenção',
    announcementsTitle: 'Anúncios do sistema',
    personalTitle: 'Notificações pessoais',
    unread: '{count} não lidas',
    markAllRead: 'Marcar tudo como lido',
    noMaintenance: 'Sem alertas de manutenção',
    noAnnouncements: 'Sem anúncios',
    noPersonal: 'Nenhuma notificação encontrada',
    clickToView: 'Clica para ver →',
    scheduled: 'Agendado',
    affects: 'Afeta'
  },
  gdpr: {
    bannerTitle: 'Privacidade e cookies',
    bannerDescription: 'Usamos cookies e tecnologias semelhantes para o site funcionar, melhorar a tua experiência e personalizar o conteúdo. Podes aceitar tudo, rejeitar cookies opcionais ou personalizar as tuas escolhas.',
    acceptAll: 'Aceitar tudo',
    rejectOptional: 'Rejeitar opcionais',
    customize: 'Personalizar',
    preferencesTitle: 'Preferências de cookies',
    preferencesIntro: 'Escolhe que categorias de cookies permitir. Os cookies necessários são obrigatórios para o site e não podem ser desativados.',
    necessary: 'Necessários',
    necessaryDesc: 'Essenciais para o funcionamento do site (ex. sessão, segurança).',
    analytics: 'Analíticos',
    analyticsDesc: 'Ajudam-nos a perceber como usas o site para o melhorar.',
    preferencesCat: 'Preferências',
    preferencesDesc: 'Guardam as tuas definições e preferências.',
    marketing: 'Marketing',
    marketingDesc: 'Usados para publicidade e marketing relevantes (se os usarmos).',
    alwaysOn: 'Sempre ativos',
    savePreferences: 'Guardar preferências',
    cookiePreferencesLink: 'Preferências de cookies'
  },
  legal: {
    platformOwner: 'The platform owner is Uilliam Dettori.'
  },
  settingsExtra: {
    walletAssociatedLabel: 'Wallet associada à tua conta:',
    walletConnectedLabel: 'Wallet atualmente ligada:',
    walletMismatchTitle: 'Wallet não corresponde',
    walletMismatchBody: 'A wallet ligada não corresponde à associada à tua conta. Liga a wallet correta para usar todas as funcionalidades.',
    walletConnected: 'Wallet ligada',
    walletSaveSuccess: 'Wallet associada com sucesso!',
    walletSaveError: 'Erro ao guardar a wallet: {message}',
    walletConnectError: 'Erro ao ligar a wallet: {message}',
    saveWallet: 'Associar esta wallet à tua conta',
    saveWalletConfirm: 'Sim, associar wallet',
    savingWallet: 'A guardar...',
    walletMobileHint: 'No telemóvel: quando o ecrã abrir, escolhe a app da wallet ou digitaliza o código QR.',
    walletConnectedReadyInfo: 'Podes usar esta wallet para depósitos e levantamentos. Não é preciso ligar novamente.',
    walletModalTitle: 'Wallet ligada',
    walletModalConnectedSuccess: 'Wallet ligada com sucesso:',
    walletModalQuestion: 'Queres associar esta wallet à tua conta? Assim poderás usá-la em transações futuras.',
    walletModalSkip: 'Não, ignorar'
  },
  supportWidget: {
    buttonOpen: 'Ajuda',
    title: 'Suporte',
    closeAria: 'Fechar',
    sendAria: 'Enviar',
    openTelegram: 'Abrir Telegram',
    loadingReply: 'A procurar uma resposta...',
    escalateAction: 'Abrir ticket de suporte',
    inputPlaceholder: 'Escreve aqui...',
    welcomeMessage: 'Posso ajudar com depósitos, levantamentos, marketplace, leilões, packs, torneios, referral ou conta. Se necessário, encaminho para um operador, ou podes contactar o suporte diretamente no Telegram.',
    fallbackNotUnderstood: 'Não percebi. Queres falar com um operador?',
    temporaryError: 'Erro temporário. Tenta novamente ou fala com um operador.',
    loginRequired: 'Para abrir um ticket de suporte tens de iniciar sessão.',
    writeRequestHint: 'Escreve o teu pedido abaixo e toca novamente em "Abrir ticket de suporte", ou envia primeiro uma mensagem ao bot.',
    escalatedTicket: 'Encaminhei o pedido para um operador. Ticket #{ticketId}',
    escalateFailed: 'Não consigo contactar um operador neste momento. Tenta novamente em breve.',
    quickHome: 'Início',
    quickMarketplace: 'Marketplace',
    quickTournaments: 'Torneios',
    quickRankings: 'Rankings',
    quickDeposit: 'Depósito',
    quickProfile: 'Perfil'
  },
  depositPage: {
    title: 'Depositar fundos',
    chooseMethod: 'Escolhe como depositar',
    methodBonifico: 'Transferência bancária (SEPA)',
    methodPostepay: 'Carregamento Postepay',
    bonificoTitle: 'Transferência bancária (SEPA)',
    bonificoLead: 'Faz uma transferência SEPA para o IBAN indicado. Na descrição, indica o teu ',
    usernameEmphasis: 'nome de utilizador DIOS',
    bonificoTail: ' para associarmos o pagamento. 1 EUR = 1 DIOS. O crédito não é automático: será verificado manualmente.',
    postepayTitle: 'Carregamento Postepay',
    postepayLead: 'Usa os dados abaixo para o carregamento. ',
    postepayCausaleLabel: 'Descrição:',
    postepayMid: ' indica o teu ',
    postepayTail: ' (o mesmo com que inicias sessão). O crédito não é automático: será verificado manualmente.',
    labelIban: 'IBAN',
    labelAccountHolder: 'Titular da conta',
    labelCardNumber: 'Número do cartão',
    labelExpiry: 'Validade',
    labelFiscalCode: 'Código fiscal (titular)',
    copyIban: 'Copiar IBAN',
    copy: 'Copiar',
    copyNumber: 'Copiar número',
    copyFiscalCode: 'Copiar código fiscal',
    copied: 'Copiado ✓',
    stripeUnavailableTitle: 'Indisponível de momento'
  },
  confirmD10S: {
    first: 'Vais gastar {amount} DIOS em: {action}. Continuar?',
    second: 'Confirma novamente para prosseguir.',
    actionDeposit: 'Depósito',
    actionWithdraw: 'Levantamento',
    actionListSale: 'Colocar à venda',
    actionListLoan: 'Colocar em empréstimo',
    firstListSale: 'Vais colocar esta carta à venda por {amount} DIOS. Continuar?',
    firstListLoan: 'Vais colocar esta carta em empréstimo (total {amount} DIOS). Continuar?',
    titleFirst: 'Confirmar operação',
    titleSecond: 'Confirmação final',
    confirmContinue: 'Continuar',
    confirmFinal: 'Sim, prosseguir'
  }
};

const tr = {
  common: {
    language: 'Dil',
    save: 'Ayarları kaydet',
    saving: 'Kaydediliyor...',
    continue: 'Devam',
    search: 'Ara',
    cancel: 'İptal',
    previous: 'Önceki',
    next: 'Sonraki',
    pageOf: 'Sayfa {page} / {total}',
    loading: 'Yükleniyor...',
    notAvailable: 'Yok',
    unknown: 'Bilinmiyor',
    processing: 'İşleniyor...'
  },
  onboarding: {
    chooseLanguageTitle: 'Dilini Seç',
    chooseLanguageSubtitle: 'Oyun için tercih ettiğin dili seç',
    savingLanguage: 'Kaydediliyor...'
  },
  navbar: {
    searchPlaceholder: 'Oyuncu adıyla ara...',
    searchAriaLabel: 'Ara',
    searching: 'Aranıyor...',
    noResults: 'Sonuç yok',
    totalCards: 'Toplam kart',
    company: 'Şirket',
    errorSearch: 'Arama hatası',
    signIn: 'Giriş Yap',
    register: 'Kayıt Ol',
    adminPanel: 'Admin Paneli',
    rules: 'Kurallar',
    musicMute: 'Arka plan müziğini kapat',
    musicUnmute: 'Arka plan müziğini aç'
  },
  rules: {
    mobileTitle: 'DIOS10 Kuralları',
    mobileDesc: 'Mobilde en iyi okuma deneyimi için PDF\'i tarayıcıda aç.',
    openPdf: 'PDF\'i tarayıcıda aç'
  },
  auth: {
    signIn: 'Giriş Yap',
    signingIn: 'Giriş yapılıyor...',
    email: 'E-posta',
    password: 'Şifre',
    forgotPassword: 'Şifremi unuttum?',
    noAccount: 'Hesabın yok mu?',
    registerNow: 'Şimdi kayıt ol',
    fillAllFields: 'Lütfen tüm alanları doldur',
    loginFailed: 'Giriş başarısız. Bilgilerini kontrol et.',
    emailVerified: 'E-posta doğrulandı. Artık giriş yapabilirsin.',
    emailVerifiedInvalid: 'Geçersiz veya süresi dolmuş doğrulama linki.',
    createAccount: 'Hesabını Oluştur',
    chooseUsername: 'Kullanıcı adını seç',
    username: 'Kullanıcı adı',
    confirmPassword: 'Şifreyi onayla',
    referralCode: 'Davet kodu (isteğe bağlı)',
    referralPlaceholder: 'Davet kodun varsa gir',
    confirmPasswordPlaceholder: 'Şifreni onayla',
    minimumCharacters: 'En az 6 karakter',
    creatingAccount: 'Hesap oluşturuluyor...',
    startJourney: 'Yolculuğuna başla',
    alreadyAccount: 'Zaten hesabın var mı?',
    terms: 'Kayıt olarak Hizmet Şartlarımızı kabul etmiş olursun',
    passwordMismatch: 'Şifreler eşleşmiyor',
    passwordShort: 'Şifre en az 6 karakter olmalı',
    registrationPending: 'Kayıt beklemede. E-posta doğrulama linki gönderdik. E-postanı doğrulayana kadar giriş yapamazsın.',
    registrationSuccess: 'Kayıt tamamlandı. Artık giriş yapabilirsin.',
    registrationFailed: 'Kayıt başarısız. Tekrar dene.',
    forgotTitle: 'Şifremi Unuttum?',
    forgotSubtitle: 'E-posta adresini gir, şifre sıfırlama linki göndereceğiz.',
    sendResetLink: 'Sıfırlama linki gönder',
    sending: 'Gönderiliyor...',
    resetToken: 'Sıfırlama kodu',
    setNewPassword: 'Yeni şifre belirle',
    newPassword: 'Yeni şifre',
    confirmNewPassword: 'Yeni şifreyi onayla',
    resetPassword: 'Şifreyi sıfırla',
    resetting: 'Sıfırlanıyor...',
    resetTokenRequired: 'Sıfırlama kodu gerekli',
    resetPasswordShort: 'Şifre en az 8 karakter olmalı',
    resetSuccess: 'Şifre başarıyla sıfırlandı! Girişe yönlendiriliyorsun...',
    resetFailed: 'Şifre sıfırlanamadı. Kod geçersiz veya süresi dolmuş olabilir.',
    requestResetSuccess: 'Bu e-posta varsa sıfırlama linki gönderildi.',
    requestResetToken: 'Sıfırlama linki gönderildi! Kod: {token} (Test için kopyala)',
    addToHomeTitle: 'Ana Ekrana Ekle',
    addToHomeMessage: 'Bu uygulama en iyi uygulama olarak çalışır. En iyi deneyim için telefona ana ekrana kaydet.',
    addToHomeButton: 'Ana Ekrana Kaydet',
    addToHomeDontShowAgain: 'Bu mesajı bir daha gösterme',
    addToHomeGotIt: 'Tamam',
    addToHomeStepsSafari: 'Safari: 1) Alttaki Paylaş butonuna dokun. 2) "Ana Ekrana Ekle"yi seç. 3) "Ekle"ye dokun.',
    addToHomeStepsChrome: 'Chrome: 1) Adres çubuğundaki Paylaş ikonuna dokun. 2) "Ana Ekrana Ekle"yi seç. 3) "Ekle"ye dokun.',
    addToHomeStepsFirefox: 'Firefox: 1) Adres çubuğundaki Paylaş ikonuna dokun. 2) "Ana Ekrana Ekle"yi seç. 3) "Ekle"ye dokun.',
    addToHomeStepsEdge: 'Edge: 1) Adres çubuğundaki Paylaş ikonuna dokun. 2) "Ana Ekrana Ekle"yi seç. 3) "Ekle"ye dokun.',
    addToHomeStepsSamsung: 'Samsung Internet: 1) Menüye (3 çizgi) dokun. 2) "Ana ekrana ekle"yi seç. 3) "Ekle"ye dokun.',
    addToHomeStepsOpera: 'Opera: 1) Menü ikonuna dokun. 2) "Ana Ekrana Ekle"yi seç. 3) "Ekle"ye dokun.',
    addToHomeStepsDefault: '1) Tarayıcıda Paylaş veya menü ikonuna dokun. 2) "Ana Ekrana Ekle" veya benzerini ara. 3) "Ekle"ye dokun.'
  },
  home: {
    marketplace: 'PAZAR',
    tournaments: 'TURNAVALAR',
    rankings: 'SIRALAMALAR',
    marketplaceDesc: 'Kart al ve sat',
    tournamentsDesc: 'GameWeek\'lerde yarış',
    rankingsDesc: 'Lider tabloları',
    activeGameweeks: 'AKTİF GAMEWEEK\'LER',
    tournamentsCount: '{count} Turnuva'
  },
  settings: {
    title: 'Ayarlar',
    walletConnection: 'Cüzdan Bağlantısı',
    walletConnected: 'Bağlı',
    connectWallet: 'Cüzdan Bağla',
    disconnectWallet: 'Bağlantıyı Kes',
    connecting: 'Bağlanıyor...',
    languageLabel: 'Dil',
    tutorialCompleted: 'Öğretici tamamlandı',
    soundsEnabled: 'Ses efektleri',
    soundsEnabledDesc: 'Butonlara tıklarken ve oyun sırasında ses çal',
    musicEnabled: 'Arka plan müziği',
    musicEnabledDesc: 'Girişten sonra arka plan müziği çal',
    musicVolume: 'Müzik sesi',
    musicVolumeMobile: 'Mobilde ses cihazınla kontrol edilir.',
    accountTitle: 'Hesap',
    logout: 'Çıkış Yap',
    saveSuccess: 'Ayarlar başarıyla kaydedildi.',
    saveFailed: 'Ayarlar kaydedilemedi.',
    passwordSectionTitle: 'Sifreyi sifirla',
    currentPassword: 'Mevcut sifre',
    currentPasswordPlaceholder: 'Mevcut sifreni gir',
    newPassword: 'Yeni sifre',
    newPasswordPlaceholder: 'Yeni sifreni gir',
    confirmNewPassword: 'Yeni sifreyi onayla',
    confirmNewPasswordPlaceholder: 'Yeni sifreni tekrar gir',
    changePassword: 'Sifre degisikligini onayla',
    changingPassword: 'Sifre guncelleniyor...',
    passwordFillAllFields: 'Lutfen tum sifre alanlarini doldur.',
    passwordMinLength: 'Yeni sifre en az 8 karakter olmali.',
    passwordMismatch: 'Yeni sifreler eslesmiyor.',
    passwordMustDiffer: 'Yeni sifre mevcut sifreden farkli olmali.',
    passwordChangeSuccess: 'Sifre basariyla guncellendi.',
    passwordChangeFailed: 'Sifre guncellenemedi.'
  },
  rankings: {
    title: 'Sıralamalar',
    gameweekSectionTitle: 'GameWeek Sıralamaları',
    gameweekSectionDesc: 'Her GameWeek turnuvası için resmi sıralama: sıra, final puanı ve ödül. Aşağıdan turnuva ve kategori seçin (Basic, Plus, Rare, Epic, Unique).',
    monthlySectionTitle: 'Aylık Sıralamalar',
    monthlySectionDesc: 'Platform tarafından yayınlanan resmi aylık sıralamalar: puan, dönemdeki GameWeek sonuçlarının toplamıdır (aynı kategori).',
    monthlySelectTitle: 'Aylık sıralama seç',
    monthlySelectPlaceholder: 'Aylık sıralama seç...',
    monthlyEmptyHint: 'Henüz aylık sıralama yayınlanmadı. Dönem sonunda platform tarafından yayınlanır.',
    monthlyEmptyTable: 'Bu aylık sıralama için veri yok',
    monthlyCategoryLabel: 'Kategori',
    monthlyCategoryGlobal: 'Genel',
    monthlyPrizePoolLabel: 'Ödül havuzu',
    selectTitle: 'GameWeek turnuvası seç',
    selectPlaceholder: 'GameWeek turnuvası seç...',
    emptyHint: 'GameWeek sıralaması yok. Puanlar hesaplandığında görünür.',
    loading: 'Sıralamalar yükleniyor...',
    typeLabel: 'Tür',
    tableRank: 'Sıra',
    tablePlayer: 'Oyuncu',
    tableScore: 'Puan',
    tablePrize: 'Ödül',
    emptyTable: 'Henüz sıralama yok',
    topRefTitle: 'Davet Lider Tablosu',
    topRefDesc: 'Davet edilen kullanıcılardan kazanç. Filtrelemek için dönem seç.',
    topRefPeriodLabel: 'Dönem',
    topRefColReferrals: 'Davet edilen kullanıcılar',
    topRefColEarnings: 'Kazanç (DIOS)',
    topRefEmpty: 'Bu dönemde henüz davetçi yok',
    topRefPeriodAll: 'Tüm zamanlar',
    topRefPeriodMonthly: 'Aylık',
    topRefPeriodSemestral: 'Bu dönem',
    topRefPeriodAnnual: 'Yıllık',
    topRefSelectMonth: 'Ay seç',
    topRefSelectYear: 'Yıl seç'
  },
  marketplace: {
    title: 'Pazar',
    balanceLabel: 'Bakiyen',
    tabsAuctions: 'Açık Artırmalar',
    tabsPacks: 'Paketler',
    tabsSales: 'Hemen Al',
    tabsLoans: 'Kiralar',
    tabsTrades: 'Kart Takası',
    filtersTitle: 'Ara ve Filtrele',
    resetFilters: 'Filtreleri sıfırla',
    auctionStatusOpen: 'Açık',
    auctionStatusClosed: 'Kapalı',
    auctionStatusClosedHint: 'Süresi dolmuş açık artırmalar işleniyor: süre doldu ama kart henüz atanmadı.',
    searchPlayerLabel: 'Oyuncu Ara',
    searchPlayerPlaceholder: 'Oyuncu adı gir...',
    rarityLabel: 'Nadirlik',
    allRarities: 'Tüm nadirlikler',
    rarityBasic: 'Basic',
    rarityPlus: 'Plus',
    rarityRare: 'Rare',
    rarityEpic: 'Epic',
    rarityUnique: 'Unique',
    positionLabel: 'Pozisyon',
    allPositions: 'Tüm pozisyonlar',
    positionGK: 'Kaleci',
    positionDEF: 'Defans',
    positionMID: 'Orta saha',
    positionATT: 'Forvet',
    nationalityLabel: 'Milliyet',
    nationalityPlaceholder: 'örn. İtalya',
    teamLabel: 'Takım',
    teamPlaceholder: 'örn. Real Madrid',
    leagueLabel: 'Lig',
    leaguePlaceholder: 'örn. Serie A',
    ageMinLabel: 'Min Yaş',
    ageMinPlaceholder: 'örn. 18',
    ageMaxLabel: 'Maks Yaş',
    ageMaxPlaceholder: 'örn. 35',
    xpMinLabel: 'Min XP',
    xpMinPlaceholder: 'örn. 5',
    xpMaxLabel: 'Maks XP',
    xpMaxPlaceholder: 'örn. 20',
    auctionsInfoTitle: 'Açık Artırma Bilgisi',
    auctionsInfoBody: 'Açık artırmalar her 10 dakikada finalize edilir. Kazanırsan kart ataması 10 dakika sürebilir.',
    secondaryMarketFilterNotice: 'Şu anda ikincil pazarda yalnızca Divinity ve Legend (Antrenör) kartları gösteriliyor.',
    bidSuccess: '✅ Teklif başarıyla verildi! Teklifin aktif.',
    purchaseSuccess: '✅ Kart başarıyla alındı! Koleksiyonunu kontrol et.',
    packSuccess: '✅ Paket açıldı! Yeni kartlar koleksiyona eklendi.',
    loanSuccess: '✅ Kiralama kabul edildi! Kart artık koleksiyonunda.',
    tradeAcceptSuccess: '✅ Takas kabul edildi! Kartlar değişti.',
    tradeRejectSuccess: '✅ Takas reddedildi',
    counterOfferSuccess: '✅ Karşı teklif gönderildi! Sahibi tekliflerde görecek.',
    emptyAuctionsTitle: 'Aktif Açık Artırma Yok',
    emptyAuctionsBody: 'Yeni fırsatlar için daha sonra kontrol et',
    emptySalesTitle: 'Kart Yok',
    emptySalesBody: 'Şu an satılık kart yok',
    emptyPacksTitle: 'Paket Yok',
    emptyPacksBody: 'Paketler yakında',
    emptyLoansTitle: 'Kiralama Yok',
    emptyLoansBody: 'Şu an kiralık kart yok',
    emptyTradesTitle: 'Açık Takas Yok',
    emptyTradesBody: 'Şu an açık takas yok. Kartlarından biri oluştur!'
  },
  marketplaceCards: {
    ended: 'Bitti',
    auctionBadge: 'Açık Artırma',
    viewCopiesAria: '{count} kopyayı gör',
    playerAlt: 'Oyuncu',
    positionLabel: 'Pozisyon',
    teamLabel: 'Takım',
    rarityLabel: 'Nadirlik',
    xpLevelLabel: 'XP Seviyesi',
    currentBidLabel: 'Güncel Teklif',
    currentWinnerLabel: 'Güncel Kazanan',
    minBidLabel: 'Minimum Teklif',
    bidAmountLabel: 'Teklifin',
    bidPlaceholder: 'Teklif gir (min: {amount} DIOS)',
    placingBid: 'Gönderiliyor...',
    auctionExtending: 'Süre güncelleniyor...',
    placeBid: 'Teklif Ver',
    quickBid: 'Hızlı Teklif',
    multipleCopiesHint: 'Birden fazla kopya var. Teklif için bir kopya seç.',
    viewCopiesBid: 'Kopyaları Gör ve Teklif Ver',
    loginToBid: 'Teklif vermek için giriş yap',
    bidMinError: 'Teklif en az {amount} DIOS olmalı',
    bidFailed: 'Teklif verilemedi',
    bidAuctionUpdated: 'Açık artırma güncellendi: yeni teklif ve değer. Minimum teklif şimdi {amount} DIOS. Yenile ve tekrar dene.',
    bidOfferMinButton: '{amount} D10S Teklif Ver',
    copiesLoadFailed: 'Kopyalar yüklenemedi',
    availableCopies: 'Mevcut Kopyalar ({count})',
    loadingCopies: 'Kopyalar yükleniyor...',
    noCopies: 'Mevcut kopya yok.',
    auctionNumber: 'Açık Artırma #{id}',
    none: '—',
    bidMin: 'Min Teklif',
    customBidPlaceholder: 'Özel (min {amount})',
    loginToPurchase: 'Satın almak için giriş yap',
    purchaseOwnCard: 'Kendi kartını alamazsın',
    purchaseFailed: 'Kart alınamadı',
    buyNowBadge: 'Hemen Al',
    bonusLabel: 'Bonus',
    bonusPosition: 'Rol bonusu',
    bonusLeague: 'Lig bonusu',
    bonusScore: 'Puan bonusu',
    priceLabel: 'Fiyat',
    processing: 'İşleniyor...',
    buyNowAction: 'Hemen Al',
    loginToOpenPack: 'Paket açmak için giriş yap',
    openPackFailed: 'Paket açılamadı',
    packDescriptionFallback: 'Bu pakette harika kartlar keşfet!',
    openingPack: 'Paket açılıyor...',
    openPack: 'Paket Aç',
    packQuantity: 'Miktar',
    packQuantityLabel: 'Alınacak paketler',
    openingOnePack: '1 paket açılıyor',
    openingPacksCount: '{count} paket açılıyor',
    nextPack: 'Sonraki paket',
    skipOpening: 'Atla',
    cardsAssignedSummary: '{count} kart koleksiyonuna eklendi.',
    viewInProfile: 'Profilde Gör',
    loginToAcceptLoan: 'Kiralama kabul etmek için giriş yap',
    acceptOwnLoan: 'Kendi kiralamını kabul edemezsin',
    acceptLoanFailed: 'Kiralama kabul edilemedi',
    loanBadge: 'Kiralama',
    pricePerGameweek: 'Gameweek başı fiyat',
    durationLabel: 'Süre',
    gameweeks: '{count} Gameweek',
    totalCost: 'Toplam maliyet',
    acceptLoan: 'Kiralamayı Kabul Et'
  },
  trade: {
    loginToAccept: 'Takas kabul etmek için giriş yap',
    noRequestedCardAvailable: 'Takas için istediğin kart mevcut değil',
    noRequestedCard: 'İstenen karta sahip değilsin',
    loadCardsFailed: 'Kartların yüklenemedi',
    acceptFailed: 'Takas kabul edilemedi',
    loginToReject: 'Takas reddetmek için giriş yap',
    rejectFailed: 'Takas reddedilemedi',
    loginToCounter: 'Karşı teklif vermek için giriş yap',
    noCardsForCounter: 'Karşı teklif için uygun kart yok',
    selectCardForCounter: 'Karşı teklif için bir kart seç',
    createCounterFailed: 'Karşı teklif oluşturulamadı',
    openTrade: 'Açık Takas',
    offerFrom: '{username} takas teklifi',
    byUser: 'Gönderen: {username}',
    expires: 'Bitiş: {date}',
    theyOffer: 'Onlar sunuyor',
    theyWant: 'Onlar istiyor',
    youGive: 'Sen veriyorsun',
    unknownPlayer: 'Bilinmeyen oyuncu',
    unknownRarity: 'Bilinmeyen nadirlik',
    accept: 'Takası Kabul Et',
    makeCounter: 'Karşı Teklif Yap',
    counterOffer: 'Karşı Teklif',
    reject: 'Reddet',
    ownerHint: 'Bu senin takas teklifin. Başkalarının kabul etmesini veya karşı teklif yapmasını bekle.',
    selectCardTitle: 'Takas İçin Kart Seç',
    youWillReceive: 'Alacaksın',
    youWillGive: 'Vereceksin',
    selectWhichCard: 'Takas için kartı seç:',
    makeCounterTitle: 'Karşı Teklif Yap',
    counterHint: 'İstenen karta sahip değilsin ama kendi kartlarından birini sunabilirsin.',
    selectCardToOffer: 'Sunulacak kartı seç:',
    selectCardPlaceholder: '-- Kart seç --',
    sendCounter: 'Karşı Teklif Gönder',
    sending: 'Gönderiliyor...',
    counterOfferTitle: 'Karşı Teklif',
    youWant: 'Sen istiyorsun',
    yourCard: 'Senin kartın',
    theirCard: 'Onların kartı',
    selectCardInstead: 'Bunun yerine sunulacak kartı seç:',
    creating: 'Oluşturuluyor...'
  },
  tournaments: {
    title: 'GameWeek\'ler ve Turnuvalar',
    create: 'Turnuva Oluştur',
    filterTitle: 'Türe Göre Filtrele',
    filterAll: 'Tümü',
    filterGameweek: 'GameWeek\'ler',
    filterPrivate: 'Özel',
    filterThematic: 'Tematik',
    loading: 'Turnuvalar yükleniyor...',
    emptyGameweeks: 'Şu an aktif GameWeek yok',
    emptyTournaments: 'Turnuva yok',
    statusInProgress: 'DEVAM EDİYOR',
    statusPendingPayment: 'ÖDEME BEKLEMEDE',
    statusClosed: 'KAPALI',
    statusUpcoming: 'YAKINDA',
    statusOpen: 'AÇIK',
    checkScores: 'Skorları Kontrol Et',
    viewGameweekScores: 'Gameweek skorlarını gör',
    viewTournamentScores: 'Turnuva skorlarını gör',
    availableTournaments: '{count} turnuva mevcut',
    participants: '{count} katılımcı',
    free: 'Ücretsiz',
    registered: 'Kayıtlı',
    editFormation: 'Formasyonu Düzenle',
    enter: 'Katıl',
    entriesClosed: 'GameWeek devam ediyor - kayıtlar kapalı',
    starts: 'Başlangıç',
    ends: 'Bitiş',
    countdownFormationLocksIn: 'Formasyon kilitlenmesine kalan',
    countdownFormationLocked: 'Formasyon kilitlendi',
    countdownStartsIn: 'Başlıyor',
    countdownEndsIn: 'Bitiyor',
    countdownEnded: 'Bitti',
    buyIn: 'Katılım ücreti',
    buyInAmount: '{amount} DIOS',
    gameweekPricing: 'Basic: Ücretsiz | Plus: 5 | Rare: 10 | Epic: 25 | Unique: 50 DIOS',
    rarityLabel: 'Nadirlik',
    rarityBasic: 'Basic',
    inProgressClosed: 'Devam ediyor - kayıtlar kapalı',
    joinGameweek: 'GameWeek\'e Katıl',
    joinFreeGameweek: 'Ücretsiz GameWeek\'e Katıl',
    enterTournament: 'Turnuvaya Katıl',
    joinFree: 'Ücretsiz Katıl',
    prizePool: 'Ödül havuzu',
    prize: 'Ödül'
  },
  notifications: {
    title: 'Bildirimler',
    markAllRead: 'Tümünü okundu işaretle',
    noNotifications: 'Bildirim yok',
    ariaLabel: 'Bildirimler',
    justNow: 'Şimdi',
    minutesAgo: '{count} dk önce',
    hoursAgo: '{count} sa önce',
    daysAgo: '{count} gün önce'
  },
  profile: {
    tabs: {
      myCards: 'Kartlarım',
      soldLoans: 'Satılanlar ve Kiralamalar',
      activityReport: 'Aktivite Raporu',
      offers: 'Teklifler',
      referrals: 'Davetler',
      loginHistory: 'Giriş geçmişi',
      security: 'Güvenlik',
      notifications: 'Bildirimler',
      settings: 'Ayarlar'
    }
  },
  activityReport: {
    title: 'Aktivite Raporu',
    last7Days: 'Son 7 gün',
    downloadCsv: 'CSV indir',
    loading: 'Aktivite yükleniyor...',
    empty: 'Son 7 günde aktivite yok.',
    category: {
      deposit: 'Yatırma',
      withdrawal: 'Çekim',
      prize: 'Ödül',
      marketplace: 'Pazar'
    },
    action: {
      deposit: 'Yatırma',
      withdrawal: 'Çekim',
      purchase: 'Satın alma',
      sale: 'Satış',
      loanBorrow: 'Kiralama (alan)',
      loanLend: 'Kiralama (veren)',
      gameweekPrize: 'Gameweek ödülü'
    }
  },
  cardsStatus: {
    cardsForSale: 'Satılık kartlar',
    soldCards: 'Satılan kartlar',
    loanedCards: 'Kiralanan kartlar',
    borrowedCards: 'Kiralanan kartlar',
    forSaleLabel: 'Satılık',
    soldLabel: 'Satıldı',
    loanedLabel: 'Kiralık',
    borrowedLabel: 'Kiralık',
    listedDate: 'Listeleme',
    saleDate: 'Satış tarihi',
    startDate: 'Başlangıç tarihi',
    duration: 'Süre: {count} GW',
    emptyCardsForSale: 'Satılık kart yok.',
    emptySold: 'Satılan kart yok.',
    emptyLoaned: 'Kiralanan kart yok.',
    emptyBorrowed: 'Aktif kiralık kart yok.',
    removeFromSale: 'Satıştan kaldır',
    confirmRemoveFromSale: 'Bu kartı satıştan kaldırmak istiyor musun?',
    removeFromSaleFailed: 'Satıştan kaldırılamadı'
  },
  loginHistory: {
    title: 'Giriş geçmişi',
    total: 'Toplam: {count}',
    loading: 'Giriş geçmişi yükleniyor...',
    empty: 'Giriş geçmişi bulunamadı',
    success: 'Başarılı',
    failed: 'Başarısız',
    reason: 'Sebep',
    ip: 'IP',
    location: 'Konum'
  },
  security: {
    titleSecurity: 'Güvenlik raporları',
    titleSupport: 'Destek talepleri',
    total: 'Toplam: {count}',
    reportIssue: 'Sorun bildir',
    createFirst: 'İlk raporu oluştur',
    loadingSecurity: 'Güvenlik raporları yükleniyor...',
    loadingSupport: 'Destek talepleri yükleniyor...',
    emptySecurity: 'Güvenlik raporu bulunamadı',
    emptySupport: 'Destek talebi bulunamadı',
    sectionSecurity: 'Güvenlik raporları',
    sectionSupport: 'Destek talepleri',
    created: 'Oluşturuldu',
    resolved: 'Çözüldü',
    adminNotes: 'Admin notları',
    botReply: 'Bot yanıtı',
    reportModalTitle: 'Güvenlik sorunu bildir',
    reportType: 'Rapor türü',
    priority: 'Öncelik',
    title: 'Başlık',
    description: 'Açıklama',
    titlePlaceholder: 'Kısa açıklama',
    descriptionPlaceholder: 'Güvenlik sorununun detaylı açıklaması',
    reportTypeOptions: {
      accountCompromise: 'Hesap ele geçirildi',
      suspiciousActivity: 'Şüpheli aktivite',
      phishing: 'Kimlik avı',
      unauthorizedAccess: 'Yetkisiz erişim',
      other: 'Diğer'
    },
    priorityOptions: {
      low: 'Düşük',
      medium: 'Orta',
      high: 'Yüksek',
      critical: 'Kritik'
    },
    openSupportTicket: 'Destek talebi aç',
    supportTicketModalTitle: 'Yeni destek talebi',
    supportSubject: 'Konu (isteğe bağlı)',
    supportSubjectPlaceholder: 'Kısa özet (isteğe bağlı)',
    supportMessage: 'Mesaj',
    supportMessagePlaceholder: 'Talebinizi ayrıntılı yazın.',
    submitSupportTicket: 'Talebi gönder',
    supportTicketError: 'Talep açılamadı. Lütfen tekrar deneyin.',
    submit: 'Rapor gönder',
    cancel: 'İptal'
  },
  notificationsTab: {
    maintenanceTitle: 'Bakım uyarıları',
    announcementsTitle: 'Sistem duyuruları',
    personalTitle: 'Kişisel bildirimler',
    unread: '{count} okunmamış',
    markAllRead: 'Tümünü okundu işaretle',
    noMaintenance: 'Bakım uyarısı yok',
    noAnnouncements: 'Duyuru yok',
    noPersonal: 'Bildirim bulunamadı',
    clickToView: 'Görüntülemek için tıkla →',
    scheduled: 'Planlandı',
    affects: 'Etkiler'
  },
  gdpr: {
    bannerTitle: 'Gizlilik ve çerezler',
    bannerDescription: 'Site çalışması, deneyim iyileştirme ve içerik kişiselleştirme için çerezler kullanıyoruz. Tümünü kabul edebilir, isteğe bağlı çerezleri reddedebilir veya seçimlerini özelleştirebilirsin.',
    acceptAll: 'Tümünü kabul et',
    rejectOptional: 'İsteğe bağlıları reddet',
    customize: 'Özelleştir',
    preferencesTitle: 'Çerez tercihleri',
    preferencesIntro: 'Hangi çerez kategorilerine izin verdiğini seç. Zorunlu çerezler site için gerekli ve devre dışı bırakılamaz.',
    necessary: 'Zorunlu',
    necessaryDesc: 'Site çalışması için gerekli (oturum, güvenlik vb.).',
    analytics: 'Analitik',
    analyticsDesc: 'Siteyi nasıl kullandığını anlamamıza yardımcı olur.',
    preferencesCat: 'Tercihler',
    preferencesDesc: 'Ayarlarını ve tercihlerini hatırlar.',
    marketing: 'Pazarlama',
    marketingDesc: 'İlgili reklamlar için (kullanıyorsak).',
    alwaysOn: 'Her zaman açık',
    savePreferences: 'Tercihleri kaydet',
    cookiePreferencesLink: 'Çerez tercihleri'
  },
  legal: {
    platformOwner: 'The platform owner is Uilliam Dettori.'
  },
  settingsExtra: {
    walletAssociatedLabel: 'Hesabına bağlı cüzdan:',
    walletConnectedLabel: 'Şu an bağlı cüzdan:',
    walletMismatchTitle: 'Cüzdan uyuşmazlığı',
    walletMismatchBody: 'Bağlı cüzdan hesabındakiyle eşleşmiyor. Tüm özellikler için doğru cüzdanı bağla.',
    walletConnected: 'Bağlı cüzdan',
    walletSaveSuccess: 'Cüzdan başarıyla bağlandı!',
    walletSaveError: 'Cüzdan kaydedilemedi: {message}',
    walletConnectError: 'Cüzdan bağlanamadı: {message}',
    saveWallet: 'Bu cüzdanı hesaba bağla',
    saveWalletConfirm: 'Evet, cüzdanı bağla',
    savingWallet: 'Kaydediliyor...',
    walletMobileHint: 'Mobilde: bağlantı ekranı açıldığında cüzdan uygulamanı seç veya QR kodunu tara.',
    walletConnectedReadyInfo: 'Bu cüzdanı yatırma ve çekme işlemlerinde kullanabilirsin. Yeniden bağlamana gerek yok.',
    walletModalTitle: 'Cüzdan bağlandı',
    walletModalConnectedSuccess: 'Cüzdan başarıyla bağlandı:',
    walletModalQuestion: 'Bu cüzdanı hesabına bağlamak istiyor musun? Böylece gelecekteki işlemlerde kullanabilirsin.',
    walletModalSkip: 'Hayır, geç'
  },
  supportWidget: {
    buttonOpen: 'Yardım',
    title: 'Destek',
    closeAria: 'Kapat',
    sendAria: 'Gönder',
    openTelegram: 'Telegram aç',
    loadingReply: 'Yanıt aranıyor...',
    escalateAction: 'Destek talebi aç',
    inputPlaceholder: 'Buraya yaz...',
    welcomeMessage: 'Yatırma, çekim, marketplace, açık artırma, paketler, turnuvalar, referral veya hesap konularında yardımcı olabilirim. Gerekirse bir operatöre iletebilirim ya da Telegram üzerinden doğrudan iletişime geçebilirsin.',
    fallbackNotUnderstood: 'Anlayamadım. Bir operatörle konuşmak ister misin?',
    temporaryError: 'Geçici hata. Tekrar dene veya bir operatörle konuş.',
    loginRequired: 'Destek talebi açmak için önce giriş yapmalısın.',
    writeRequestHint: 'Talebini aşağıya yazıp tekrar "Destek talebi aç" butonuna bas, ya da önce bota bir mesaj gönder.',
    escalatedTicket: 'Talebini bir operatöre ilettim. Ticket #{ticketId}',
    escalateFailed: 'Şu anda operatöre ulaşamıyorum. Lütfen biraz sonra tekrar dene.',
    quickHome: 'Ana Sayfa',
    quickMarketplace: 'Marketplace',
    quickTournaments: 'Turnuvalar',
    quickRankings: 'Sıralamalar',
    quickDeposit: 'Yatırma',
    quickProfile: 'Profil'
  },
  depositPage: {
    title: 'Para yatır',
    chooseMethod: 'Nasıl yatırmak istediğini seç',
    methodBonifico: 'Banka havalesi (SEPA)',
    methodPostepay: 'Postepay yükleme',
    bonificoTitle: 'Banka havalesi (SEPA)',
    bonificoLead: 'Belirtilen IBAN\'a SEPA havale yap. Açıklama kısmına ',
    usernameEmphasis: 'DIOS kullanıcı adını',
    bonificoTail: ' yaz ki ödemeyi eşleştirebilelim. 1 EUR = 1 DIOS. Bakiye otomatik yüklenmez; manuel kontrol edilir.',
    postepayTitle: 'Postepay yükleme',
    postepayLead: 'Yükleme için aşağıdaki bilgileri kullan. ',
    postepayCausaleLabel: 'Açıklama:',
    postepayMid: ' alanına ',
    postepayTail: ' yaz (girişte kullandığın ile aynı). Bakiye otomatik yüklenmez; manuel kontrol edilir.',
    labelIban: 'IBAN',
    labelAccountHolder: 'Hesap sahibi',
    labelCardNumber: 'Kart numarası',
    labelExpiry: 'Son kullanma',
    labelFiscalCode: 'Vergi numarası (hesap sahibi)',
    copyIban: 'IBAN kopyala',
    copy: 'Kopyala',
    copyNumber: 'Numarayı kopyala',
    copyFiscalCode: 'Vergi numarasını kopyala',
    copied: 'Kopyalandı ✓',
    stripeUnavailableTitle: 'Şu anda kullanılamıyor'
  },
  confirmD10S: {
    first: '{amount} DIOS harcayacaksın: {action}. Devam etmek istiyor musun?',
    second: 'Devam etmek için tekrar onayla.',
    actionDeposit: 'Yatırma',
    actionWithdraw: 'Çekim',
    actionListSale: 'Satışa listele',
    actionListLoan: 'Kiralamaya listele',
    firstListSale: 'Bu kartı {amount} DIOS\'a satışa listeliyorsun. Devam?',
    firstListLoan: 'Bu kartı kiralamaya listeliyorsun (toplam {amount} DIOS). Devam?',
    titleFirst: 'İşlemi onayla',
    titleSecond: 'Son onay',
    confirmContinue: 'Devam',
    confirmFinal: 'Evet, devam et'
  }
};

export const translations = {
  en,
  it,
  es,
  fr,
  de,
  pt,
  tr
};

